const messages = {
	en: {
		translations: {
			contactWhatsappStatus: {
				online: "online",
				typing: "typing...",
				recording: "recording audio...",
				lastSeen: "last seen {{when}}",
				todayAt: "today at {{time}}",
				yesterdayAt: "yesterday at {{time}}",
				dateAt: "on {{date}} at {{time}}",
				stories: {
					open: "View status",
					close: "Close",
					previous: "Previous status",
					next: "Next status",
					loadError: "This status could not be loaded.",
					retry: "Try again",
				},
			},
			ticketRatings: {
				title: "Service ratings",
				subtitle: "When a conversation is closed, the customer rates it from 0 to 10. Track the satisfaction of the company and of each agent here.",
				disabledNotice: {
					admin: "Ratings are turned off: no rating requests are being sent. Turn them on in the Settings tab.",
					user: "Ratings are turned off: no rating requests are being sent. Ask an administrator to turn them on.",
				},
				tabs: {
					overview: "Overview",
					responses: "Responses",
					settings: "Settings",
				},
				filters: {
					from: "Start date",
					to: "End date",
					user: "Agent",
					connection: "Connection",
					status: "Status",
					all: "All",
					submit: "Refresh",
				},
				status: {
					answered: "Answered",
					no_answer: "No reply",
					waiting: "Waiting",
				},
				cards: {
					nps: "NPS",
					average: "Average rating",
					averageHint: "on a 0 to {{max}} scale",
					responseRate: "Response rate",
					responseRateHint: "{{answered}} of {{sent}} customers replied",
					noAnswer: "No reply",
					waitingHint: "{{total}} still within the reply window",
					noAnswers: "No ratings in this period yet.",
				},
				zones: {
					critical: "Critical",
					improvement: "Improvement",
					quality: "Quality",
					excellence: "Excellence",
				},
				groups: {
					promoter: {
						name: "Promoter",
						label: "Promoters (9 and 10)",
						description: "Delighted customers who would recommend the company.",
					},
					passive: {
						name: "Passive",
						label: "Passives (7 and 8)",
						description: "Satisfied but unenthusiastic. They don't count toward the NPS.",
					},
					detractor: {
						name: "Detractor",
						label: "Detractors (0 to 6)",
						description: "Unhappy customers. Open the conversation to understand why.",
					},
				},
				howToRead: {
					title: "How to read the ratings",
					subtitle: "Each reply from 0 to {{max}} falls into one of three groups:",
					formula: "NPS = % promoters − % detractors. It ranges from −100 (everyone unhappy) to +100 (everyone delighted).",
				},
				npsBlock: {
					title: "NPS gauge",
					subtitle: "NPS {{nps}} — {{zone}} range, based on {{total}} replies.",
					split: "How the replies break down",
				},
				charts: {
					distributionTitle: "How often each rating appeared",
					distributionSubtitle: "Bars on the right (green) are delighted customers; on the left (red), unhappy ones.",
					rateAxis: "Rating",
					rateTooltip: "Rating {{rate}}",
					responses: "{{count}} reply",
					responses_plural: "{{count}} replies",
					average: "Average",
					timelineTitle: "Average rating per day",
					timelineSubtitle: "Days without replies have no point. Hover to see how many ratings came in that day.",
				},
				ranking: {
					title: "Performance by agent",
					subtitle: "Sorted by NPS. The bar shows each agent's mix of promoters, passives and detractors.",
					sent: "Requests",
					answered: "Answered",
					split: "Breakdown",
				},
				table: {
					user: "Agent",
					sentAt: "Sent at",
					contact: "Contact",
					connection: "Connection",
					rating: "Rating",
					answeredAt: "Answered at",
					ticket: "Ticket",
					empty: "No ratings in this period.",
				},
				responses: {
					title: "All responses",
					subtitle: "Every request sent in the period. \"No reply\": the customer didn't reply with a number within the reply window.",
				},
				settings: {
					title: "Question sent to the customer",
					enabled: "Send the rating question when a conversation is closed",
					message: "Rating question",
					messageHelp: "Ask the customer to reply with a number from {{min}} to {{max}}. Use {{firstName}} or {{name}} for the contact's name.",
					thanksMessage: "Thank-you message",
					thanksMessageHelp: "Sent after the customer replies with the rating. Leave blank to send nothing.",
					windowHours: "Reply window (hours)",
					windowHoursHelp: "From 1 to 168 hours. After that the request shows as \"No reply\".",
					save: "Save",
					saving: "Saving...",
					saved: "Rating settings saved.",
					howItWorks: "How it works",
					steps: {
						close: "The agent closes the conversation on WhatsApp (QR or official API) and the customer receives the question asking for a rating from {{min}} to {{max}}.",
						reply: "If they reply with just the number within {{hours}} h, the rating is saved for the agent and they receive the thank-you message.",
						noReply: "If they don't reply, or write something else, nothing is saved: the conversation shows as \"No reply\" and continues normally.",
					},
					preview: "WhatsApp preview",
				},
				dashboardColumn: {
					title: "Average rating (0 to 10)",
					hint: "Average of the 0 to 10 ratings received in the period. Details on the Ratings screen.",
					count: "({{total}})",
				},
			},
			connectionLogs: {
				title: "Connection logs — {{name}}",
				subtitle: "Audit of session events recorded by the server (visible to support only)",
				currentState: "Current state:",
				chips: {
					database: "database: {{value}}",
					memory: "memory: {{value}}",
					reconnections: "reconnections: {{value}}",
					code: "code: {{value}}",
				},
				timeline: "last reconnection: {{lastReconnect}} | next attempt: {{nextRetry}} | last health check: {{lastHealthCheck}}",
				scheduler: "reconnection scheduler (global): queue {{queued}} | snapshot at {{generatedAt}}",
				hideQr: "Hide QR Code events",
				totalEvents: "{{count}} event in total",
				totalEvents_plural: "{{count}} events in total",
				empty: "No events recorded for this connection.",
				user: "user: {{name}}",
				reload: "Reload",
			},
			contactChat: {
				otherUsers: {
					intro: "This contact has {{count}} open ticket(s) with other attendants:",
					noQueue: "No queue",
					attendant: "Attendant",
					assumeThis: "Take over this ticket",
					assume: "Take over ticket",
					anotherAttendant: "another attendant",
					belongsTo: "This ticket belongs to another attendant ({{name}}).",
					dialogTitle: "Existing tickets for this contact",
					dialogIntro: "This contact has open ticket(s) with other attendant(s). Take over a ticket to continue the service.",
					dialogIntroWithNew: "This contact has an open ticket with another attendant. Take over the ticket or open a new one of your own to send the message.",
					createNew: "Open new ticket",
				},
				agent: {
					typing: "Agent \"{{name}}\" is typing...",
					handling: "This ticket is being handled by an AI agent ({{name}}).",
					fallbackName: "Agent #{{id}}",
				},
				connection: "Connection: {{name}}",
				autoConnection: "Automatic connection (system default)",
				errors: {
					connectionNotAssigned: "This ticket belongs to a connection that is not assigned to your user.",
					conversationConnectionNotAssigned: "This conversation belongs to a connection that is not assigned to your user.",
					noQueueAccess: "You do not have access to this ticket's queue",
					noQueuelessPermission: "You do not have permission to take over tickets without a queue (allTicket disabled).",
				},
				toasts: {
					ticketAssumed: "Ticket taken over successfully!",
				},
				connectionTooltip: "Connection: {{name}} — click to change",
				chooseConnectionTooltip: "Click to choose the connection",
				selectConnection: "Select connection",
				callConnectionTitle: "Call through which connection?",
				thisConnection: "this connection",
				groupElsewhere: "Group being handled on connection {{connection}} (#{{id}}) — sending through {{target}} will move the ticket.",
				history: {
					viewAll: "View all messages",
					selectTicket: "Select a ticket",
					ticketOption: "Ticket #{{id}} • {{status}}",
					status: {
						open: "In progress",
						pending: "Waiting",
						closed: "Resolved",
					},
				},
				templatePicker: {
					title: "Send Message Template",
					description: "Official API connection (Cloud API). Send an approved message template to start the conversation.",
					noTemplates: "No approved message templates found. Create templates and submit them for approval on the Templates page.",
					selectTemplate: "Select a template",
					preview: "Preview:",
					emptyBody: "(No body text)",
					variables: "Variables:",
					variable: "Variable",
					send: "Send",
					sending: "Sending...",
					sent: "Template sent successfully!",
				},
			},
			tagsContainer: {
				placeholder: "Ticket tags",
			},
			connectionDisconnectedBanner: {
				message: "The connection \"{{name}}\" of this ticket is disconnected. Replies will not be sent until it reconnects or the ticket is transferred to another connection.",
			},
			sentMessageOrigin: {
				labels: {
					campaign: "Campaign",
					schedule: "Schedule",
					external: "External send",
				},
				noTicket: {
					campaign: "Campaign message sent on {{date}} (no ticket)",
					schedule: "Scheduled message sent on {{date}} (no ticket)",
					external: "External send on {{date}} (no ticket)",
				},
			},
			messagePreview: {
				received: "Received",
				image: "Image",
				video: "Video",
				audio: "Audio",
				file: "File",
				sticker: "Sticker",
				location: "Location",
				contacts: "Several contacts",
				contactSent: "Contact sent: {{name}}",
				catalogProduct: "🛍️ Catalog product",
				orderReceived: "🛒 Order received",
				externalMessage: "Message sent externally",
				reaction: "Reaction",
				deleted: "Deleted message",
				withoutContent: "Message without content",
				noMessages: "No messages",
			},
			sessionStatusIndicator: {
				extended: "Extended session",
				minutes: "{{minutes}}min",
				expiresIn: "Session expires in {{minutes}} minutes",
				noExpiry: "Sessions are set not to expire automatically",
			},
			plans: {
				form: {
					name: "Name",
					users: "Users",
					connections: "Connections",
					campaigns: "Campaigns",
					schedules: "Schedules",
					enabled: "Enabled",
					disabled: "Disabled",
					clear: "Cancel",
					delete: "Delete",
					save: "Save",
					yes: "Yes",
					no: "No",
					money: "R$",
					queues: "Queues",
					value: "Price",
					internalChat: "Internal Chat",
					externalApi: "External API",
					integrations: "Integrations",
					whatsappQr: "WhatsApp via QR Code",
				},
				newPlan: "New Plan",
				restricted: {
					message: "Only the main administrator user can manage plans.",
				},
				toasts: {
					saveError: "Could not complete the operation. Check whether a plan with the same name already exists or whether the fields were filled in correctly",
				},
			},
			companies: {
				title: "Register Company",
				form: {
					name: "Company name",
					plan: "Plan",
					token: "Token",
					submit: "Register",
					success: "Company created successfully!",
				},
			},
			queueIntegrationModal: {
				title: {
					add: "Add project",
					edit: "Edit project",
				},
				form: {
					id: "ID",
					type: "Type",
					name: "Name",
					projectName: "Project name",
					language: "Language",
					jsonContent: "JsonContent",
					urlN8N: "URL",
					typebotSlug: "Typebot - Slug",
					typebotExpires: "Minutes until a conversation expires",
					typebotKeywordFinish: "Keyword to close the ticket",
					typebotKeywordRestart: "Keyword to restart the flow",
					typebotRestartMessage: "Message when restarting the conversation",
					typebotUnknownMessage: "Invalid option message",
					typebotDelayMessage: "Interval (ms) between messages",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
					test: "Test bot",
				},
				messages: {
					testSuccess: "Integration tested successfully!",
					addSuccess: "Integration added successfully.",
					editSuccess: "Integration updated successfully.",
				},
				languages: {
					ptBR: "Portuguese",
					en: "English",
					es: "Spanish",
				},
			},
			sideMenu: {
				name: "Initial side menu",
				note: "If enabled, the side menu starts collapsed",
				options: {
					enabled: "Open",
					disabled: "Closed",
				},
			},
			deleteAccountModal: {
				title: "Delete my account",
				intro: "This action is permanent. Here is what happens when you delete your account:",
				userScope: {
					access: "Your access to the system will end immediately.",
					tickets: "Your open tickets will go back to the queue.",
				},
				companyScope: {
					intro: "You are the only administrator: the company account will be closed as well.",
					company: "The company {{companyName}} will be deactivated.",
					users: "{{total}} other user(s) will lose access.",
					connections: "{{total}} WhatsApp connection(s) will be disconnected.",
					subscription: "The recurring subscription will be cancelled.",
					history: "The ticket history is kept anonymized; the e-mail, company name and CNPJ are released for a new registration.",
				},
				passwordLabel: "Confirm your password",
				acknowledge: "I understand this action cannot be undone.",
				buttons: {
					cancel: "Cancel",
					confirm: "Delete my account",
				},
				toasts: {
					success: "Account deleted successfully.",
				},
				loginBanner: "Your account was deleted successfully.",
			},
			internalChat: {
				actions: {
					reply: "Reply",
					copy: "Copy",
				},
				reply: {
					you: "You",
					cancel: "Cancel reply",
				},
				search: {
					open: "Search messages",
					title: "Search messages",
					placeholder: "Search",
					prompt: "Search messages in this conversation.",
					close: "Close search",
					loadMore: "Load more",
					noResults: "No messages found.",
				},
				copy: {
					success: "Message copied successfully.",
					error: "Could not copy the message.",
					empty: "There is nothing to copy in this message.",
				},
				jump: {
					notFound: "Could not open this message.",
					tooOld: "This message is too old to be opened here.",
				},
				list: {
					title: "Conversations",
					new: "New",
					empty: "No conversations yet. Click \"New\" to get started.",
				},
				tabs: {
					chats: "Conversations",
					messages: "Messages",
				},
				modal: {
					title: "Conversation",
					titleField: "Title",
					titleRequired: "Please fill in the conversation title.",
					usersRequired: "Please select at least one user.",
				},
				messages: {
					empty: "No messages in this conversation yet.",
					inputPlaceholder: "Write a message",
				},
				header: {
					edit: "Edit conversation",
					delete: "Delete conversation",
				},
				deleteConfirm: {
					title: "Delete Conversation",
					message: "This action cannot be undone. Confirm?",
				},
			},
			uploads: {
				titles: {
					titleUploadMsgDragDrop: "DRAG AND DROP FILES INTO THE FIELD BELOW",
					titleFileList: "File list",
				},
			},
			queueIntegration: {
				title: "Integrations",
				table: {
					id: "ID",
					type: "Type",
					name: "Name",
					projectName: "Project name",
					language: "Language",
					lastUpdate: "Last update",
					actions: "Actions",
				},
				buttons: {
					add: "Add project",
				},
				searchPlaceholder: "Search...",
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? This action cannot be undone, and it will be removed from the linked queues and connections",
				},
				toasts: {
					deleted: "Integration deleted successfully.",
				},
			},
			files: {
				title: "File lists",
				table: {
					name: "Name",
					contacts: "Contacts",
					actions: "Action",
				},
				toasts: {
					deleted: "List deleted successfully!",
					deletedAll: "All lists deleted successfully!",
				},
				buttons: {
					add: "Add",
					deleteAll: "Delete all",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteAllTitle: "Delete all",
					deleteMessage: "Are you sure you want to delete this list?",
					deleteAllMessage: "Are you sure you want to delete all lists?",
				},
			},
			messagesAPI: {
				title: "API",
				textMessage: {
					number: "Number",
					body: "Message",
					token: "Registered token",
				},
				mediaMessage: {
					number: "Number",
					body: "File name",
					media: "File",
					token: "Registered token",
				},
				showHideToken: "Show/hide token",
				buttons: {
					send: "Send",
				},
				toasts: {
					sent: "Message sent successfully",
				},
				doc: {
					title: "Documentation for sending messages",
					methods: "Sending methods",
					textMessages: "Text messages",
					mediaMessages: "Media messages",
					instructions: "Instructions",
					importantNotes: "Important notes",
					tokenNote: "Before sending messages, you must register the token linked to the connection that will send them.",
					tokenNoteHowTo: "To register it, open the \"{{menu}}\" menu, click the connection's edit button and enter the token in the corresponding field.",
					numberFormat: "The destination number must not contain a mask or special characters and must consist of:",
					countryCode: "Country code",
					areaCode: "Area code",
					textInfo: "Below is the information required to send text messages:",
					mediaInfo: "Below is the information required to send media messages:",
					method: "Method",
					headers: "Authorization (Bearer token) and Content-Type ({{contentType}})",
					fileValue: "file",
					sendTest: "Send test",
				},
			},
			documentTemplates: {
				title: "Document Templates",
				searchPlaceholder: "Search...",
				table: {
					name: "Name",
					description: "Description",
					active: "Active",
					actions: "Actions",
				},
				buttons: {
					add: "New template",
					save: "Save",
					cancel: "Cancel",
					insertVariable: "Insert variable",
					pageConfig: "Page settings",
					send: "Generate and send",
				},
				toasts: {
					saved: "Template saved successfully!",
					deleted: "Template deleted successfully!",
					sent: "Document sent successfully!",
				},
				confirmationModal: {
					deleteTitle: "Delete template",
					deleteMessage: "This action is irreversible! Do you want to continue?",
				},
				editor: {
					name: "Template name",
					description: "Description",
					active: "Active",
					fontFamily: "Font",
					fontSize: "Size",
					paperSize: "Paper",
					margins: "Margins (cm)",
					marginTop: "Top",
					marginBottom: "Bottom",
					marginLeft: "Left",
					marginRight: "Right",
					variableGroups: {
						system: "System",
						contact: "Contact",
						cliente: "Customer",
						clienteCustom: "Custom fields",
					},
				},
				sendModal: {
					title: "Send document",
					selectTemplate: "Document template",
					missingFields: "Fill in the missing information",
					resolvedFields: "Data filled in automatically",
					noClienteLinked: "This contact has no linked customer — customer fields must be filled in manually.",
					caption: "Message (optional)",
					preview: "Preview",
					previewTitle: "Document preview",
					send: "Generate and send",
					cancel: "Cancel",
				},
				toolbar: {
					bold: "Bold",
					italic: "Italic",
					underline: "Underline",
					alignLeft: "Align left",
					alignCenter: "Center",
					alignRight: "Align right",
					justify: "Justify",
					bulletList: "Bulleted list",
					orderedList: "Numbered list",
					insertTable: "Insert table",
					removeTable: "Remove table",
				},
			},
			quickMessages: {
				title: "Quick Replies",
				searchPlaceholder: "Search...",
				noAttachment: "No attachment",
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action is irreversible! Do you want to continue?",
				},
				buttons: {
					add: "Add",
					attach: "Attach file(s)",
					cancel: "Cancel",
					edit: "Edit",
				},
				toasts: {
					success: "Shortcut added successfully!",
					deleted: "Shortcut removed successfully!",
				},
				attachments: {
					title: "Attachments",
					maxReached: "Limit of {{max}} attachments per quick reply reached.",
					rejected: "File(s) not allowed: {{files}}",
					notFound: "Attachment(s) of this quick reply were not found on the server.",
					deleteAllMessage: "The attachment of this quick reply will be removed. Do you want to continue?",
				},
				dialog: {
					title: "Quick Reply",
					shortcode: "Shortcut",
					message: "Reply",
					save: "Save",
					cancel: "Cancel",
					geral: "Allow editing",
					add: "Add",
					edit: "Edit",
					visao: "Allow viewing",
					mediaAlt: "Message media",
				},
				modal: {
					title: "Quick Replies",
					search: "Search quick replies...",
					empty: "No quick replies registered",
					noResults: "No messages found",
					viewMessage: "View message",
					close: "Close",
					useMessage: "Use message",
					hasMedia: "Media",
				},
				table: {
					shortcode: "Shortcut",
					message: "Message",
					actions: "Actions",
					mediaName: "File name",
					filesSuffix: "files",
					status: "Status",
				},
			},
			messageVariablesPicker: {
				label: "Available variables",
				vars: {
					contactFirstName: "First name",
					contactName: "Name",
					greeting: "Greeting",
					protocolNumber: "Protocol",
					date: "Date",
					hour: "Time",
				},
			},
			contactLists: {
				title: "Contact Lists",
				table: {
					name: "Name",
					contacts: "Contacts",
					actions: "Actions",
				},
				buttons: {
					add: "New list",
					downloadSample: "Download sample spreadsheet",
				},
				dialog: {
					name: "Name",
					company: "Company",
					okEdit: "Edit",
					okAdd: "Add",
					add: "Add",
					edit: "Edit",
					cancel: "Cancel",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
				},
				toasts: {
					saved: "List saved successfully.",
					deleted: "Record deleted",
				},
				searchPlaceholder: "Search by ID or name",
				pagination: {
					rowsPerPage: "Items per page",
					displayedRows: "{{from}}-{{to}} of {{total}}",
				},
			},
			campaigns: {
				title: "Campaigns",
				searchPlaceholder: "Search",
				buttons: {
					add: "New campaign",
					contactLists: "Contact lists",
				},
				table: {
					name: "Name",
					whatsapp: "Connection",
					contactList: "Contact list",
					status: "Status",
					scheduledAt: "Scheduled",
					completedAt: "Completed",
					confirmation: "Confirmation",
					actions: "Actions",
					noContactList: "Not set",
					noWhatsapp: "Not set",
					notScheduled: "Not scheduled",
					notCompleted: "Not completed",
					confirmationEnabled: "Enabled",
					confirmationDisabled: "Disabled",
				},
				dialog: {
					new: "New campaign",
					update: "Edit campaign",
					readonly: "View only",
					form: {
						name: "Name",
						message1: "Message 1",
						message2: "Message 2",
						message3: "Message 3",
						message4: "Message 4",
						message5: "Message 5",
						confirmationMessage1: "Confirmation message 1",
						confirmationMessage2: "Confirmation message 2",
						confirmationMessage3: "Confirmation message 3",
						confirmationMessage4: "Confirmation message 4",
						confirmationMessage5: "Confirmation message 5",
						messagePlaceholder: "Message content",
						whatsapp: "Connection",
						status: "Status",
						scheduledAt: "Schedule",
						confirmation: "Confirmation",
						contactList: "Contact list",
						tagList: "Tag list",
						fileList: "File list",
						none: "None",
						whatsappConnection: "WhatsApp connection",
						responseQueue: "Campaign reply queue",
						responseQueueHelper: "If you select a queue, the reply window in minutes becomes required.",
						responseWindow: "Reply window (minutes)",
						responseWindowHelper: "Required. Routes to the queue if the contact replies within this window.",
						responseWindowDisabledHelper: "Select a queue to enable this field.",
						dispatchType: "Campaign start",
						dispatchImmediate: "Start immediately",
						dispatchScheduled: "Schedule for a date/time",
					},
					buttons: {
						add: "Add",
						edit: "Update",
						okadd: "Ok",
						cancel: "Cancel sending",
						restart: "Restart sending",
						close: "Close",
						attach: "Attach file",
					},
					validation: {
						integerMinutes: "Use a whole number of minutes",
						minWindow: "The minimum window is 1 minute",
						maxWindow: "The maximum window is 10080 minutes (7 days)",
						queueAndWindow: "Select the queue and the window to enable routing",
						windowRequired: "Enter the window in minutes",
						responseQueueRequired: "Select a reply queue",
					},
					toasts: {
						missingVariables: "Fill in all template variables before saving:",
						smsMessageRequired: "Write the text message for the SMS campaign.",
						smsBaratoTooLong: "The message has {{length}} characters after conversion to the SMS Barato format — the provider's limit is {{max}}.",
						templateRequired: "Select a template for the campaign.",
						scheduledAtRequired: "Fill in the scheduled date/time.",
						responseWindowRequired: "Enter the reply window in minutes (minimum 1) for the selected queue.",
					},
					sms: {
						sectionTitle: "MESSAGE - For SMS",
						messageLabel: "SMS message *",
						messagePlaceholder: "Text that will be sent. Use {{variable}} to personalize it.",
						helperSmsBarato: "{{length}}/{{max}} characters · SMS Barato sends 1 SMS per message, without accents or line breaks",
						helperSegments: "{{length}} characters · {{encoding}} · {{segments}} billed segment(s) · {{perSegment}} characters per segment",
						overLimit: "The message exceeds SMS Barato's {{max}}-character limit — shorten the text to save the campaign.",
						willBeSentAs: "Will be sent as:",
						ucs2Warning: "The message contains characters outside the GSM-7 standard (emojis, symbols and — on Witi.me — accents). This lowers the limit from 160 to 70 characters per segment and makes sending more expensive.",
					},
					template: {
						sectionTitle: "TEMPLATE - For Cloud API",
						label: "Template",
						selectConnection: "Select a Cloud API connection to load the templates.",
						selected: "Selected template:",
						category: "Category:",
						language: "Language:",
						text: "Text:",
					},
					variables: {
						title: "Template Variable Settings",
						description: "Set how each template variable will be filled in with contact data or fixed values.",
						variable: "Variable",
						buttonUrlRequired: "{{component}} - URL button (required)",
						buttonType: "{{type}} button",
						contactData: "Contact data",
						fixedValue: "Fixed value",
						contactField: "Contact field",
						fixedValuePlaceholder: "Enter the value that will be used for all contacts",
					},
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
				},
				toasts: {
					success: "Operation completed successfully",
					cancel: "Campaign cancelled",
					restart: "Campaign restarted",
					deleted: "Record deleted",
				},
				statuses: {
					inactive: "Inactive",
					scheduled: "Scheduled",
					inProgress: "In progress",
					canceled: "Canceled",
					finished: "Finished",
				},
				actions: {
					stop: "Stop campaign",
					start: "Start campaign",
					startNow: "Start now",
					viewReport: "View report",
				},
				pagination: {
					rowsPerPage: "Items per page",
					displayedRows: "{{from}}-{{to}} of {{total}}",
					moreThan: "more than {{value}}",
				},
			},
			announcements: {
				active: "Active",
				inactive: "Inactive",
				title: "Announcements",
				searchPlaceholder: "Search",
				buttons: {
					add: "New announcement",
					contactLists: "Announcement lists",
				},
				table: {
					priority: "Priority",
					title: "Title",
					text: "Text",
					mediaName: "File",
					status: "Status",
					actions: "Actions",
				},
				dialog: {
					edit: "Edit announcement",
					add: "New announcement",
					update: "Edit announcement",
					readonly: "View only",
					form: {
						priority: "Priority",
						title: "Title",
						text: "Text",
						mediaPath: "File",
						status: "Status",
					},
					buttons: {
						add: "Add",
						edit: "Update",
						okadd: "Ok",
						cancel: "Cancel",
						close: "Close",
						attach: "Attach file",
					},
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
				},
				toasts: {
					success: "Operation completed successfully",
					deleted: "Record deleted",
				},
			},
			campaignsConfig: {
				title: "Campaign settings",
				toasts: {
					saved: "Settings saved",
				},
				intervals: {
					title: "Intervals",
					baileysOnly: "Randomized sending intervals apply only to Baileys connections.",
					messageInterval: "Random sending interval",
					longerIntervalAfter: "Longer interval after",
					greaterInterval: "Longer sending interval",
					noInterval: "No interval",
					notDefined: "Not set",
					seconds: "{{count}} second",
					seconds_plural: "{{count}} seconds",
				},
				buttons: {
					addVariable: "Add variable",
					saveSettings: "Save settings",
				},
				variables: {
					shortcut: "Shortcut",
					content: "Content",
				},
			},
			helps: {
				title: "Help Center",
				form: {
					title: "Title",
					video: "Video code",
				},
				table: {
					video: "Video",
				},
				toasts: {
					saveError: "Could not complete the operation. Check whether a help item with the same title already exists or whether the fields were filled in correctly",
				},
			},
			schedules: {
				title: "Schedules",
				confirmationModal: {
					deleteTitle: "Are you sure you want to delete this schedule?",
					deleteMessage: "This action cannot be undone.",
				},
				table: {
					contact: "Contact",
					body: "Message",
					sendAt: "Scheduled date",
					sentAt: "Sent date",
					status: "Status",
					actions: "Actions",
				},
				buttons: {
					add: "New schedule",
				},
				toasts: {
					deleted: "Schedule deleted successfully.",
				},
				calendar: {
					yesterday: "Yesterday",
					tomorrow: "Tomorrow",
					noEventsInRange: "No schedules in this period.",
					showMore: "+{{total}} more",
					eventFallback: "Schedule",
				},
			},
			tags: {
				title: "Tags",
				confirmationModal: {
					deleteTitle: "Are you sure you want to delete this tag?",
					deleteMessage: "This action cannot be undone.",
					deleteAllMessage: "Are you sure you want to delete all tags?",
					deleteAllTitle: "Delete all",
				},
				table: {
					name: "Name",
					color: "Color",
					tickets: "Tagged records",
					contacts: "Contacts",
					actions: "Actions",
				},
				buttons: {
					add: "New tag",
					deleteAll: "Delete all",
					viewContacts: "View contacts with this tag",
				},
				toasts: {
					deletedAll: "All tags deleted successfully!",
					deleted: "Tag deleted successfully.",
				},
			},
			tagContactsModal: {
				title: "Contacts with tag",
				count: "{{count}} contact(s)",
				search: "Search by name, number or client CNPJ...",
				empty: "No contacts with this tag.",
				minChars: "Type at least {{count}} characters to search.",
				close: "Close",
			},
			fileModal: {
				title: {
					add: "Add file list",
					edit: "Edit file list",
				},
				buttons: {
					okAdd: "Save",
					okEdit: "Edit",
					cancel: "Cancel",
					fileOptions: "Add file",
				},
				form: {
					name: "File list name",
					message: "List details",
					fileOptions: "File list",
					extraName: "Message to send with the file",
					extraValue: "Option value",
				},
				success: "File list saved successfully!",
				validation: {
					nameTooShort: "Name too short",
				},
			},
			languages: {
				pt: "Português",
				en: "English",
				es: "Español",
			},
			forgetPassword: {
				title: "Reset password",
				toasts: {
					emailSent: "Email sent successfully!",
					passwordReset: "Password reset successfully.",
					emailNotFound: "Email not found",
				},
				buttons: {
					signup: "Don't have an account? Sign up!",
					resetPassword: "Reset password",
					sendEmail: "Send email",
				},
				form: {
					verificationCode: "Verification code",
					newPassword: "New password",
					confirmPassword: "Confirm password",
				},
				validation: {
					passwordRule: "Your password must be at least 8 characters long and include an uppercase letter, a lowercase letter and a number.",
				},
			},
			kanban: {
				lanes: {
					open: "Open",
				},
			},
			common: {
				dateTimeAt: "{{date}} at {{time}}",
				yes: "Yes",
				no: "No",
				ok: "OK",
				cancel: "Cancel",
				save: "Save",
				saving: "Saving...",
				close: "Close",
				delete: "Delete",
				edit: "Edit",
				add: "Add",
				new: "New",
				search: "Search",
				filter: "Filter",
				clear: "Clear",
				back: "Back",
				next: "Next",
				previous: "Previous",
				confirm: "Confirm",
				loading: "Loading...",
				loadMore: "Load more",
				all: "All",
				none: "None",
				noRecords: "No records found",
				noResults: "No results found",
				actions: "Actions",
				name: "Name",
				email: "E-mail",
				phone: "Phone",
				status: "Status",
				type: "Type",
				date: "Date",
				startDate: "Start date",
				endDate: "End date",
				from: "From",
				to: "To",
				total: "Total",
				active: "Active",
				inactive: "Inactive",
				enabled: "Enabled",
				disabled: "Disabled",
				required: "Required",
				optional: "Optional",
				export: "Export",
				exportExcel: "Export to Excel",
				print: "Print",
				refresh: "Refresh",
				select: "Select",
				selected: "Selected",
				description: "Description",
				notes: "Notes",
				createdAt: "Created at",
				updatedAt: "Updated at",
				user: "User",
				company: "Company",
				unknown: "Unknown",
				error: "Error",
				success: "Success",
				notInformed: "Not provided",
				featureNotEnabled: "This company does not have permission to access this page! Redirecting you.",
				calendar: {
					today: "Today",
					previous: "Back",
					next: "Next",
					month: "Month",
					week: "Week",
					day: "Day",
					agenda: "Agenda",
					date: "Date",
					time: "Time",
					event: "Event",
					allDay: "All day",
					noEventsInRange: "No events in this period.",
					showMore: "+ Show more ({{count}})",
				},
				time: {
					minutesAgo: "{{count}} minute ago",
					minutesAgo_plural: "{{count}} minutes ago",
					hoursAgo: "{{count}} hour ago",
					hoursAgo_plural: "{{count}} hours ago",
					daysAgo: "{{count}} day ago",
					daysAgo_plural: "{{count}} days ago",
				},
			},
			validation: {
				required: "Required",
				tooShort: "Too short",
				tooLong: "Too long",
				invalidEmail: "Invalid e-mail",
				invalidPhone: "Invalid phone number",
				invalidUrl: "Invalid URL",
				invalidDate: "Invalid date",
				invalidNumber: "Invalid number",
				minLength: "Minimum of {{count}} characters",
				maxLength: "Maximum of {{count}} characters",
				min: "Minimum value: {{min}}",
				max: "Maximum value: {{max}}",
				positiveNumber: "Enter a positive number",
				passwordsMustMatch: "Passwords do not match",
				invalidCnpj: "Invalid CNPJ",
				invalidCpf: "Invalid CPF",
			},
			labels: {
				priority: {
					low: "Low",
					medium: "Medium",
					normal: "Normal",
					high: "High",
					urgent: "Urgent",
				},
				severity: {
					critical: "Critical",
					high: "High",
					medium: "Medium",
					low: "Low",
					info: "Info",
				},
				weekdays: {
					monday: "Monday",
					tuesday: "Tuesday",
					wednesday: "Wednesday",
					thursday: "Thursday",
					friday: "Friday",
					saturday: "Saturday",
					sunday: "Sunday",
				},
			},
			signup: {
				title: "Sign up",
				toasts: {
					success: "User created successfully! Please login!",
					fail: "Error creating user. Check the reported data.",
				},
				form: {
					name: "Name",
					email: "Email",
					password: "Password",
					acceptTermsPrefix: "I have read and accept the",
					acceptTermsLink: "Terms and Conditions of Use",
					acceptTermsRequired: "You must accept the Terms to sign up",
					phone: "Phone (with area code)",
					planOption: "{{name}} - Agents: {{users}} - WhatsApp: {{connections}} - Queues: {{queues}} - R$ {{value}}",
					freeTrial: "🎁 First month free! Billing for the chosen plan only starts in the second month.",
				},
				buttons: {
					submit: "Register",
					login: "Already have an account? Log in!",
				},
				validation: {
					planRequired: "Select a plan",
				},
			},
			login: {
				title: "Login",
				form: {
					email: "Email",
					password: "Password",
					showHidePassword: "Show/hide password",
				},
				buttons: {
					submit: "Enter",
					register: "Don't have an account? Register!",
				},
				licenseBlocked: {
					title: "Access blocked: this company's license is not valid.",
					reason: "Reason: {{reason}}",
					contact: "Please contact Empsis to renew the license.",
				},
				sessionExpired: "Your session has expired. Please log in again.",
			},
			auth: {
				token: "Token",
				toasts: {
					success: "Login successfully!",
					subscriptionBlocked: "Oops! Your subscription expired on {{date}}. Settle the payment to keep using the system.",
					subscriptionExpiresInOneDay: "Your subscription expires in {{days}} day",
					subscriptionExpiresInDays: "Your subscription expires in {{days}} days",
					subscriptionExpired: "Your subscription expired on {{date}}. Settle the payment to avoid being blocked.",
				},
			},
			dashboard: {
				charts: {
					perDay: {
						title: "Tickets today: ",
					},
					createdTickets: "Tickets Created: {{total}}",
					ticketsAxis: "Tickets",
					conversations: {
						chartTitle: "Conversations Chart",
						total: "Total ({{total}})",
						start: "Start",
						end: "End",
						hourRange: "{{hour}}:00 to {{hour}}:59",
						loadError: "Error loading ticket data",
					},
					conversationsByUser: {
						title: "Total Conversations by User",
						chartTitle: "Conversations Chart",
						dataset: "Conversations",
						loadError: "Error loading conversation data",
					},
					messagesByUser: {
						title: "Messages by User",
						chartTitle: "Messages by User (Received × Sent)",
						received: "Received",
						sent: "Sent",
						loadError: "Error loading messages by user",
					},
					messagesPerDay: {
						title: "Messages per Day",
						chartTitle: "Messages per Day Chart",
						loadError: "Error loading messages per day",
					},
					ticketsPerDay: {
						title: "Tickets per Day",
						chartTitle: "Tickets per Day Chart",
						loadError: "Error loading tickets per day",
					},
					ticketsPerHour: {
						title: "Tickets by Hour",
						chartTitle: "Tickets by Hour Chart",
						loadError: "Error loading tickets by hour",
					},
					ticketsPerWeekDay: {
						title: "Tickets by Day of the Week",
						chartTitle: "Tickets by Day of the Week Chart",
						loadError: "Error loading tickets by day of the week",
					},
					volume: {
						low: "Lower volume",
						mid: "Average volume",
						high: "Higher volume",
					},
					weekDayShort: {
						sun: "Sun",
						mon: "Mon",
						tue: "Tue",
						wed: "Wed",
						thu: "Thu",
						fri: "Fri",
						sat: "Sat",
					},
				},
				conversions: {
					title: "Conversions",
					chartTitle: "Conversions (Yes × No)",
					yes: "Yes",
					no: "No",
					totalTickets: "Total Tickets",
					totalConversions: "Total Conversions",
					conversionRate: "Conversion Rate",
					notApplicable: "Not applicable",
					dialog: {
						title: "Converted?",
						message: "Did this ticket result in a conversion?",
						yes: "Yes",
						no: "No",
						notApplicable: "Not applicable",
						cancel: "Cancel",
					},
					loadError: "Error loading conversion data",
				},
				noInteraction: {
					cardTitle: "Closed without interaction",
					chartTitle: "Closed without interaction by agent",
					subtitle: "Tickets closed by the agent without any message sent to the contact.",
					empty: "No tickets closed without interaction in this period.",
					total: "Total in period",
					user: "Agent",
					quantity: "Amount",
					detailsTitle: "Tickets closed without interaction",
					view: "View",
					close: "Close",
					table: {
						ticket: "Ticket",
						contact: "Contact",
						queue: "Queue",
						connection: "Connection",
						user: "Agent",
						closedAt: "Closed at",
						open: "Open",
					},
				},
				ticketsByContactTag: {
					title: "Tickets by contact tag",
					chartTitle: "Tickets opened by contact tag",
					subtitle: "{{total}} tickets opened in the period · {{untagged}} without tag",
					multiTagNote: "A ticket counts under every tag of its contact, so the sum of tags can exceed the total.",
					topNote: "The chart shows the {{count}} tags with the most tickets; the table lists all of them.",
					loadError: "Error loading tickets by contact tag",
					tag: "Tag",
					quantity: "Amount",
					percent: "% of total",
					untagged: "No tag",
					view: "View",
					close: "Close",
					detailsTitle: "Tickets with tag",
					detailsTitleUntagged: "Tickets from contacts without tag",
					detailsEmpty: "No tickets found.",
					showingLimit: "Showing the {{shown}} most recent of {{total}}.",
					status: {
						open: "In progress",
						pending: "Waiting",
						closed: "Closed",
						group: "Group",
					},
					table: {
						ticket: "Ticket",
						contact: "Contact",
						queue: "Queue",
						connection: "Connection",
						user: "Agent",
						status: "Status",
						openedAt: "Opened at",
						open: "Open",
					},
				},
				filters: {
					title: "Filters",
					invalid: "Set up the filter",
				},
				cards: {
					inConversation: "In Conversation",
					waiting: "Waiting",
					finished: "Closed",
					newContacts: "New Contacts",
					medianConversation: "Median Conversation Time",
					medianWait: "Median Wait Time",
				},
				attendantsTable: {
					avgSupportTime: "Avg. Service Time",
					currentStatus: "Status (Current)",
				},
			},
			connections: {
				subscription: {
					subscribed: "Subscribed",
					pending: "Pending",
				},
				typeTooltips: {
					cloudapi: "Official Meta API",
					email: "Email channel (POP3/IMAP + SMTP)",
					sms: "SMS channel",
					baileys: "Baileys (Unofficial)",
					publicLink: "Public link / custom nickname",
				},
				publicLink: {
					title: "Public link",
					titleWithName: "Public link — {{name}}",
					defaultLink: "Default public link for this connection:",
					nicknameHelp: "Custom nickname (short link). Leave blank to remove it.",
					nicknamePlaceholder: "e.g. sniperCMS",
					nicknameRules: "3 to 50 characters: letters, numbers, '-' or '_'.",
					activeLink: "Active custom link:",
					copy: "Copy",
					saveNickname: "Save nickname",
				},
				title: "Connections",
				toasts: {
					instagramConnected: "Instagram connected successfully!",
					instagramConnectedAs: "Instagram (@{{username}}) connected successfully!",
					instagramFailed: "Failed to connect Instagram: {{reason}}",
					instagramSubscribed: "Instagram webhooks subscribed successfully!",
					instagramSubscribeFailed: "Meta rejected the webhook subscription. Try reconnecting Instagram.",
					unknownError: "unknown error",
					subscribed: "Connection subscribed successfully!",
					linkCopied: "Link copied!",
					publicLinkCopied: "Public link copied!",
					customLinkCopied: "Custom link copied!",
					nicknameSaved: "Nickname saved!",
					nicknameRemoved: "Nickname removed.",
					instagramAuthUrlMissing: "Instagram authorization URL was not received.",
					deleted: "WhatsApp connection deleted sucessfully!",
					deletedByType: {
						cloudapi: "WhatsApp (Official API) connection deleted successfully!",
						email: "Email connection deleted successfully!",
						sms: "SMS connection deleted successfully!",
						instagram: "Instagram connection deleted successfully!",
					},
				},
				alerts: {
					offline:
						"The {{name}} connection is offline. Your messages may not be sent or received — please notify the system administrator.",
					offlineManager:
						"The {{name}} connection is offline. Open the Connections menu to reconnect it.",
					offlineMultiple:
						"{{total}} connections are offline ({{names}}). Your messages may not be sent or received — please notify the system administrator.",
					offlineMultipleManager:
						"{{total}} connections are offline ({{names}}). Open the Connections menu to reconnect them.",
					recovered: "The {{name}} connection is back online.",
					ack: "OK",
					dismiss: "Dismiss alert",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? It cannot be reverted.",
					disconnectTitle: "Disconnect",
					disconnectMessage: "Are you sure? You'll need to read QR Code again.",
				},
				buttons: {
					emailChannel: "Email channel",
					smsChannel: "SMS channel",
					reconnectInstagram: "Reconnect Instagram",
					instagramSubscribe: "Subscribe webhooks",
					instagramConnected: "Connected",
					subscribe: "Subscribe",
					subscribing: "Subscribing...",
					subscribed: "Subscribed",
					add: "Add Account",
					disconnect: "Disconnect",
					tryAgain: "Try Again",
					qrcode: "QR CODE",
					newQr: "New QR CODE",
					connecting: "Connectiing",
				},
				toolTips: {
					DISCONNECTED: {
						title: "Failed to start WhatsApp session",
						content:
							"Make sure your cell phone is CONNECTED to the internet and try again, or request a new QR Code",
					},
					qrcode: {
						title: "Waiting for QR Code read",
						content:
							"Click on 'QR CODE' button and read the QR Code with your cell phone to start session",
					},
					CONNECTED: {
						title: "Connection established",
					},
					instagramReconnect: {
						title: "Instagram token expired or revoked",
						content: "Click 'Reconnect Instagram' and log in to the account to send and receive messages again",
					},
					instagramSubscribe: {
						title: "Instagram webhooks not subscribed",
						content: "Messages may not arrive. Click 'Subscribe webhooks' to fix it",
					},
					timeout: {
						title: "Connection with cell phone has been lost",
						content:
							"Make sure your cell phone is CONNECTED to the internet and WhatsApp is open, or click on 'Disconnect' button to get a new QRcode",
					},
				},
				table: {
					number: "Number",
					type: "Type",
					subscription: "Subscription",
					name: "Name",
					status: "Status",
					lastUpdate: "Last Update",
					default: "Default",
					actions: "Actions",
					session: "Session",
				},
			},
			whatsappModal: {
				connectionType: {
					title: "Connection Type",
					fixed: "Connection Type: {{type}}",
					baileys: "Unofficial API (Baileys)",
					cloudapi: "Official API (Meta)",
					email: "Email channel (POP3/IMAP + SMTP)",
					desc: {
						baileys: "QR Code connection using the Baileys library. No Business account required.",
						cloudapi: "Official Meta/WhatsApp Business API. Requires Meta Business Platform credentials.",
						email: "Channel for sending and receiving emails via POP3 or IMAP (incoming) and SMTP (outgoing) to open and reply to tickets.",
						instagram: "Instagram Direct and comments via the official API. Connect your professional account using the easy login below.",
						sms: "SMS sending through a gateway (Witi.me, SMS Barato or SMSDev). Send-only channel (campaigns) — it does not receive replies.",
					},
				},
				instagram: {
					title: "Instagram Connection",
					connectedAccount: "Connected account:",
					description: "Connect your Instagram professional account to receive and reply to Direct messages and comments. Click the button below, log in and authorize — the connection is created automatically.",
					notConfigured: "The Meta app is not configured on this server. Contact support.",
					connect: "Connect Instagram",
					reconnect: "Reconnect Instagram",
					redirecting: "Redirecting...",
				},
				kanban: {
					title: "Automatic Kanban Card Creation",
					description: "Choose whether this connection should automatically create Kanban cards when new tickets are started.",
					enable: "Enable automatic card creation",
					board: "Target board",
					boardPlaceholder: "Select a board",
					boardHelp: "Board where the cards will be created",
					column: "Target column",
					columnPlaceholder: "Select a column",
					columnHelp: "Column where the cards will be created",
					user: "Assigned user (optional)",
					userHelp: "User who will be linked to the automatically created cards",
					prerequisiteLabel: "Prerequisite:",
					prerequisiteText: "The selected board must have the \"ticketId\" custom field configured for automatic creation to work.",
					loadColumnsError: "Error loading the board columns",
				},
				cloudApi: {
					title: "Official API Setup (Meta Cloud API)",
					appNotConfigured: "The Meta app is not configured on this server, so the easy login is unavailable. Contact support or fill in the data manually below.",
					quickTitle: "Quick Connection",
					quickDescription: "Connect your WhatsApp Business with a single click. Log in to Facebook and authorize access.",
					connect: "Connect WhatsApp",
					connecting: "Connecting...",
					selectNumber: "Select the number you want to connect:",
					orManual: "or set it up manually",
					hideManual: "Hide manual fields",
					showManual: "Show manual fields",
					phoneNumberIdHelp: "Number ID in Meta Business (e.g. 123456789012345)",
					wabaIdHelp: "WhatsApp Business account ID",
					validate: "Validate Credentials",
					valid: "Valid",
					invalid: "Invalid",
					result: {
						number: "Number:",
						verifiedName: "Verified name:",
						quality: "Quality:",
						account: "Account:",
					},
					credentialsSet: "Credentials configured",
					appCredentialsLabel: "Meta app credentials:",
					appCredentialsText: "they are configured only once on the server. Until that is done, you can fill them in on the \"Cloud API\" tab in \"Settings\".",
					toasts: {
						valid: "Valid connection! Number: {{phone}} - {{name}}",
						invalid: "Invalid credentials: {{error}}",
						validateError: "Error validating credentials",
						communicationError: "Communication error",
						signupUnavailable: "Easy login unavailable: the Meta app is not configured on the server. Contact support.",
						processing: "Processing authorization... Please wait.",
						signupError: "Embedded Signup error",
						connectedReview: "WhatsApp connected successfully! Review the data and click Save.",
						connectedNumber: "WhatsApp connected! Number: {{phone}} ({{name}}). Click Save.",
						authorizedSelect: "Authorization complete! Select the number you want to connect.",
						authorizedNoNumber: "Authorization complete, but no number was found.",
						timeout: "Meta took too long to respond. The account may have been created — close and reopen this screen before trying again.",
						processError: "Error processing Embedded Signup",
						cancelled: "Embedded Signup cancelled",
						numberSelected: "Selected number: {{phone}} ({{name}})",
					},
				},
				sms: {
					title: "SMS Gateway Setup ({{provider}})",
					provider: "SMS provider",
					providers: {
						witime: "Witi.me — best for large volumes",
						smsbarato: "SMS Barato — best for smaller volumes",
						smsdev: "SMSDev — best for smaller volumes",
					},
					apiKey: "API key",
					apiKeyCurrent: "Current key: {{hint}}. Leave blank to keep the current key.",
					apiKeyHelpWitime: "Available in the Witi.me panel under SMS > SMS Settings.",
					apiKeyHelp: "Available in the {{provider}} panel.",
					apiKeyMissing: "Enter the SMS gateway API key.",
					showHideApiKey: "Show/hide API key",
					route: "Route",
					routeHelp: "Optional. Empty uses the account's default route.",
					sendType: "Send type",
					sendTypes: {
						common: "Standard (marketing / P2P)",
						token: "Token (OTP)",
						debug: "Debug (simulation, not charged)",
					},
					reference: "Reference",
					referenceHelp: "Identifies the messages in the {{provider}} panel.",
					webhookUrl: "Webhook URL (DLR)",
					showHideWebhook: "Show/hide webhook URL",
					copyWebhook: "Copy webhook URL",
					webhookCopied: "Webhook URL copied.",
					webhookCopyError: "Could not copy the URL.",
					webhookHelp: "Register this URL in the Witi.me panel to receive campaign delivery confirmations. It contains a secret token — use the copy button.",
					webhookAfterSave: "The webhook URL for delivery confirmation will be shown here after you save the connection.",
					baseUrl: "System URL",
					baseUrlHelp: "Optional. Each account uses its own address (sistemaNN) — confirm yours with SMS Barato support.",
					smsbaratoNote: "SMS Barato does not accept accents or line breaks (converted automatically when sending) and limits each message to 160 characters. Delivery confirmation is checked automatically — there is no webhook to register.",
					smsdevNote: "SMSDev does not deliver accented characters, so accents are converted automatically when sending (ação → acao); line breaks are kept. Long messages use 1 credit per 160 characters. Delivery confirmation is checked automatically — there is no webhook to register.",
				},
				email: {
					title: "Email Channel Setup",
					user: "Email user",
					password: "Email password",
					passwordKeep: "Leave blank to keep the current password.",
					showHidePassword: "Show/hide email password",
					fromName: "Sender name",
					inboundProtocol: "Incoming protocol",
					pop3Suggested: "POP3 (suggested)",
					host: "{{protocol}} server",
					port: "{{protocol}} port",
					deleteAfterFetch: "Delete from server after downloading",
					deleteAfterFetchHelp: "Off: messages stay on the server and remain visible in your email client; the CRM keeps track of what has already been imported. On: each imported email is deleted from the mailbox.",
					mailbox: "Mailbox",
					test: "Test {{protocol}}/SMTP connection",
					result: {
						ok: "Connection validated",
						partial: "Partial validation",
						failed: "Validation failed",
						statusFailed: "Failed",
						noDetails: "No details",
					},
					toasts: {
						missingFields: "Fill in the email user/password and the {{protocol}}/SMTP servers.",
						missingFieldsTest: "Fill in the email user/password and the {{protocol}}/SMTP servers before testing.",
						missingServer: "Fill in the user, password and {{protocol}} server",
						validated: "{{protocol}}/SMTP connection validated successfully.",
						partialDetail: "Partial validation: {{protocol}}: {{inbound}} | SMTP: {{smtp}}",
						failedShort: "failed",
						partial: "Partial validation of the email connection.",
						failed: "Failed to validate the email connection.",
						testFailed: "Failed to test {{protocol}}",
					},
				},
				tabs: {
					general: "General",
					messages: "Messages",
					assessments: "Ratings",
					integrations: "Integrations",
					schedules: "Business hours",
				},
				title: {
					add: "Add Connection",
					edit: "Edit Connection",
				},
				form: {
					timeToTransfer: "Transfer after x (minutes)",
					transferQueue: "Transfer queue",
					showHideToken: "Show/hide token",
					tokenCurrent: "Current token: {{hint}}. Leave blank to keep the current token.",
					removeToken: "Remove token",
					undoRemoveToken: "Undo removal",
					tokenWillBeRemoved: "The token will be removed on save; integrations using this token will stop working.",
					sendIdQueue: "Queue",
					timeSendQueue: "Redirect to queue after X minutes",
					queueRedirection: "Queue redirection",
					outOfHoursMessage: "Out-of-hours message",
					queueRedirectionDesc: "Select a queue to redirect contacts that have no queue",
					prompt: "Prompt",
					expiresTicket: "Close open chats after X minutes",
					expiresInactiveMessage: "Closing message for inactivity",
					greetingMessage: "Greeting message",
					complationMessage: "Completion message",
					name: "Name",
					default: "Default",
					onlineWhileViewing: "Show contact \"typing\" and \"online\"",
					onlineWhileViewingHelp: "The number appears online while any agent has FaleCRM open. During that time the phone does not notify messages.",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "WhatsApp saved successfully.",
				successByType: {
					cloudapi: "WhatsApp (Official API) connection saved successfully.",
					email: "Email connection saved successfully.",
					sms: "SMS connection saved successfully.",
					instagram: "Instagram connection saved successfully.",
				},
			},
			qrCode: {
				title: "Use your WhatsApp:",
				methodPhone: "Phone number",
				generatingQr: "Generating QR Code...",
				qrSteps: {
					one: "1 - Open WhatsApp on your phone",
					two: "2 - Tap More options on Android or Settings on iPhone",
					three: "3 - Tap Linked devices and then Link a device",
					four: "4 - Point your phone at this screen to scan the QR Code",
					hint: "If the QR Code expires, click \"Generate New QR Code\".",
				},
				phoneSteps: {
					one: "1 - Enter the number (country code + area code + number) and click \"Generate code\".",
					two: "2 - On your phone, open WhatsApp → Linked devices → Link a device",
					three: "3 - Tap \"Link with phone number\"",
					four: "4 - Enter the 8-digit code shown on the side",
					hint: "Use digits only, with the country code. E.g. 5511999998888.",
				},
				error: {
					title: "Failed to connect",
					message: "Could not establish a connection with WhatsApp.",
					retry: "Try Again",
				},
				cooldown: {
					title: "Too many connection attempts",
					message: "To protect your number from being blocked by WhatsApp, QR Code generation has been paused. It resumes automatically in about",
					at: "(at {{time}}).",
					hint: "If you prefer, try now — but avoid generating many QR Codes in a row without scanning them.",
					retry: "Try now",
				},
				expired: {
					title: "QR Code expired.",
					message: "Click below to generate a new QR Code.",
					retry: "Generate New QR Code",
				},
				pairing: {
					enterCode: "Enter this code in your WhatsApp:",
					number: "Number:",
					newCode: "Generate new code",
					phoneLabel: "Number with country code",
					generate: "Generate code",
					generating: "Generating...",
					invalidNumber: "Enter the number with country code + area code + number (e.g. 5511999998888).",
				},
				message: "Read QrCode to start the session",
			},
			contacts: {
				title: "Contacts",
				toasts: {
					deletedAll: "All contacts deleted successfully!",
					deleted: "Contact deleted sucessfully!",
					exportEmpty: "No contacts to export with the current search.",
					exportLimited: "Export limited to 5,000 contacts. Refine the search to export the rest.",
				},
				exportMenu: {
					xlsx: "Export XLSX",
					csv: "Export CSV",
				},
				searchPlaceholder: "Search ...",
				confirmationModal: {
					deleteAllTitle: "Delete all",
					deleteAllMessage: "Are you sure you want to delete all contacts? All related tickets will be lost.",
					deleteTitle: "Delete",
					importTitle: "Import contacts",
					deleteMessage:
						"Are you sure you want to delete this contact? All related tickets will be lost.",
					importMessage: "Do you want to import all contacts from the phone?",
				},
				buttons: {
					import: "Import Contacts",
					add: "Add Contact",
					export: "Export Contacts",
					delete: "Delete All Contacts",
				},
				importModal: {
					title: "Import contacts",
					optionConnection: "From WhatsApp connection",
					optionFile: "From file (CSV/XLS/XLSX)",
					message:
						"Choose which connected WhatsApp number to import contacts from. Contacts will be created with the names saved on the phone.",
					selectLabel: "WhatsApp connection",
					importing: "Importing contacts... this can take a while for large contact lists.",
					noConnection:
						"No WhatsApp connection is currently connected. Connect a number on the connections page first.",
					success: "Import finished: {{total}} contacts read from the phone — {{imported}} new, {{updated}} updated.",
					partialWarning: "The full phone address book could not be downloaded right now. Only the {{total}} contacts received since the last server restart were processed ({{imported}} new, {{updated}} updated) — some contacts may be missing. Try again in a few minutes or import from a spreadsheet.",
					fileMessage:
						"Upload a CSV, XLS or XLSX spreadsheet with the columns from the template below. Fill in \"numero\" or \"email\" — the other columns are optional and can be left blank.",
					downloadTemplateXlsx: "Download XLSX template",
					downloadTemplateCsv: "Download CSV template",
					selectFile: "Select file",
					noFileSelected: "No file selected",
					uploading: "Importing spreadsheet... this can take a while for large contact lists.",
					fileSuccess: "Import finished: {{imported}} new, {{updated}} updated, {{skipped}} skipped, {{errors}} errors.",
					notValidatedWarning: "Numbers were imported without WhatsApp verification (no active connection available).",
					invalidNumbersInfo: "{{count}} numbers were not found on WhatsApp but were imported anyway.",
					closeAfterImport: "Close",
				},
				table: {
					name: "Name",
					whatsapp: "WhatsApp",
					email: "Email",
					actions: "Actions",
				},
				linkedCliente: "Linked to client: {{name}}",
				connectionTooltip: {
					selected: "Connection: {{name}}",
					selectedFallback: "Selected",
					select: "Select connection for new tickets",
				},
				linkModal: {
					contactLabel: "Contact: {{name}}",
					linkType: "Link type",
					existingCliente: "Existing client",
					newCliente: "New client",
					searchHelper: "Type a name, email, CPF or CNPJ",
					newClienteInfo: "When you continue, the new client screen will open with the contact's name, mobile number and email already filled in.",
					selectCliente: "Select a client to link",
					invalidContact: "Invalid contact for linking",
				},
			},
			contactListItems: {
				title: "Contacts",
				searchPlaceholder: "Search",
				buttons: {
					add: "New",
					lists: "Lists",
					import: "Import",
					importing: "Importing…",
				},
				dialog: {
					name: "Name",
					number: "Number",
					whatsapp: "WhatsApp",
					email: "Email",
					okEdit: "Edit",
					okAdd: "Add",
					add: "Add",
					edit: "Edit",
					cancel: "Cancel",
				},
				importProgress: {
					uploading: "Uploading spreadsheet… {{percent}}%",
					processing: "Processing spreadsheet…",
					importing: "Importing contacts: {{processed}} of {{total}}",
				},
				validation: {
					queued: "Queued for WhatsApp validation…",
					progress: "Validating numbers on WhatsApp: {{checked}} of {{total}}",
					done: "Validation finished: {{valid}} valid and {{invalid}} invalid.",
					doneWithPending:
						"Validation finished: {{valid}} valid, {{invalid}} invalid and {{unvalidated}} not validated.",
					unavailable:
						"WhatsApp validation unavailable (no WhatsApp connection is connected). The contacts were imported and the campaign is not affected; import the spreadsheet again to retry validating the pending ones.",
					error:
						"Error validating the numbers on WhatsApp. The contacts were imported; import the spreadsheet again to retry validating the pending ones.",
				},
				table: {
					name: "Name",
					number: "Number",
					whatsapp: "WhatsApp",
					email: "Email",
					actions: "Actions",
					validWhatsapp: "Valid WhatsApp",
					invalidWhatsapp: "Invalid WhatsApp",
					notValidated: "Number not validated on WhatsApp",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "This action cannot be undone.",
					importMessage: "Do you want to import the contacts from this spreadsheet? ",
					importTitlte: "Import",
					downloadSample: "Click here to download the sample spreadsheet.",
				},
				toasts: {
					deleted: "Record deleted",
					imported:
						"{{created}} contacts imported ({{duplicates}} were already in the list, {{invalid}} rows without a valid number).",
				},
			},
			contactModal: {
				title: {
					editGroup: "Edit group",
					add: "Add contact",
					edit: "Edit contact",
				},
				form: {
					whatsapp: "Source connection: ",
					mainInfo: "Contact details",
					extraInfo: "Additional information",
					name: "Name",
					number: "Whatsapp number",
					email: "Email",
					extraName: "Field name",
					extraValue: "Value",
					tags: "Contact tags",
					tagsPlaceholder: "Tags",
					numberHelper: "Brazilian: area code + number. International: use + and the country code (e.g.: +1 415 555 2671)",
					emailPlaceholder: "Email address",
				},
				buttons: {
					addExtraInfo: "Add information",
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Contact saved successfully.",
				warnings: {
					whatsappValidationSkipped:
						"Contact saved, but the number could not be verified on WhatsApp: no WhatsApp connection is currently connected. SMS campaigns do not require this validation.",
				},
			},
			scheduleModal: {
				title: {
					add: "New Schedule",
					edit: "Edit Schedule",
					PENDENTE: "Pending Message",
					AGENDADA: "Scheduled Message",
					ENVIADA: "Sent Message",
					ERRO: "Sending Error",
				},
				form: {
					body: "Message",
					contact: "Contact",
					sendAt: "Schedule date",
					sentAt: "Sent date",
					signMessage: "Sign message",
					whatsapp: "Connection used to send *",
					whatsappPlaceholder: "Select a connection",
					contactSearchPlaceholder: "Type to search a contact (name or number)",
					contactMinChars: "Type at least 2 characters to search...",
					contactNotFound: "No contact found",
					contactLoading: "Searching contacts...",
				},
				validation: {
					required: "Required",
					bodyMin: "Message too short",
					sendAtPast:
						"Scheduling a message in the past is not allowed (2 minute tolerance).",
					whatsappRequired: "Select a connection",
				},
				confirmationModal: {
					deleteTitle: "Delete attachment",
					deleteMessage:
						"Are you sure you want to delete the attachment of this schedule?",
				},
				toasts: {
					deleted: "Attachment deleted successfully.",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Schedule saved successfully.",
			},
			tagModal: {
				title: {
					add: "New Tag",
					edit: "Edit Tag",
				},
				form: {
					name: "Name",
					color: "Color",
					blockAi: "Block AI",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "Tag saved successfully.",
			},
			queueModal: {
				title: {
					add: "Add queue",
					edit: "Edit queue",
				},
				form: {
					complationMessage: "Completion message",
					outOfHoursMessage: "Out-of-hours message",
					ratingMessage: "Rating message",
					token: "Token",
					orderQueue: "Queue order (bot)",
					integrationId: "Integration",
					name: "Name",
					color: "Color",
					greetingMessage: "Greeting Message",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				tabs: {
					data: "Queue Details",
					schedules: "Business Hours",
				},
				toasts: {
					saved: "Queue saved successfully",
					schedulesPending: "Click save to apply the changes",
				},
			},
			userModal: {
				deleteAccount: {
					title: "Delete my account",
					hint:
						"Deleting your account ends your access to the system. This action cannot be undone.",
					button: "Delete my account",
				},
				title: {
					add: "Add user",
					edit: "Edit user",
				},
				form: {
					whatsapp: "Default connection",
					allTicket: "Ticket without queue [Invisible]",
					allTicketEnabled: "Enabled",
					allTicketDesabled: "Disabled",
					name: "Name",
					email: "Email",
					password: "Password",
					profile: "Profile",
					whatsapps: "Connections the user manages",
					salesGoal: "Sales Goal",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				success: "User saved successfully.",
			},
			chat: {
				noTicketMessage: "Select a ticket to start chatting.",
			},
			// O bloco internalChat NAO existe aqui de proposito: a tela de Conversas
			// e escrita em pt-BR e o en.js so tem uma fracao das chaves do sistema.
			// Sem a chave em ingles, o i18next cai no fallback (pt) e a tela fica
			// coerente com o resto dela em navegadores configurados em ingles.
			ticketsManager: {
				buttons: {
					newTicket: "New",
				},
				emailSync: {
					tooltip: "Refresh emails (check for new ones)",
					error: "Could not check emails. Please try again.",
					received: "{{count}} new email received.",
					received_plural: "{{count}} new emails received.",
					none: "No new emails found.",
				},
				sorting: {
					title: "Sorting",
				},
			},
			ticketsQueueSelect: {
				placeholder: "Queues",
			},
			ticketsWhatsappSelect: {
				placeholder: "Connections",
			},
			tickets: {
				muted: "Notifications muted",
				inactiveConnection: {
					badge: "Connection deleted",
					tooltip: "This ticket belongs to a connection deleted on {{date}}. Available for reference only.",
					readOnly: "Ticket from a deleted connection — read-only. It can't be answered or reopened.",
					removedToast: "This ticket's connection was deleted. The ticket was closed.",
				},
				toasts: {
					deleted: "The ticket you were on has been deleted.",
					noQueueAccess: "You do not have access to this ticket's queue",
					assumed: "Ticket taken over successfully!",
				},
				notification: {
					message: "Message from",
				},
				tabs: {
					open: { title: "Inbox" },
					closed: { title: "Resolved" },
					search: { title: "Search" },
				},
				search: {
					placeholder: "Search tickets and messages.",
				},
				buttons: {
					showAll: "All",
				},
				contactRemoved: "Contact removed",
				closePreview: "Close preview",
				dropFileHere: "Drop the file here",
				advanced: {
					selectTicket: "Select Ticket",
					nav: {
						ticket: "Ticket",
						tickets: "Tickets",
					},
				},
				developmentRequest: {
					request: "Request development",
					previewTicketNotFound: "Ticket not found to generate the preview.",
					saveTicketNotFound: "Ticket not found to save the request.",
					created: "Development request registered successfully.",
				},
			},
			transferTicketModal: {
				fieldQueueLabel: "Transfer to queue",
				fieldQueuePlaceholder: "Select a queue",
				title: "Transfer Ticket",
				bulkTitle: "Transfer {{count}} tickets",
				keepQueue: "Keep each ticket's queue",
				keepConnection: "Keep each ticket's connection",
				fieldLabel: "Type to search for users",
				pendingUserHelper: "Optional: leave blank to keep the ticket pending",
				openUserHelper: "Optional: leave blank to move the ticket back to pending in the selected queue",
				offline: "offline",
				noOptions: "No user found with this name",
				noQueue: "No queue",
				buttons: {
					ok: "Transfer",
					cancel: "Cancel",
				},
				selectConnection: "Select a connection",
				errors: {
					invalidTicket: "Invalid ticket for transfer",
					selectUser: "Select a user",
				},
			},
			ticketContextMenu: {
				selection: "Selection",
				select: "Select",
				selectAll: "Select All",
				clearSelection: "Clear Selection",
				selected: "selected",
				selectedCount: "{{count}} selected",
				cancel: "Cancel",
				actions: {
					title: "Actions",
					accept: "Accept",
					close: "Close",
					transfer: "Transfer",
					return: "Return to Queue",
					resolve: "Resolve",
					schedule: "Create Schedule",
					markUnread: "Mark as Unread",
					markRead: "Mark as Read",
					resetAlarm: "Reset Alarm",
					mute: "Mute notifications",
					muteFor8Hours: "8 hours",
					muteFor1Week: "1 week",
					muteForever: "Always",
					unmute: "Unmute",
				},
				confirmAcceptTitle: "Confirm Accept",
				confirmAcceptMessage: "Do you want to accept {{count}} ticket(s)?",
				confirmCloseTitle: "Confirm Close",
				confirmCloseMessage: "Do you want to close {{count}} ticket(s)?",
				confirmReturnTitle: "Confirm Return",
				confirmReturnMessage: "Do you want to return {{count}} ticket(s) to queue?",
				confirmResolveTitle: "Confirm Resolve",
				confirmResolveMessage: "Do you want to resolve {{count}} ticket(s)?",
				confirmMarkUnreadTitle: "Confirm Mark as Unread",
				confirmMarkUnreadMessage: "Do you want to mark {{count}} ticket(s) as unread?",			confirmMarkReadTitle: "Confirm Mark as Read",
			confirmMarkReadMessage: "Do you want to mark {{count}} ticket(s) as read?",				bulkActionSuccess: "{{count}} ticket(s) - action '{{action}}' completed successfully!",
				bulkActionFail: "{{count}} ticket(s) failed in action.",
				bulkActionCancelled: "Action cancelled: {{count}} ticket(s) were not changed.",
				errors: {
					transferTicketNotFound: "Could not identify the ticket to transfer",
				},
			},
			ticketsSearch: {
				sections: {
					contacts: "Contacts",
					commonGroups: "Groups in common",
					messages: "Messages",
				},
				alsoInGroup: "~{{name}} is also in this group",
				showMore: "Show more",
				noResults: "No results found",
				noResultsHint: "Nothing matches \"{{term}}\" in this tab.",
				searchedUntil: "Searched back to {{date}}",
				searchOlder: "Search older messages",
			},
			ticketsList: {
				pendingHeader: "Queue",
				assignedHeader: "Working on",
				contactsHeader: "Contacts",
				noTicketsTitle: "Nothing here!",
				noTicketsMessage: "No tickets found with this status or search term.",
				buttons: {
					closed: "Close",
					reopen: "Reopen",
					accept: "Accept",
				},
				sorting: {
					oldestFirst: "Oldest first",
					newestFirst: "Newest first",
					longestWaitFirst: "Longest wait first",
					shortestWaitFirst: "Shortest wait first",
					unreadFirst: "Unread first",
					autoReorder: "Auto reorder"
				},
				filters: {
					title: "Filters",
					searchMode: "Search mode",
					contactNameOnly: "Search contact name only",
					queues: "Queues",
					whatsapp: "WhatsApp Connection",
					tags: "Tags",
					contactTags: "Contact tags",
					contactTagsPlaceholder: "Filter by contact tags",
					users: "Users",
				},
				noConnection: {
					title: "No connection assigned",
					message: "The connection filter is active and your user has no connection assigned. Ask the administrator to assign a connection to your profile.",
				},
				item: {
					comment: "Comment",
					queueLabel: "Queue: {{name}}",
					attendantLabel: "Attendant: {{name}}",
					aiAgentLabel: "AI agent: {{name}}",
				},
			},
			contactsListPanel: {
				newContact: "New contact",
				noContacts: "No contacts found",
				noContactsText: "Use search to find contacts or add new ones on the contacts page",
			},
			newTicketModal: {
				title: "Create Ticket",
				fieldLabel: "Type to search for a contact",
				add: "Add",
				noQueue: "No queue",
				selectQueue: "Select the queue",
				buttons: {
					ok: "Save",
					cancel: "Cancel",
				},
				selectConnection: "Select connection",
				selectConnectionDialogTitle: "Select the connection for the ticket",
				errors: {
					selectConnection: "Select a connection",
					selectWhatsappConnection: "Select a WhatsApp connection",
					connectionNotConnected: "The selected connection is not connected. Please select an active connection.",
				},
				existingTicket: {
					title: "Ticket Already Exists",
					message: "There is already an open ticket for this contact.",
					unknownUser: "Unknown user",
					attendantLabel: "Agent:",
					queueLabel: "Queue:",
					connectionLabel: "Connection:",
					groupSingleTicket: "This group already has a ticket in progress. A group has a single ticket, on any connection — open the existing one.",
					canCreateNew: "You can open the existing ticket or create a new ticket on the selected connection.",
					canCreateNewWithConnection: "You can open the existing ticket or create a new ticket on the selected connection ({{connection}}).",
					sameConnection: "The existing ticket is already on the selected connection. Do you want to open this ticket?",
					createNew: "Create New Ticket",
					openExisting: "Open Existing Ticket",
				},
				templatePicker: {
					title: "24-hour window expired",
					description: "The 24-hour window has expired. Send a message template to start a new conversation.",
					noTemplates: "No approved message templates found. Create templates and submit them for approval on the Templates page.",
					selectTemplate: "Select a template",
					preview: "Preview:",
					emptyBody: "(No body text)",
					variables: "Variables:",
					variable: "Variable",
					send: "Send",
					sending: "Sending...",
					sent: "Template sent successfully!",
				},
			},
			promptModal: {
				form: {
					integrateHumanMessages: "Integrate human messages",
					integrateHumanMessagesTooltip: "When enabled, the system sends the messages exchanged between the customer and the human agent to IAHub, to keep the context before the AI takes over.",
					signMessage: "Sign replies with the agent's name",
					signMessageTooltip: "When enabled, AI replies reach the customer signed with the agent's name on the first line, like messages signed by attendants. When off, replies are sent without a signature.",
					name: "Name",
					prompt: "Prompt",
					voice: "Voice",
					max_tokens: "Maximum Tokens in response",
					temperature: "Temperature",
					apikey: "API Key",
					max_messages: "Maximum messages in History",
					voiceKey: "Voice API Key",
					voiceRegion: "Voice Region",
					aiHubAgentId: "AI Hub Agent ID",
					aiHubBaseUrl: "AI Hub Base URL",
					aiHubWebhookUrl: "AI Hub Webhook URL",
					aiHubAgentIdHelper: "Agent ID in AI Hub (required)",
					aiHubBaseUrlLabel: "AI Hub Base URL",
					aiHubBaseUrlHelper: "Base URL of the AI hub. If empty, the server's AI_HUB_BASE_URL is used",
				},
				success: "Prompt saved successfully!",
				title: {
					add: "Add Prompt",
					edit: "Edit Prompt",
				},
				buttons: {
					okAdd: "Add",
					okEdit: "Save",
					cancel: "Cancel",
				},
				validation: {
					nameTooShort: "Name too short! Minimum of 5 characters.",
					nameTooLong: "Name too long! Maximum of 100 characters.",
					nameRequired: "Name is required",
					agentIdRequired: "AI Hub Agent ID is required",
					invalidBaseUrl: "Must be a valid URL starting with http:// or https://",
				},
				test: {
					title: "Test Agent",
					subtitle: "Uses the agent's saved settings",
					emptyTitle: "Test your agent here!",
					emptyHint: "Send a message to start the conversation",
					openAttachment: "Open attachment",
					attachTooltip: "Attach an image or audio (the typed text is sent as the caption)",
					inputPlaceholder: "Type your message...",
					processingError: "Sorry, an error occurred while processing your request. Please try again.",
				},
				logs: {
					title: "Test Logs — AI Hub",
					subtitle: "Requests sent and callbacks received from this agent's test chat, in real time",
					empty: "No logs recorded yet.",
					emptyHint: "Send a message through an agent's test chat to generate logs.",
					sent: "SENT",
					received: "RECEIVED",
					error: "Error",
					response: "Response",
					clear: "Clear Logs",
					reload: "Reload",
				},
			},
			prompts: {
				humanCooldown: {
					title: "AI pause after an attendant replies",
					helper: "Applies to all agents. As soon as an attendant replies — through FaleCRM or directly from the phone — the AI stays silent on that ticket for this long. Use 0 to disable the pause.",
					label: "Minutes",
					save: "Save",
					saved: "Pause time saved!",
					invalid: "Enter a number of minutes equal to or greater than zero.",
				},
				integrations: {
					enabled: "Yes",
					disabled: "No",
				},
				title: "Prompts",
				table: {
					agentId: "Agent ID",
					integrateHumanMessages: "Integrates human messages",
					name: "Name",
					queue: "Queue/Department",
					max_tokens: "Maximum Response Tokens",
					aiHub: "AI Hub",
					aiHubTooltip: {
						enabled: "AI Hub active - Click to disable",
						disabled: "AI Hub disabled - Click to enable (configure Agent ID first)",
					},
					actions: "Actions",
				},
				toasts: {
					aiHubEnabled: "AI Hub successfully enabled!",
					aiHubDisabled: "AI Hub successfully disabled!",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage: "Are you sure? This action cannot be reverted.",
				},
				buttons: {
					add: "Add Prompt",
				},
			},
			mainDrawer: {
				listItems: {
					ticketRatings: "Ratings",
					ticketsConference: "Ticket Review",
					messagesReport: "Messages Report",
					attendanceMonitor: "Monitoring",
					kanban: "Flows",
					kanbanAll: "All flows",
					clientCentral: "Customer Center",
					usageReport: "Reports",
					clientes: "Customers",
					followUp: "Follow-up",
					tagPhrases: "Tag Phrases",
					forbiddenWords: "Forbidden Terms",
					forbiddenWordsRegister: "Register terms",
					forbiddenWordsReport: "Terms report",
					development: "Development",
					campaignsList: "List",
					contactLists: "Contact Lists",
					campaignsConfig: "Settings",
					messageTemplates: "Message Templates",
					management: "Management",
					quickMessages: "Quick Replies",
					documentTemplates: "Document Templates",
					tags: "Tags",
					helps: "Help",
					messagesAPI: "API",
					schedules: "Schedules",
					campaigns: "Campaigns",
					annoucements: "Announcements",
					financeiro: "Billing",
					files: "File lists",
					prompts: "AI Agents",
					queueIntegration: "Integrations",
                    perfis: "User Profiles",
					dashboard: "Dashboard",
					connections: "Connections",
					tickets: "Tickets",
					pendingMessages: "Pending",
					catalog: "Product Catalog",
					contacts: "Contacts",
					chats: "Internal Chat",
					queues: "Queues",
					administration: "Administration",
					users: "Users",
					settings: "Settings",
				},
				appBar: {
					tooltips: {
						darkMode: "Toggle light/dark theme",
						volume: "Notification volume",
						tickets: "Ticket notifications",
						announcements: "Announcements",
						internalChat: "Internal chat",
						account: "My account",
					},
					notRegister: "No notifications",
					refresh: "Refresh page",
					clearCache: {
						tooltip: "Clear cache",
						title: "Clear CRM cache and data?",
						message: "This deletes the cache, cookies and CRM data stored in this browser, ends your session and reloads the system on the latest version. Messages not yet sent will be lost. Then just sign in again.",
					},
					openFollowUp: "Open follow-up popup",
					greeting: {
						hello: "Hello",
						welcome: "welcome to",
						activeUntil: "Active until {{date}}",
					},
					toasts: {
						popupBlocked: "The browser blocked the follow-up popup. Allow popups and try again.",
					},
					user: {
						language: "Language",
						profile: "Profile",
						logout: "Logout",
					},
				},
			},
			notifications: {
				noTickets: "No notifications.",
			},
			catalog: {
				title: "Product Catalog",
				searchPlaceholder: "Search product or SKU",
				connection: "Connection",
				collection: "Collection",
				allCollections: "All",
				empty: "No products in this connection's catalog. Use Sync to pull the products from WhatsApp.",
				table: {
					image: "Image",
					name: "Product",
					sku: "SKU",
					price: "Price",
					status: "Status",
					actions: "Actions",
				},
				status: {
					published: "Published",
					hidden: "Hidden",
					localOnly: "CRM only",
				},
				buttons: {
					sync: "Sync",
					add: "New product",
				},
				toasts: {
					synced: "Catalog synced: {{created}} new, {{updated}} updated, {{removed}} removed.",
					deleted: "Product deleted successfully.",
				},
				confirmationModal: {
					deleteTitle: "Delete product",
					deleteMessage: "Are you sure you want to delete this product? It will also be removed from the WhatsApp catalog.",
				},
				modal: {
					addTitle: "New product",
					editTitle: "Edit product",
					name: "Name",
					description: "Description",
					price: "Price",
					currency: "Currency",
					retailerId: "SKU (product code)",
					retailerIdHint: "Identifier WhatsApp uses when sending the product. If left blank, the provider generates one.",
					productUrl: "Product link",
					addImage: "Add image",
					changeImage: "Change image",
					isHidden: "Hide from public catalog",
					hint: "The product is created in the WhatsApp catalog and becomes available to send in the chat.",
					save: "Save",
					cancel: "Cancel",
					saved: "Product saved successfully.",
					validation: {
						nameRequired: "Enter the product name.",
						nameShort: "Name too short.",
						priceRequired: "Enter the price.",
						priceInvalid: "Invalid price.",
					},
				},
				picker: {
					title: "Send catalog product",
					searchPlaceholder: "Search product",
					empty: "No products found. Sync the catalog on the Product Catalog screen.",
					mode: "How to send",
					modeSingle: "Single product",
					modeList: "Product list",
					modeCatalog: "Full catalog",
					message: "Message (optional)",
					header: "List title",
					footer: "Footer (optional)",
					send: "Send",
					cancel: "Cancel",
					sent: "Product sent.",
					selectOne: "Select at least one product.",
				},
			},
			queues: {
				title: "Queues",
				table: {
					id: "ID",
					orderQueue: "Queue order (bot)",
					name: "Name",
					color: "Color",
					greeting: "Greeting message",
					actions: "Actions",
				},
				buttons: {
					add: "Add queue",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"Are you sure? It cannot be reverted! Tickets in this queue will still exist, but will not have any queues assigned.",
				},
				toasts: {
					deleted: "Queue deleted successfully.",
					hasPrompts: "Cannot delete queue. There are prompts associated with this queue. Please reassign or delete the prompts before deleting this queue.",
				},
			},
			queueSelect: {
				inputLabel: "Queues",
				selectQueue: "Select a queue",
			},
			users: {
				title: "Users",
				table: {
					id: "ID",
					name: "Name",
					email: "Email",
					profile: "Profile",
					queues: "Queues",
					defaultConnection: "Default Connection",
					allTicket: "Ticket Without Queue",
					actions: "Actions",
				},
				buttons: {
					add: "Add user",
					salesReport: "Sales Goals Report",
				},
				toasts: {
					deleted: "User deleted sucessfully.",
				},
				confirmationModal: {
					deleteTitle: "Delete",
					deleteMessage:
						"All user data will be lost. Users' open tickets will be moved to queue.",
				},
				salesReport: {
					title: "Sales Goals Report",
					period: "Period",
					user: "User",
					salesGoal: "Goal ($)",
					totalSales: "Total Sales ($)",
					achievement: "Achievement",
					actions: "Actions",
					viewDetails: "View sales details",
					noData: "No sales found in the period",
					filters: {
						startDate: "Start Date",
						endDate: "End Date",
						allUsers: "All Users",
						filter: "Filter",
					},
					details: {
						title: "Sales Details",
						totalSales: "Total Sales",
						salesCount: "Number of Sales",
						date: "Date",
						clientName: "Client",
						value: "Value",
						observations: "Observations",
						total: "TOTAL",
						noSales: "No sales found for this user in the period",
					},
				},
			},
			settings: {
				success: "Settings saved successfully.",
				title: "Settings",
				tabs: {
					options: "Options",
					kanban: "Kanban",
					schedules: "Schedules",
					companies: "Companies",
					plans: "Plans",
					email: "Email",
					cloudApi: "Cloud API",
					customFields: "Custom Fields",
					requiredFields: "Required Fields",
					help: "Help",
					empsis: "Empsis",
					templateCredits: "Template Credits",
					aiCredits: "AI Credits",
					instagramWebhooks: "IG Webhooks",
					systemAlerts: "System Alerts",
				},
				companiesManager: {
					fields: {
						name: "Name",
						cnpj: "CNPJ",
						email: "Email",
						adminPassword: "Administrator password",
						phone: "Phone",
						plan: "Plan",
						status: "Status",
						campaigns: "Campaigns",
						dueDate: "Due date",
						recurrence: "Recurrence",
						empsisToken: "Empsis token",
						empsisTokenHelper: "Used to validate the license with Empsis",
						customValue: "Custom price (R$)",
						customUsers: "Users (custom)",
						customConnections: "Connections (custom)",
					},
					options: {
						active: "Active",
						inactive: "Inactive",
						enabled: "Enabled",
						disabled: "Disabled",
					},
					recurrence: {
						MENSAL: "Monthly",
						BIMESTRAL: "Every 2 months",
						TRIMESTRAL: "Quarterly",
						SEMESTRAL: "Every 6 months",
						ANUAL: "Yearly",
					},
					validation: {
						cnpjInvalid: "Invalid CNPJ",
						cnpjRequired: "CNPJ is required",
						passwordRequired: "Password is required",
						passwordMin: "At least 5 characters",
						empsisTokenRequired: "Empsis token is required",
					},
					customization: "Customization (customer with its own price/limits — leave blank to use the plan)",
					buttons: {
						clear: "Clear",
						delete: "Delete",
						addDueDate: "+ Due date",
						user: "User",
						save: "Save",
						generateToken: "Generate token",
						recheckLicense: "Recheck license",
					},
					tokenVisibility: {
						show: "Show token",
						hide: "Hide token",
					},
					restricted: {
						title: "Restricted access",
						message: "Only the main administrator user can manage companies.",
						hint: "Contact the system administrator if you need to make changes.",
					},
					license: {
						section: "Empsis license",
						column: "License",
						columnMonitor: "License (monitor)",
						monitorTooltip: "Monitor mode: the status is checked with Empsis, but no company is blocked.",
						status: {
							noCnpj: "Blocked: no CNPJ",
							exemptInvalid: "Exempt (invalid license)",
							exempt: "Exempt",
							valid: "Valid",
							invalid: "Invalid",
							unchecked: "Not checked",
						},
						checkedAt: "Checked on {{date}}",
						token: {
							autoRenew: "Token renews automatically",
							noAutoRenew: "Token without automatic renewal",
							missing: "No Empsis token",
						},
						exemptLabel: "Exempt from license validation",
						exemptNoCnpjHint: "Without a CNPJ the company stays blocked even if exempt. Add the CNPJ to unblock it.",
					},
					tokenDialog: {
						title: "Generate Empsis token",
						description: "Empsis access user and password. They are stored encrypted so FaleCRM can generate a new token on its own when this one expires (30 days).",
						user: "Empsis user",
						password: "Empsis password",
						cancel: "Cancel",
						generate: "Generate",
					},
					grid: {
						createdAt: "Created on",
						dueDate: "Due date",
						reactivate: "Reactivate company",
						deactivate: "Deactivate company",
					},
					toasts: {
						tokenGeneratedPending: "Token generated. It will be saved together with the company.",
						tokenGeneratedSaved: "Token generated and saved for the company.",
						licenseUnavailable: "Empsis did not give a definitive answer ({{reason}}). The last status was kept.",
						noDetails: "no details",
						licenseRechecked: "License rechecked: {{status}}.",
						licenseRecheckedWithReason: "License rechecked: {{status}} ({{reason}}).",
						exemptOn: "Company marked as exempt from license validation.",
						exemptOff: "License exemption removed.",
						loadError: "Could not load the list of records",
						success: "Operation completed successfully!",
						error: "Could not complete the operation",
						reactivated: "Company reactivated successfully!",
						deactivated: "Company deactivated. Users will not be able to log in and the WhatsApp connections were disconnected.",
						statusError: "Could not change the company status",
					},
					showInactive: "Show inactive ({{count}})",
					confirm: {
						deleteTitle: "Delete record",
						deleteMessage: "Do you really want to delete this record?",
						reactivateTitle: "Reactivate the company {{name}}?",
						deactivateTitle: "Deactivate the company {{name}}?",
						reactivateMessage: "Users will regain access and WhatsApp connections with a saved session will be reconnected automatically.",
						deactivateMessage: "Users of this company will no longer be able to log in and the WhatsApp connections will be disconnected (the saved session is kept for a future reactivation).",
					},
				},
				empsis: {
					title: "Empsis integration",
					description: "The Empsis token is used to look up fixed assets (Asset fields on rental boards) and to validate the license. To generate it, enter the CNPJ, user and password used to access Empsis. FaleCRM saves the token and stores the user and password encrypted, so it can generate a new one on its own when this one expires. Each Empsis token is valid for 30 days.",
					docsLink: "API documentation",
					fields: {
						cnpj: "CNPJ",
						user: "Empsis user",
						password: "Empsis password",
						token: "Empsis API token",
						tokenPlaceholder: "No token generated yet",
						tokenHelper: "Read only. To change the token, use Generate and save above.",
					},
					buttons: {
						generate: "Generate and save",
						generating: "Generating...",
						test: "Test connection",
						testing: "Testing...",
					},
					autoRenew: {
						active: "✓ Automatic renewal on · user {{user}}",
						generatedAt: " · token generated on {{date}}",
						inactive: "Automatic renewal off: generate the token here so FaleCRM can renew it on its own.",
					},
					currentToken: "Current token",
					toasts: {
						generated: "Token generated and saved. It will be renewed automatically when it expires.",
						generatedNoRenew: "Token generated and saved, but without automatic renewal.",
					},
					errors: {
						serverUnreachable: "Could not reach the server.",
					},
					testResult: {
						ok: "Connection OK: {{count}} fixed asset item(s) found.",
						okEmpty: "Connection OK, but Empsis returned no active items.",
						failed: "Connection failed: {{reason}}",
					},
				},
				options: {
					loading: "Updating...",
					sections: {
						integrations: "INTEGRATIONS",
						asaas: "ASAAS",
						aiTransferNotify: "AI TRANSFER NOTICE",
					},
					messages: {
						updated: "Operation updated successfully.",
						updateError: "Failed to update setting.",
					},
					fields: {
						userRating: {
							label: "Ratings",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						crmConvertedQuestion: {
							label: "Conversion Question (CRM)",
							helper: "Ask \"Converted?\" when closing the ticket",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						scheduleType: {
							label: "Business Hours Management",
							options: {
								disabled: "Disabled",
								queue: "Queue",
								company: "Company",
							},
						},
						checkMsgIsGroup: {
							label: "Ignore Group Messages",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						callType: {
							label: "Accept Calls",
							options: {
								enabled: "Accept",
								disabled: "Do Not Accept",
							},
						},
						chatbotType: {
							label: "Chatbot Type",
							options: {
								text: "Text",
							},
						},
						sendGreetingAccepted: {
							label: "Send greeting when ticket is accepted",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						sendMsgTransfTicket: {
							label: "Send transfer message for queue/agent",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						sendGreetingMessageOneQueues: {
							label: "Send greeting when there is only 1 queue",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						autoManageConnection: {
							label: "Auto connection management",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						sidebarBehavior: {
							label: "Sidebar behavior",
							options: {
								expanded: "Always expanded",
								collapsed: "Collapsed (with hover)",
								collapsed_no_hover: "Collapsed (no hover)",
							},
						},
						sidebarSubmenuBehavior: {
							label: "Submenu behavior",
							options: {
								expanded: "Always expanded",
								collapsible: "Collapsible",
							},
						},
						unifyTicketsByContact: {
							label: "Contact ticket with several connections",
							helper: "One per contact: the contact has a single ticket, on any connection. One per connection: each connection has its own ticket with the contact; sending or forwarding without choosing a connection uses the agent's, and taking over a ticket does not move it to another connection.",
							options: {
								enabled: "One per contact (any connection)",
								disabled: "One per connection",
							},
						},
						groupTicketUnify: {
							label: "Group ticket with several connections",
							helper: "One per group: when more than one connection is a member of the same group there is a single ticket (the connection chosen when sending becomes the ticket's). One per connection: each connection has its own group ticket and all of them show the whole conversation.",
							options: {
								enabled: "One per group (any connection)",
								disabled: "One per connection",
							},
						},
						notifyGroupMessages: {
							label: "Notify group messages",
							helper: "Plays the sound and shows the alert for group messages too, with the same rule as individual tickets (Waiting: whoever can open the ticket; with an agent: only the agent). Each group can be muted individually.",
							options: {
								disabled: "Disabled (groups don't alert)",
								enabled: "Enabled",
							},
						},
						notifyPhoneUnreadMessages: {
							label: "Notify the phone of unread messages",
							helper: "Applies to connections with \"Show contact typing and online\" enabled. While an agent is using FaleCRM the number stays online and the phone does not notify; if a customer message stays unopened for a few minutes (default 3), the number goes offline for a few seconds so the phone notifies.",
							options: {
								enabled: "Enabled",
								disabled: "Disabled (the phone only notifies when nobody is using FaleCRM)",
							},
						},
						messageHistory: {
							label: "Message history",
							helper: "Contact: full history | Ticket: only this ticket | Connection: only same connection",
							options: {
								contact: "By contact (all messages)",
								ticket: "By ticket (isolated)",
								whatsapp: "By Connection (same connection)",
							},
						},
						ticketConnectionScope: {
							label: "Restrict tickets to the user's connections",
							helper: "When enabled, each user (except admin) only sees tickets from the connections they manage (default connection + connections assigned in the user form). With no connection assigned, they see no tickets. Disabled: current behavior (everyone sees all by queue).",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						ticketCloseWithoutInteraction: {
							label: "Close ticket without interaction",
							helper: "Controls what happens when an agent closes a ticket without ever sending a message to the contact (automatic and system messages don't count). In every mode the ticket is counted in the Dashboard \"Closed without interaction\" metric.",
							options: {
								allowed: "Allowed",
								warn: "Warn and ask for confirmation",
								blocked: "Block",
							},
						},
						askCompletionMessageOnClose: {
							label: "Ask before sending the completion message",
							helper: "When closing a ticket whose connection has a completion message configured, asks the agent whether it should be sent. Automatic closings (inactivity, chatbot, API) always send it.",
							options: {
								disabled: "Disabled (always send)",
								enabled: "Enabled (ask when closing)",
							},
						},
						transferPendingTickets: {
							label: "Transfer pending tickets",
							helper: "Shows the Transfer button on tickets that have not been accepted yet. Without a user, the ticket stays pending in the new queue/connection.",
							options: {
								disabled: "Disabled",
								enabled: "Enabled",
							},
						},
						transferToOfflineUser: {
							label: "Transfer to offline user",
							helper: "When disabled, tickets can only be transferred to users who are online (this also applies to the AI). Taking over a ticket yourself is still allowed.",
							options: {
								disabled: "Disabled",
								enabled: "Enabled",
							},
						},
						clientImport: {
							label: "Client Import",
							helper: "When enabled, allows importing clients from an external database",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						whatsappConnectionType: {
							label: "WhatsApp Connection Type",
							helper: "Defines which connection types the company can use",
							options: {
								both: "Both (Baileys + Cloud API)",
								baileys: "Baileys Only (Unofficial)",
								cloudapi: "Cloud API Only (Official Meta)",
							},
						},
						attendanceAlarmMinutes: {
							label: "Monitoring delay alarm (minutes)",
							helper: "Maximum time without response before the ticket enters alarm mode. Default: 10 minutes.",
							errors: {
								invalid: "Enter a valid value in minutes (minimum 1).",
							},
						},
						outOfHoursMessageInterval: {
							label: "Out-of-hours message interval (minutes)",
							helper: "Sends the notice once per conversation every X minutes. 0 = on every message. Default: 60.",
							errors: {
								invalid: "Enter a value in minutes between 0 and 1440.",
							},
						},
						attendanceAlarmEnabled: {
							label: "Enable monitoring alarms",
							helper: "When enabled, tickets without response enter visual alarm mode after the configured time.",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						attendanceAlarmResetEnabled: {
							label: "Allow resetting alarm",
							helper: "When enabled, adds a 'Reset Alarm' option to the ticket menu to acknowledge the alarm without sending a message to the client.",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						transcriptionApiKey: {
							label: "OpenAI key for audio transcription",
							helper: "With a key configured, received audio messages are automatically transcribed (Whisper) and shown below the player. Leave empty to disable. Each audio triggers one OpenAI API call.",
							showHide: "Show/hide API key",
						},
						aiTransferNotifyEnabled: {
							label: "AI transfer notice",
							helper: "When the AI transfers a ticket, sends a WhatsApp notice with a summary of the conversation to the configured numbers. In the AI agent, also enable \"Notify Transfer\".",
							options: {
								enabled: "Enabled",
								disabled: "Disabled",
							},
						},
						aiTransferNotifyConnectionId: {
							label: "Connection that sends the notice",
							helper: "Unofficial API (Baileys) connections only. The connection must be connected.",
							none: "None",
						},
						aiTransferNotifyNumbers: {
							label: "Numbers that receive the notice",
							helper: "Country code + area code + number, e.g. 5542999999999. Several numbers: separate with semicolons.",
							errors: {
								invalid: "Invalid number. Use country code + area code + number, e.g. 5542999999999.",
							},
						},
						asaasToken: {
							label: "Asaas Token",
						},
					},
				},
				requiredFields: {
					title: "Required registration fields",
					description: "Define which fields must be required for customer and /contacts registration.",
					sections: {
						cliente: "Customer Registration",
						contacts: "Contacts Registration (/contacts)",
					},
					buttons: {
						save: "Save configuration",
						saving: "Saving...",
					},
					messages: {
						saved: "Required fields configuration saved successfully.",
						error: "Failed to save required fields configuration.",
					},
					fields: {
						cliente: {
							NOMECLI: "Business Name / Full Name",
							NOMEFANTASIA: "Trade Name",
							PESSOA: "Person Type",
							STATUS: "Status",
							USUARIO_RESPONSAVEL: "Responsible User",
							INSCESTCLI: "State Registration",
							insc_municipal: "Municipal Registration",
							suframa: "SUFRAMA",
							contribuinte_icms: "ICMS Taxpayer",
							DDDCLI: "Area Code (Phone)",
							E_MAIL: "Email",
							FONECLI: "Phone",
							DDDCELULAR: "Area Code (Mobile)",
							CELULAR: "Mobile",
							site: "Website",
							CEPCLI: "ZIP Code",
							ENDCLI: "Address",
							NUMERO: "Number",
							BAIRROCLI: "District",
							CIDADECLI: "City",
							ESTADOCLI: "State",
							LIMITE: "Credit Limit",
							metas_vendas: "Sales Goals",
							potencial_vendas: "Sales Potential",
							acoes_vendas: "Sales Actions",
							OBS: "Notes",
							CGCCLI: "CNPJ",
							CPFCLI: "CPF",
						},
						contacts: {
							name: "Name",
							number: "Number",
							email: "Email",
						},
					},
				},
				kanban: {
					title: "Kanban Settings",
					description: "Manage card creation rules, scheduling, and inactivity timing.",
					loading: "Updating...",
					options: {
						enabled: "Enabled",
						disabled: "Disabled",
					},
					requireSchedule: {
						label: "Require schedule when creating a card",
						helper: "When enabled, cards can only be moved across columns with a schedule filled in.",
					},
					creationMode: {
						label: "Card creation on ticket closure",
						helper: "Defines how the system behaves when a ticket is closed.",
						options: {
							optional: "Optional",
							mandatory: "Mandatory",
							hidden: "Hidden",
						},
					},
					duplicateContact: {
						label: "Duplicate card for the same contact",
						helper: "Defines what happens when the contact already has a card while creating one from the ticket.",
						options: {
							disabled: "Disabled",
							warn: "Warn",
							blocked: "Block",
						},
					},
					duplicateContactScope: {
						label: "Where to look for the contact's card",
						helper: "Defines the reach of the duplicate card check.",
						options: {
							column: "Same column of the board",
							board: "Any column of the board",
							any: "Any board",
						},
					},
					codcli: {
						label: "Send CODCLI in Kanban contracts",
						helper: "When enabled, sends the linked client's CODCLI for contract generation.",
					},
					contactMethods: {
						title: "Relationship contact methods",
						description: "Choose which contact methods are available when registering a relationship on Kanban.",
						helper: "These options will be shown in Kanban relationship forms.",
						placeholder: "E.g.: Prospecting",
						addButton: "Add contact method",
						removeButton: "Remove contact method",
						options: {
							visit: "Visit",
							budget: "Budget",
							followUp: "Follow-up",
							negotiation: "Negotiation",
							afterSales: "After-sales",
							complaint: "Complaint",
							referral: "Referral",
						},
					},
					inactivity: {
						title: "Card inactivity time",
						description: "Set day thresholds and colors for each visual inactivity level.",
						rules: "All time values are in days. The Warning color is applied when the Warning threshold is reached, the Critical color when the Critical threshold is reached, and the Urgent color when the Urgent threshold is reached.",
						enableLabel: "Highlight cards by inactivity",
						enableHelper: "When disabled, cards do not receive visual highlighting based on inactivity time.",
						noPermission: "You do not have permission to change inactivity timing rules.",
						warningDays: "Warning (days)",
						warningColor: "Warning (color)",
						warningDaysHelper: "Ex: 1",
						dangerDays: "Critical (days)",
						dangerColor: "Critical (color)",
						dangerDaysHelper: "Ex: 3",
						criticalDays: "Urgent (days)",
						criticalColor: "Urgent (color)",
						criticalDaysHelper: "Ex: 5",
					},
					messages: {
						scheduleSaved: "Schedule setting updated successfully.",
						creationModeSaved: "Card creation mode updated successfully.",
						duplicateContactSaved: "Duplicate card check updated successfully.",
						codcliSaved: "CODCLI setting updated successfully.",
						contactMethodsSaved: "Relationship contact methods updated successfully.",
						inactivitySaved: "Inactivity timing setting updated successfully.",
					},
					errors: {
						update: "Failed to update the setting.",
						contactMethodsEmpty: "Select at least one contact method.",
						invalidDays: "Enter a valid day value (0 or greater).",
						invalidDaysOrder: "Day thresholds must follow: Warning <= Critical <= Urgent.",
						invalidColor: "Enter a valid hexadecimal color (e.g., #ff0000).",
					},
				},
				settings: {
					clientImport: {
						name: "Customer import",
						note: "Enables or disables importing customers from the external database. When disabled, the 'Import customers' button is hidden.",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
					webhookKommoSendCodcli: {
						name: "Send CODCLI in Kanban contracts",
						note: "When enabled, moving a card to the contract-generation column sends the CODCLI of the customer linked to the card. If disabled or no customer is linked, the default CODCLI (1) is used.",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
					userCreation: {
						name: "User creation",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
					unifyTicketsByContact: {
						name: "Unify conversations by contact",
						note: "When enabled, all conversations from a contact are unified regardless of the number. When disabled, each WhatsApp number will have a separate conversation.",
						options: {
							enabled: "Enabled",
							disabled: "Disabled",
						},
					},
					groupTicketUnify: {
						name: "Group ticket with several connections",
						note: "One per group: a single ticket per group, on any connection. One per connection: each connection has its own group ticket and all of them show the whole conversation.",
						options: {
							enabled: "One per group (any connection)",
							disabled: "One per connection",
						},
					},
				},
				email: {
					title: "Email Settings (SMTP)",
					description: "Configure the SMTP server details for sending emails from the system",
					fields: {
						host: "SMTP server",
						hostPlaceholder: "smtp.example.com",
						port: "Port",
						user: "SMTP user",
						userPlaceholder: "user@example.com",
						password: "SMTP password",
						from: "Sender email",
						fromPlaceholder: "noreply@company.com",
						fromName: "Sender name",
						fromNamePlaceholder: "CRM System",
						secure: "Use SSL/TLS (recommended for port 465)",
						active: "Active configuration",
					},
					buttons: {
						update: "Update",
						test: "Test Email",
					},
					testDialog: {
						title: "Send Test Email",
						description: "Enter a valid email address to receive the test email:",
						email: "Test email",
						emailPlaceholder: "test@example.com",
						send: "Send",
					},
					toasts: {
						requiredFields: "Please fill in all required fields",
						updated: "Email settings updated successfully!",
						saved: "Email settings saved successfully!",
						saveError: "Error saving email settings",
						fillBeforeTest: "Please fill in the settings before testing",
						invalidEmail: "Please enter a valid email address",
						testError: "Error sending test email",
					},
				},
				instagram: {
					title: "Instagram Settings (Instagram Login)",
					info: {
						beforeProduct: "Credentials for the",
						afterProduct: "product of your Meta app. They are used for the simplified login (OAuth) and for verifying webhook signatures. Get the Instagram App ID and App Secret at",
						path: "> your app > Instagram > API setup.",
					},
					managedByServer: {
						title: "The Meta app is already configured on this server.",
						description: "The credentials below are ignored — the simplified login uses the server variables (IG_APP_ID, IG_APP_SECRET, IG_REDIRECT_URI). The fields remain available only for installations that have not migrated yet.",
					},
					fields: {
						appIdHelper: "Instagram app ID (Instagram product of the Meta app)",
						appIdPlaceholder: "E.g. 123456789012345",
						appSecretHelper: "Used for OAuth and for the webhook HMAC verification",
						verifyTokenHelper: "Token you define to verify the webhook in the Meta dashboard",
						graphVersion: "Graph API version",
						latest: "Latest",
						redirectUriHelper: "Must be identical to the URI registered in the Meta app (Instagram > API setup > Business Login)",
					},
					webhookUrl: "Webhook URL (configure it in the Meta dashboard, Instagram product > Webhooks, fields messages and comments):",
					suggestedRedirectUri: "Suggested OAuth Redirect URI:",
					save: "Save Settings",
					toasts: {
						loadError: "Error loading Instagram settings",
						saved: "Instagram settings saved successfully!",
						saveError: "Error saving Instagram settings",
					},
				},
				instagramWebhooks: {
					title: "Instagram Webhook Monitor",
					description: "Follow in real time the webhooks Meta sends to this system. Use the \"Test\" button in the Meta dashboard (or \"Simulate\" below) and see here whether the event arrived, in which format, whether the signature is valid and whether the backend recognizes the field to process it.",
					status: {
						processed: "Processed",
						received: "Received",
						ignored: "Ignored",
						error: "Error",
					},
					simulated: "simulated",
					recognized: "Recognized",
					recognizedTooltip: "There is dedicated processing in the backend",
					unhandled: "No handler",
					unhandledTooltip: "The webhook arrives, but there is no dedicated processing yet",
					signatureInvalid: "invalid",
					signatureInvalidTooltip: "Invalid HMAC signature",
					signatureValidTooltip: "HMAC signature verified",
					payload: "Received payload",
					legend: {
						recognized: "recognized (processed by the backend)",
						unhandled: "no dedicated handler (arrives, but is not processed yet)",
					},
					simulateAll: "Simulate all fields",
					table: {
						receivedAt: "Received at",
						field: "Field",
						signature: "Signature",
						connection: "Connection",
						detail: "Detail",
					},
					empty: "No webhook received yet. Click \"Simulate\" or trigger a test in the Meta dashboard.",
					toasts: {
						loadError: "Could not load the webhook events.",
						cleared: "Events cleared.",
						clearError: "Failed to clear events.",
						simulated: "Simulated events generated (one per field).",
						simulateError: "Failed to simulate events.",
					},
				},
				onSpace: {
					title: "OnSpace Integration",
					description: "Whenever a contact sends a WhatsApp message, ChatCRM will automatically notify OnSpace to register the lead in the Appointment Review.",
					fields: {
						url: "OnSpace URL",
						urlPlaceholder: "https://myonspace.com",
						urlHelper: "Base URL of the OnSpace system (no trailing slash)",
						salaoId: "Salon ID",
						salaoIdPlaceholder: "E.g. 123",
						salaoIdHelper: "Salon/clinic ID in OnSpace (required)",
						apiKey: "OnSpace API Key",
						apiKeyPlaceholder: "Leave blank if you do not use authentication",
						apiKeyHelper: "Sent in the x-api-key header (optional)",
					},
					toasts: {
						salaoIdInvalid: "Salon ID is required and must be an integer.",
						saved: "OnSpace settings saved successfully!",
						saveError: "Error saving OnSpace settings.",
					},
				},
				schedulesUpdated: "Schedules updated successfully.",
				systemAlerts: {
					title: "System alerts via WhatsApp",
					description: "Sends a WhatsApp notice when the system detects congestion in database access — the signal that precedes service freezes. This setting applies to the whole installation: the alert covers all companies, and the chosen connection can belong to any of them. The notice is sent at most once every 15 minutes, and a second message confirms when everything is back to normal.",
					enabled: "Send alerts via WhatsApp",
					connection: "Sending connection",
					noConnection: "None",
					connectionHint: "Any connection in the system, from any company. Prefer one that is not the main service connection.",
					numbers: "Destination numbers",
					numbersHint: "Separate with semicolons, including country and area codes.",
					validNumbers: "{{count}} valid number.",
					validNumbers_plural: "{{count}} valid numbers.",
					invalidEntries: "{{count}} entry will be ignored because it does not look like a number.",
					invalidEntries_plural: "{{count}} entries will be ignored because they do not look like a number.",
					sendTest: "Send test alert",
					testHint: "The test ignores the minimum interval and uses the configuration already saved — save before testing.",
					toasts: {
						loadError: "Could not load the alert settings.",
						saved: "Alert settings saved.",
						saveError: "Could not save the alert settings.",
						testSent: "Test alert sent to {{count}} number.",
						testSent_plural: "Test alert sent to {{count}} numbers.",
						testNotSent: "Could not send: {{reason}}.",
						unknownError: "unknown error",
						testError: "Failed to trigger the test alert.",
					},
				},
				cloudApi: {
					title: "Meta Cloud API Global Settings",
					info: "These settings are global and shared across all Cloud API connections. The App Secret and the Verify Token are defined in the Meta App Dashboard and are unique per app.",
					managedByServer: "The credentials below are ignored — the simplified login uses the server variables (META_APP_ID, META_APP_SECRET, META_CONFIG_ID). The fields remain available only for installations that have not migrated yet.",
					embeddedSignup: {
						title: "Embedded Signup (1-click connection)",
						description: "Set the Facebook App ID and the Config ID to let users connect WhatsApp Business with a single click, without manually entering the WABA ID, Phone Number ID and Token. Get these values at",
					},
					globalSection: "Global Settings",
					fields: {
						appIdHelper: "Meta app ID (Settings > Basic menu in the App Dashboard)",
						configIdHelper: "WhatsApp Embedded Signup configuration ID (WhatsApp > API Setup > Embedded Signup)",
						appSecretHelper: "Meta app secret (Settings > Basic menu in the App Dashboard)",
						apiVersion: "API version",
					},
					webhookUrl: "Webhook URL (configure it in the Meta App Dashboard):",
					toasts: {
						loadError: "Error loading Cloud API settings",
						saved: "Cloud API settings saved successfully!",
						saveError: "Error saving Cloud API settings",
					},
				},
			},
			messagesList: {
				system: {
					ratedHidden: "⭐ Customer rated the service on {{date}} (Ticket #{{ticket}})",
					rated: "⭐ Customer rated the service {{rate}} out of {{max}} on {{date}} (Ticket #{{ticket}})",
					closedBy: "Service closed by {{user}} on {{date}} (Ticket #{{ticket}})",
					takenBy: "Ticket taken by ({{user}}) - {{date}}",
					transferredBy: "Ticket transferred by ({{user}}) - From {{from}} to {{to}} - {{date}}",
					transferredFromTo: "Ticket transferred from {{from}} to {{to}} - {{date}}",
					transferredToPendingQueue: "Ticket transferred by ({{user}}) - From {{from}} to Pending in queue {{queue}} - {{date}}",
					transferredToPendingNoQueue: "Ticket transferred by ({{user}}) - From {{from}} to Pending with no queue - {{date}}",
					started: "Ticket started - {{queue}} ({{user}}) - {{date}}",
					systemUser: "System",
					adminQueue: "ADMINISTRATIVE",
					queueFallback: "Queue",
				},
				chips: {
					unknownDate: "unknown date",
					ticketMissing: "Ticket #{{ticket}} (not found) — messages from {{date}}",
					openedExternal: "Ticket opened by an externally sent message on {{date}} (Ticket #{{ticket}})",
					openedByAgent: "Service started by {{user}} on {{date}} (Ticket #{{ticket}})",
					openedByCustomer: "Ticket opened by a customer message on {{date}} (Ticket #{{ticket}})",
				},
				header: {
					assignedTo: "Assigned to:",
					buttons: {
						return: "Return",
						resolve: "Resolve",
						reopen: "Reopen",
						accept: "Accept",
					},
				},
				emptyChat: "Say hello to your new contact!",
				transcription: {
					label: "Transcription:",
					processing: "Transcribing audio…",
					retry: "Try again",
				},
				media: {
					downloading: "Downloading media…",
					downloadingShort: "Downloading…",
					failed: "This media could not be downloaded.",
					retry: "Try again",
					unavailable: "Media unavailable",
					download: "Download",
				},
				mediaViewer: {
					open: "Open in viewer",
					goToMessage: "Go to message",
					zoomIn: "Zoom in",
					zoomOut: "Zoom out",
				},
				jumpNotFound: "The selected message was not found in this ticket history.",
				jumpTooOld: "This message is too far back for a direct jump. Scroll the history to reach it.",
				jumpToQuoted: "Go to the quoted message",
				documentCard: {
					label: "Document",
					open: "Open",
					download: "Download",
				},
				interactive: {
					viewOptions: "View options",
					poll: "Poll",
					pollSelectOne: "Select one option",
					pollSelectMany: "Select one or more options",
				},
				catalog: {
					productTitle: "Product",
					productsTitle: "Products",
					orderTitle: "Order",
					orderTotal: "Total",
					orderLoading: "Loading order items…",
					orderFailed: "Could not load the items of this order.",
					sku: "SKU",
					unnamedProduct: "Unnamed product",
				},
				forwardSelection: {
					selectedSingle: "{{count}} message selected",
					selectedMultiple: "{{count}} messages selected",
					forwardMessages: "Forward messages",
					cancelSelection: "Cancel selection",
				},
				forwarded: {
					label: "Forwarded",
					frequently: "Forwarded many times",
				},
				instagram: {
					postTooltip: "Post: {{caption}}",
					openCommentedPost: "Open the commented post",
					commentedPostAlt: "Commented post",
					comment: "Comment",
					publicReply: "Public reply",
					viewPost: "view post",
					reply: "Reply",
					replyPublic: "Reply on the post (public)",
					replyDm: "Reply via DM",
					dm: {
						storyMention: "Mentioned you in their story",
						storyReply: "Replied to your story",
						reel: "Reel",
						post: "Post",
						shared: "Shared content",
						watchHere: "Watch here",
						closePlayer: "Close player",
						openInInstagram: "Open on Instagram",
						downloadMedia: "Download media",
						storyExpired: "The story media was not downloaded in time; stories expire after 24h.",
						reelPlayerTitle: "Instagram reel",
					},
				},
				contactFallback: "Contact",
				you: "You",
				mention: {
					noNumber: "Could not start a direct conversation: the participant has no number available.",
					dialogTitle: "Mentioned participant",
					dialogText: "You mentioned this participant in the group.",
					name: "Name:",
					number: "Number:",
					notAvailable: "Not available",
					chatPrivately: "Chat privately",
				},
				sharedContact: {
					unnamed: "Unnamed contact",
					startMissingNumber: "Could not start the conversation: no number found in the shared contact.",
					startSaveFailed: "Could not start the conversation: failed to save the shared contact.",
					alreadyExists: "The contact already exists in the database.",
					saved: "Contact saved successfully!",
					saveMissingNumber: "Could not save: no number found in the shared contact.",
					saveFailed: "Could not save the shared contact.",
					shared: "Shared contact",
					quotedWithNumber: "Contact: {{name}} - {{number}}",
					quotedName: "Contact: {{name}}",
					quotedMultiple: "Shared contacts: {{count}}",
					summaryOthers: "{{name}} and {{count}} other contact",
					summaryOthers_plural: "{{name}} and {{count}} other contacts",
					count: "{{count}} contact",
					count_plural: "{{count}} contacts",
					viewAll: "View all",
					chat: "Chat",
				},
				delivery: {
					failedWithCode: "Sending failed: {{error}} (Meta code: {{code}})",
					failedWithError: "Sending failed: {{error}}",
					failed: "Message sending failed",
				},
				pendingAck: {
					timeoutHandled: "Callback timeout already handled with a manual template resend.",
					timeoutHandledShort: "Timeout already handled with a resend.",
					timeoutMinutes: "No status confirmation from Meta for more than {{minutes}} minutes. {{reason}}",
					timeoutLong: "No status confirmation from Meta for a long time. {{reason}}",
					defaultReason: "The message was accepted on the initial send, but we did not receive a sent/delivered/read/failed callback.",
					awaitingMeta: "Message sent to Meta and awaiting status confirmation (sent/delivered/read). This can happen due to a delay in the webhook callback.",
					processing: "Message being processed. We have not received a status confirmation yet.",
				},
				reactions: {
					allTab: "All {{total}}",
					empty: "No reactions in this category.",
					clickToRemove: "Click to remove",
					react: "React",
					search: "Search reaction",
					notFound: "No emoji found",
					categories: {
						search: "Results",
						recent: "Recent reactions",
						people: "Smileys & People",
						nature: "Animals & Nature",
						foods: "Food & Drink",
						activity: "Activities",
						places: "Travel & Places",
						objects: "Objects",
						symbols: "Symbols",
						flags: "Flags",
						custom: "Custom",
					},
				},
				connectionBadge: {
					withDetails: "Connection: {{details}}",
					withId: "Connection #{{id}}",
				},
				historyLoaded: "HISTORY - All previous conversations have been loaded",
				deleted: {
					byAgent: "This message was deleted by the agent",
					byContact: "This message was deleted by the contact",
					hide: "Hide message",
					show: "View message",
				},
				quoted: {
					statusAuthor: "{{author}} • Status",
				},
				callLog: {
					call: "Call",
					started: "Started",
					video: "Video call",
					voice: "Voice call",
					fallback: "{{call}} {{status}} on {{date}}",
				},
				edited: {
					label: "Edited",
					original: "Original: {{body}}",
				},
				openTicketFailed: "Could not open the conversation. Ticket data not found.",
				existingTicket: {
					title: "Conversation already exists",
					text: "There is already an open conversation with this contact. Do you want to open the existing conversation?",
					agent: "Agent:",
					queue: "Queue:",
					open: "Open Conversation",
				},
				goToBottom: "Go to the end of the conversation",
			},
			forwardMessageModal: {
				windowClosed: "The 24-hour window for {{name}} is closed. Open the ticket with this contact and send a template to reopen it before forwarding.",
				title: "Forward messages",
				selectedCount: "Selected messages: {{count}}",
				previewPrefix: "Preview",
				previewContactWithNumber: "Contact: {{name}} - {{number}}",
				previewContactWithName: "Contact: {{name}}",
				previewContactWithNumberOnly: "Contact: {{number}}",
				previewSharedContact: "Shared contact",
				previewSharedLocation: "Shared location",
				previewMedia: "Media ({{mediaType}})",
				previewFile: "file",
				searchContactLabel: "Search contact (name or number)",
				loadMoreContacts: "Load more contacts",
				forwarding: "Forwarding...",
				forward: "Forward",
				cancel: "Cancel",
				successSingle: "Message forwarded to {{name}}",
				successMultiple: "{{count}} messages forwarded to {{name}}",
				stoppedOnError: "Forwarding stopped due to an error in one of the messages.",
			},
			messagesInput: {
				recordingPaused: "Paused",
				placeholderOpen: "Type a message",
				placeholderClosed: "Reopen or accept this ticket to send a message.",
				placeholderReopen: "Type to reopen and send message...",
				signMessage: "Sign",
				tooltips: {
					pauseRecording: "Pause recording",
					resumeRecording: "Resume recording",
					emojiPicker: "Emoji",
					moreActions: "More actions",
					attachFile: "Attach file",
					sendContact: "Send contact",
					quickMessages: "Quick messages",
					stickers: "Stickers",
					sendTemplate: "Send template",
					signMessage: "Sign messages",
					sendMessage: "Send message",
					voiceMessage: "Voice message",
				},
				failedAudio: {
					title: "Audio not sent",
					resend: "Resend audio",
					discard: "Discard audio",
				},
				errors: {
					ticketIdNotFound: "Ticket ID not found",
					noQueueAccess: "You do not have access to this ticket's queue",
					otherOpenTicketSentHere: "This contact already has another conversation in progress. The message was sent in this ticket, which stays as it is.",
					noQueueAccessNewTicket: "You do not have access to this ticket's queue. The message was sent in a new ticket of yours.",
				},
				replyPreview: {
					contactWithNumber: "Contact: {{name}} - {{number}}",
					contact: "Contact: {{value}}",
					sharedContact: "Shared contact",
				},
				attachedFile: "File attached",
				mentionFallbackName: "Contact",
				connection: {
					selectedTooltip: "Connection: {{name}}",
					selectedFallback: "Selected",
					select: "Select connection",
				},
				cloudApi: {
					windowExpiredPlaceholder: "⏰ 24h window expired — click 📋 to send a template",
					windowExpiredInline: "24h window expired. Use the template button to send a message.",
					windowExpiredTitle: "24-hour window expired",
					windowExpiredText: "The 24-hour window has expired. Send a message template to start a new conversation.",
					noTemplates: "No approved message templates found. Create templates and submit them for approval on the Templates page.",
					selectTemplate: "Select a template",
					preview: "Preview:",
					emptyBody: "(No body text)",
					variables: "Variables:",
					variableLabel: "Variable {{name}}",
					templateSent: "Template sent successfully!",
					sending: "Sending...",
					send: "Send",
				},
				stickers: {
					removed: "Sticker removed from the library.",
					openTicketToPull: "Open a ticket to pull stickers from the conversation.",
					pulled: "Stickers pulled from WhatsApp: {{count}}.",
					pullFromWhatsApp: "Pull from WhatsApp",
					empty: "No stickers found in this ticket's WhatsApp conversation.",
					favorites: "Favorites",
					library: "Library",
					removeFromLibrary: "Remove from library",
					removeTitle: "Remove sticker",
					removeConfirm: "This sticker will be removed from the library for all users in the company.",
				},
				media: {
					dropHere: "Drop the file here to send",
					filesSelected: "{{count}} file selected",
					filesSelected_plural: "{{count}} files selected",
					captionPlaceholder: "Type a caption (optional)...",
				},
				instagram: {
					replyingPublic: "Replying on the post (public)",
					replyingDm: "Replying via DM",
				},
			},
			messageSearchDrawer: {
				title: "Search messages",
				placeholder: "Search",
				prompt: "Search for messages in this conversation.",
				noResults: "No messages found.",
				previousTicket: "Previous ticket",
				loadMore: "Load more",
				you: "You",
				contact: "Contact",
			},
			contactDrawer: {
				header: "Contact details",
				headerGroup: "Group details",
				buttons: {
					edit: "Edit contact",
					merge: "Merge contact",
				},
				favorites: {
					title: "Starred messages",
					none: "None",
					noMessages: "No starred messages for this contact.",
					loadMore: "Load more",
					loading: "Loading...",
					previewAlt: "Media preview",
					ticketLabel: "Ticket",
					senderYou: "You",
					senderContact: "Contact",
					messageDeleted: "Message deleted",
					image: "Image",
					media: "Media",
					messageWithoutContent: "Message without content",
					ticketNotFound: "Could not locate this message ticket.",
					messageFromAnotherTicket: "This message belongs to another ticket. Open that ticket to jump to it."
				},
				shared: {
					mediaTab: "Media",
					docsTab: "Docs",
					linksTab: "Links",
					loadMore: "Load more",
					loading: "Loading...",
					previewAlt: "Preview",
					image: "Image",
					video: "Video",
					document: "Document",
					link: "Link",
					empty: {
						media: "No shared media in this chat.",
						docs: "No shared documents in this chat.",
						links: "No shared links in this chat."
					}
				},
				extraInfo: "Other information",
				toasts: {
					merged: "Contact merged successfully. The update will be applied automatically.",
				},
				members: {
					title: "Group Members",
					count: "{{count}} member",
					count_plural: "{{count}} members",
					groupLabel: "Group",
					updated: "Updated {{when}}",
					syncTooltip: "Update members manually",
					syncing: "Updating members...",
					synced: "Group members updated!",
					loadError: "Could not load the members. Check that WhatsApp is connected and try syncing again.",
					admin: "Admin",
					startConversation: "Start conversation",
					participantNotLinked: "This participant is not linked to a registered contact.",
					alreadyAttended: "This contact is already being handled by {{name}}.",
					anotherAttendant: "another agent",
					lastSync: {
						now: "just now",
						minutes: "{{count}} min ago",
						hours: "{{count}}h ago",
					},
				},
			},
			mergeContactModal: {
				title: "Merge Contacts",
				currentContact: "Current contact:",
				searchPlaceholder: "Search contact by name or number...",
				noContactsFound: "No contacts found",
				searchHint: "Type at least 2 characters to search",
				warning: "This action cannot be undone!",
				mergeInfoTitle: "What will be merged:",
				mergeInfo1: "All tickets will be moved to the main contact",
				mergeInfo2: "All messages will be migrated",
				mergeInfo3: "The duplicate contact will be removed",
				success: "Contacts merged successfully!",
				buttons: {
					cancel: "Cancel",
					merge: "Merge",
					merging: "Merging...",
				},
				selectContact: "Select a contact to merge",
			},
			ticketActionButtons: {
				mandatoryKanbanCard: "Kanban Card is mandatory",
				mandatoryKanbanCardMessage: "You need to create a Kanban card before closing this ticket.",
				optionalKanbanCard: "Create a Kanban card?",
				optionalKanbanCardMessage: "Would you like to create a Kanban card for this ticket?",
				confirmKanbanCard: "Create a Kanban card before closing?",
				createCard: "Create Card",
				skip: "Skip",
				withoutInteractionTitle: "Close without interaction?",
				withoutInteractionMessage:
					"You have not sent any message to the contact on this ticket. Close it anyway? The ticket will be counted as closed without interaction.",
				completionMessageTitle: "Send completion message?",
				completionMessageText: "This ticket's connection is set to send the message below to the contact when the ticket is closed:",
				completionMessageBatchHint: "Your answer applies to all selected tickets.",
				completionMessageSend: "Send",
				completionMessageSkip: "Don't send",
				tooltips: {
					searchMessages: "Search messages",
					createKanbanCard: "Create Kanban card",
					call: "Call via WhatsApp",
					inCall: "On a call with this contact",
				},
			},
			calls: {
				status: {
					dialing: "Starting call…",
					ringing: "Ringing…",
					answering: "Connecting…",
					incoming: "Incoming call",
					connected: "On call · {{time}}",
					endedReasons: {
						ended: "Call ended",
						rejected: "Call declined",
						missed: "Not answered",
						mediaFailed: "Audio connection failed",
					},
				},
				actions: {
					answer: "Answer",
					ignore: "Ignore",
					hangUp: "Hang up",
					mute: "Mute microphone",
					unmute: "Unmute microphone",
					openTicket: "Open ticket",
					close: "Close",
				},
				permission: {
					title: "Call via WhatsApp",
					noPermission: "{{name}} has not allowed calls from this number yet. Send a permission request: the customer gets a button on WhatsApp to accept (valid for 7 days).",
					waitingReply: "Request sent. As soon as the customer accepts, the call button is enabled here.",
					windowClosed: "The 24-hour window is closed, so the request can't be sent now. Wait for the customer to message you or send a call permission template from the template picker.",
					requestLimit: "The permission request limit for this contact was reached (1 per day, 2 per week). Available again on {{date}}.",
					callLimit: "The call limit for this contact was reached. Available again on {{date}}.",
					granted: "{{name}} allowed calls.",
					callingDisabled: "Calling is not enabled on this connection. An administrator can enable it in Connections → edit the connection → Calls.",
					lookupFailed: "Couldn't check this contact's call permission right now.",
					staleCall: "You have a previous call that is still marked as in progress. End it to place a new call.",
					request: "Request permission",
					requestAgain: "Request again",
					requested: "Permission request sent to the contact.",
					callNow: "Call now",
					callAnyway: "Try calling",
					endStaleCall: "End previous call",
				},
				errors: {
					alreadyInCall: "You are already on a call.",
					microphone: "Couldn't use the microphone. Allow microphone access in the browser and try again.",
					insecureContext: "Browsers only allow the microphone on HTTPS pages. Open the system using its https address.",
				},
				warnings: {
					otherOpenTicketCalledHere: "This contact already has another conversation in progress. The call will be made from this ticket, which stays as it is.",
					noQueueAccessNewTicket: "You don't have access to this ticket's queue. The call will be made from a new ticket of yours.",
				},
				settings: {
					title: "Calls (WhatsApp Calling)",
					help: "Lets agents place and answer voice calls in the browser. Requires a number with a messaging limit of at least 2,000 conversations per day and the “calls” webhook field subscribed in the Meta app. Business-initiated calls are billed per minute by Meta. Incoming calls follow the “Accept Call” setting.",
					status: "Calls on this number",
					enabled: "Enabled",
					disabled: "Disabled",
					iconVisibility: "Call icon for customers",
					iconDefault: "Visible",
					iconHidden: "Hidden",
					callbackPermission: "Customers who call grant callback permission",
					save: "Save calls",
					saved: "Call settings saved.",
					loadError: "Couldn't read this number's call settings.",
				},
			},
			linkClienteModal: {
				title: "Link contact to client",
				contact: "Contact",
				searchLabel: "Search client",
				searchHelper: "Search by trade name, company name or CNPJ",
				newCliente: "Create new client",
				success: "Contact successfully linked to client!",
				alreadyLinked: "This contact is already linked to this client.",
				buttons: {
					cancel: "Cancel",
					link: "Link",
				},
			},
			ticketOptionsMenu: {
				registerAppointment: "Contact notes",
				appointmentsModal: {
					title: "Contact notes",
					textarea: "Note",
					placeholder: "Enter the information you want to record here",
				},
				schedule: "Schedule",
				delete: "Delete",
				transfer: "Transfer",
				linkCliente: "Link to client",
				agents: "Agents",
				confirmationModal: {
					title: "Delete ticket #",
					titleFrom: "from contact ",
					message: "Attention! All ticket's related messages will be lost.",
				},
				buttons: {
					delete: "Delete",
					cancel: "Cancel",
				},
			},
			ticketAIAgentModal: {
				title: "Agents",
				searchLabel: "Select AI agent",
				searchPlaceholder: "Search by agent name",
				noOptions: "No agents found",
				none: "None",
				currentAgent: "Current agent: {{agent}}",
				clearHumanAttendant: "Remove current human attendant from this conversation",
				buttons: {
					cancel: "Cancel",
					remove: "Remove agent",
					save: "Save",
				},
				success: {
					assigned: "AI agent assigned successfully.",
					removed: "AI agent removed successfully.",
				},
				errors: {
					invalidTicket: "Invalid ticket to assign agent.",
					selectAgent: "Select an agent to continue.",
				},
				warnings: {
					humanAttendantLinked: "Attention: while a human attendant is assigned, the AI does not reply to messages.",
				},
			},
			confirmationModal: {
				buttons: {
					confirm: "Ok",
					cancel: "Cancel",
				},
			},
			messageOptionsMenu: {
				edit: "Edit",
				details: "Message details",
				editModal: {
					title: "Edit message",
					body: "New message",
					cancel: "Cancel",
					confirm: "Save",
				},
				editErrors: {
					tooOld: "This message can no longer be edited (15-minute limit).",
					cannotEdit: "Could not edit the message.",
					notFromMe: "You can only edit messages you sent.",
					deleted: "Deleted messages cannot be edited.",
					media: "Media messages cannot be edited.",
				},
				delete: "Delete",
				deleteForEveryone: "Delete for everyone",
				deleteForMe: "Delete for me",
				copy: "Copy message",
				copyImage: "Copy Image",
				saveImage: "Save image",
				favorite: "Star message",
				unfavorite: "Unstar message",
				markPending: "Mark as pending",
				unmarkPending: "Remove pending",
				reply: "Reply",
				replyPrivate: "Reply privately",
				forward: "Forward",
				copySuccess: "Message copied successfully.",
				copyImageUrlSuccess: "Image URL copied successfully.",
				copyError: "Could not copy the message.",
				replyPrivateError: "Could not identify the sender number.",
				confirmationModal: {
					title: "Delete message?",
					titleDeleteForEveryone: "Delete for everyone?",
					titleDeleteForMe: "Delete for me?",
					message: "This action cannot be reverted.",
					messageDeleteForEveryone: "This message will be deleted for you and the recipient.",
					messageDeleteForMe: "This message will be deleted only for you. The recipient will still be able to see it.",
				},
				stickerNoMedia: "This sticker has no media to save.",
				stickerAdded: "Sticker added to my stickers.",
				imageFilename: "image",
				addToMyStickers: "Add to my stickers",
			},
			pendingMessages: {
				title: "Pending Messages",
				rowsPerPage: "Rows per page",
				filters: {
					search: "Search message",
					contact: "Contact",
					dateFrom: "Pending from",
					dateTo: "Pending until",
					pendingUser: "Created by",
					whatsapp: "WhatsApp channel",
					status: "Status",
					all: "All",
				},
				table: {
					pendingAt: "Pending date/time",
					contact: "Contact",
					pendingUser: "User",
					whatsapp: "WhatsApp",
					status: "Status",
					message: "Message",
					actions: "Actions",
					removePending: "Remove pending",
					viewMessages: "View messages",
					messageDeleted: "Message deleted",
					messageWithoutContent: "Message without content",
					image: "Image",
					video: "Video",
					audio: "Audio",
					document: "Document",
					sticker: "Sticker",
					fileTypePrefix: "File",
				},
				statuses: {
					none: "No status",
					aguardando: "Waiting",
					em_analise: "In Review",
					em_producao: "In Production",
					retornar_cliente: "Return to Client",
					finalizado: "Done",
					atrasado: "Overdue",
				},
				toasts: {
					removed: "Pending removed successfully",
					statusUpdated: "Status updated",
					ticketNotFound: "Ticket not found for this message.",
					loadConversationFailed: "Couldn't load this ticket's conversation.",
				},
			},
			backendErrors: {
				ERR_CALL_NO_PERMISSION: "The contact hasn't allowed calls from this number yet.",
				ERR_CALL_NOT_ENABLED: "Calling is not enabled on this number at Meta.",
				ERR_CALL_RECEIVER_UNCALLABLE: "This contact can't receive WhatsApp calls.",
				ERR_CALL_DUPLICATE: "There is already an ongoing call with this contact.",
				ERR_CALL_LIMIT_REACHED: "This number's call limit was reached. Try again later.",
				ERR_CALL_PERMISSION_REQUEST_LIMIT: "Permission request limit reached for this contact (1 per day, 2 per week).",
				ERR_CALL_BUSINESS_INITIATED_UNAVAILABLE: "Business-initiated calls are not available for this number.",
				ERR_CALL_TEMPORARILY_DISABLED: "Calling on this number is temporarily disabled by Meta due to low quality.",
				ERR_CALL_CANNOT_BE_ENABLED: "Calling can't be enabled: the number needs a messaging limit of at least 2,000 conversations per day.",
				ERR_CALL_PERMANENT_PERMISSION_EXISTS: "The contact already allowed calls with no expiration; no need to ask again.",
				ERR_CALL_PREREQUISITES_MISSING: "Missing prerequisites: subscribe the “calls” webhook field in the Meta app.",
				ERR_CALL_RECIPIENT_NOT_ALLOWED: "Test number: the contact is not in the allowed recipients list.",
				ERR_CALL_PERMISSION_LOOKUP_RATE_LIMIT: "Too many permission checks in a short time. Please wait a moment.",
				ERR_CALL_FAILED: "Meta refused the call. Try again shortly.",
				ERR_CALL_BAILEYS_FAILED: "The call could not be placed on this connection. Try again shortly.",
				ERR_CALL_ENGINE_FAILED: "The calling engine for this connection did not start. Try again shortly.",
				ERR_CALL_LINE_BUSY: "This connection is already on another call.",
				ERR_CALL_CONNECTION_OFFLINE: "The WhatsApp connection is not connected.",
				ERR_CALL_INVALID_SDP: "The browser couldn't prepare the call audio.",
				ERR_CALL_ALREADY_IN_PROGRESS: "You already have a call in progress.",
				ERR_CALL_ALREADY_ANSWERED: "Another agent already answered this call.",
				ERR_CALL_NOT_FOUND: "This call has already ended.",
				ERR_CALL_NOT_YOURS: "This call belongs to another agent.",
				ERR_CALL_GROUP_UNSUPPORTED: "Calls to groups are not supported.",
				ERR_CALL_PROVIDER_UNAVAILABLE: "Calls are only available on official API connections.",
				ERR_CALL_PERMISSION_WINDOW_CLOSED: "The 24-hour window is closed: the permission request can only be sent with an approved template.",
				ERR_CALL_INVALID_SETTINGS: "Invalid call settings.",
				ERR_RATING_MESSAGE_REQUIRED: "Write the rating question.",
				ERR_RATING_INVALID_WINDOW: "The reply window must be between 1 and 168 hours.",
				ERR_INVALID_PASSWORD: "Incorrect password.",
				ERR_CLOUDAPI_WINDOW_CLOSED: "The 24-hour window has expired. Send a message template to start a new conversation.",
				ERR_CLOUDAPI_REVOKE_UNSUPPORTED: "Meta refused to delete this message for the recipient: the \"delete for everyone\" feature is not yet available for Official API numbers. The message was NOT deleted on the customer's device.",
				ERR_META_SEND_TEMPLATE: "Error sending template through the WhatsApp Cloud API.",
				ERR_CANNOT_EDIT_CLOUDAPI_MESSAGE: "Official API (Meta) connections do not allow editing messages already sent. The message stays as it is on the customer's device.",
				ERR_USER_NO_QUEUE_ACCESS: "You do not have access to this ticket's queue.",
				ERR_TICKETS_FROM_OTHER_USERS: "This contact has open tickets with other attendants. Please take over one of the existing tickets before sending messages.",
				ERR_PENDING_TICKET_WITH_AGENT: "This ticket is pending with an AI agent attached. Take over the ticket to remove the AI before sending messages.",
				ERR_TRANSFER_USER_OFFLINE: "This user is offline. Transferring to offline users is disabled in the settings.",
				ERR_APPLYING_REACTION: "Could not apply the reaction.",
				ERR_POLL_UNSUPPORTED_CHANNEL: "This connection does not allow voting in polls.",
				ERR_POLL_INVALID: "This message is not a valid poll.",
				ERR_POLL_INVALID_OPTION: "Invalid option for this poll.",
				ERR_POLL_TOO_MANY_OPTIONS: "This poll does not allow that many options.",
				ERR_POLL_SECRET_NOT_FOUND: "Could not vote: the key for this poll is no longer available.",
				ERR_SENDING_POLL_VOTE: "Could not send the vote.",
				ERR_BILLING_ADDONS_NOT_CONFIGURED: "Billing add-ons are not configured.",
				ERR_CAMPAIGN_MESSAGE_OR_TEMPLATE_REQUIRED: "Enter a message or a template for the campaign.",
				ERR_CAMPAIGN_NOT_FOUND: "Campaign not found.",
				ERR_CAMPAIGN_RESPONSE_QUEUE_INVALID: "The campaign response queue is invalid.",
				ERR_CAMPAIGN_RESPONSE_QUEUE_NOT_FOUND: "The campaign response queue was not found.",
				ERR_CAMPAIGN_RESPONSE_ROUTING_INCOMPLETE: "The campaign response routing settings are incomplete.",
				ERR_CAMPAIGN_RESPONSE_WINDOW_INVALID: "The campaign response window is invalid.",
				ERR_CAMPAIGN_SMS_MESSAGE_REQUIRED: "An SMS campaign needs a message.",
				ERR_CAMPAIGN_SMS_NO_MEDIA: "SMS campaigns do not accept attachments.",
				ERR_CAMPAIGN_SMS_TOO_LONG: "The SMS campaign message is too long.",
				ERR_CAMPAIGN_TEMPLATE_REQUIRED: "Select a template for the campaign.",
				ERR_CATALOG_CHANNEL_UNSUPPORTED: "This channel does not support product catalogs.",
				ERR_CATALOG_DELETE_UNAVAILABLE: "Products cannot be deleted in this catalog.",
				ERR_CATALOG_DISCOVERY_FAILED: "Could not find the catalog on Meta.",
				ERR_CATALOG_MESSAGE_UNSUPPORTED: "This connection does not support sending catalog products.",
				ERR_CATALOG_META_PERMISSION: "No permission to access the catalog on Meta.",
				ERR_CATALOG_MULTI_UNSUPPORTED: "This connection does not support sending several products at once.",
				ERR_CATALOG_NOT_BUSINESS: "The WhatsApp account is not a business account.",
				ERR_CATALOG_NOT_FOUND: "Catalog not found.",
				ERR_CATALOG_NO_CONNECTION: "No connection available for the catalog.",
				ERR_CATALOG_NO_PRODUCT_SELECTED: "Select at least one product.",
				ERR_CATALOG_PRODUCT_NO_IMAGE: "The product has no image.",
				ERR_CATALOG_PRODUCT_NO_RETAILER_ID: "The product has no code (retailer ID).",
				ERR_CATALOG_PROVIDER_FAILURE: "Communication with the catalog provider failed.",
				ERR_CATALOG_SEND_UNAVAILABLE: "Sending products is unavailable on this connection.",
				ERR_CATALOG_SYNC_FAILED: "Catalog synchronization failed.",
				ERR_CATALOG_SYNC_UNAVAILABLE: "Catalog synchronization is unavailable on this connection.",
				ERR_CATALOG_TICKET_REQUIRED: "Select the ticket to send the product.",
				ERR_CATALOG_UPDATE_UNAVAILABLE: "Products cannot be edited in this catalog.",
				ERR_CATALOG_WABA_NOT_CONFIGURED: "WhatsApp Business account (WABA) not configured.",
				ERR_CATALOG_WAPP_NOT_CONNECTED: "The WhatsApp connection is not connected.",
				ERR_CATALOG_WRONG_CONNECTION: "The product belongs to another connection.",
				ERR_CHAT_MESSAGE_NOT_FOUND: "Chat message not found.",
				ERR_CLOUDAPI_ACCOUNT_NOT_REGISTERED: "Number not registered on the Official API (Cloud API).",
				ERR_CLOUDAPI_CONNECTION_NOT_FOUND: "Official API connection not found.",
				ERR_CLOUDAPI_DISPLAY_NAME_NOT_APPROVED: "The display name has not been approved by Meta yet.",
				ERR_CLOUDAPI_INVALID_CONFIG: "Invalid Official API configuration.",
				ERR_CLOUDAPI_INVALID_MEDIA_FORMAT: "Media format not accepted by the Official API.",
				ERR_CLOUDAPI_INVALID_MEDIA_MIME: "File type not accepted by the Official API.",
				ERR_CLOUDAPI_MEDIA_TYPE_MISMATCH: "The media type does not match what the template expects.",
				ERR_CLOUDAPI_RATE_LIMIT: "Official API sending limit reached. Try again in a moment.",
				ERR_CLOUDAPI_SUBSCRIPTION: "Failed to subscribe to the Official API events (webhook).",
				ERR_CONTACT_DATA_REQUIRED: "Enter at least one contact detail (phone, e-mail or Instagram).",
				ERR_CONTACT_EMAIL_REQUIRED: "The contact has no e-mail.",
				ERR_CONTACT_INSTAGRAM_REQUIRED: "The contact has no Instagram.",
				ERR_CONTACT_NOT_FOUND: "Contact not found.",
				ERR_CONTACT_NOT_ON_WHATSAPP: "The contact's number is not on WhatsApp.",
				ERR_CONTACT_NO_INSTAGRAM_ID: "The contact has no Instagram ID.",
				ERR_CONTACT_NO_PHONE_NUMBER: "The contact has no phone number.",
				ERR_DOCUMENTTEMPLATE_CONTENT_TOO_LARGE: "The document template content is too large.",
				ERR_DOCUMENT_MISSING_VARIABLES: "Variables are missing to generate the document.",
				ERR_EMAIL_CONNECTION_NOT_FOUND: "E-mail connection not found.",
				ERR_EMAIL_DELIVERY_REJECTED: "The e-mail server rejected the delivery.",
				ERR_EMAIL_SETTING_ALREADY_EXISTS: "An e-mail configuration already exists.",
				ERR_EMAIL_SETTING_NOT_FOUND: "E-mail configuration not found.",
				ERR_EMPTY_CHAT_MESSAGE: "The message cannot be empty.",
				ERR_FORBIDDENWORD_DUPLICATED: "This forbidden term is already registered.",
				ERR_GROUPS_RESYNC_UNSUPPORTED: "This connection does not support resyncing groups.",
				ERR_INSTAGRAM_INVALID_CONFIG: "Invalid Instagram configuration.",
				ERR_INSTAGRAM_UNSUPPORTED_MEDIA: "Media type not supported by Instagram.",
				ERR_INSTAGRAM_WINDOW_CLOSED: "The Instagram 24-hour window has expired. Wait for the contact to reply.",
				ERR_INVALID_ATTENDANCE_ALARM_MINUTES: "Invalid attendance alarm minutes.",
				ERR_INVALID_OUT_OF_HOURS_INTERVAL: "Invalid out-of-hours message interval (0 to 1440 minutes).",
				ERR_INVALID_CONTACT_ID: "Invalid contact ID.",
				ERR_INVALID_DATE_FILTER: "Invalid date filter.",
				ERR_INVALID_DATE_RANGE_FILTER: "Invalid date range.",
				ERR_INVALID_EMAIL_CONNECTION: "Invalid e-mail connection.",
				ERR_INVALID_MUTE_DURATION: "Invalid mute duration.",
				ERR_INVALID_PAYMENT_DATA: "Invalid payment data.",
				ERR_INVALID_PENDING_STATUS: "Invalid pending status.",
				ERR_INVALID_SMS_CONNECTION: "Invalid SMS connection.",
				ERR_INVALID_SOLICITACAO_ID: "Invalid request ID.",
				ERR_INVALID_SOLICITACAO_STATUS: "Invalid request status.",
				ERR_INVALID_TICKET_ID: "Invalid ticket ID.",
				ERR_INVALID_UPDATED_AT_FILTER: "Invalid update date filter.",
				ERR_INVALID_USER_ID: "Invalid user ID.",
				ERR_INVALID_WHATSAPP_ID: "Invalid connection ID.",
				ERR_MESSAGE_NOT_IN_SCOPE: "The message does not belong to this ticket.",
				ERR_MESSAGE_NO_TICKET: "The message is not linked to a ticket.",
				ERR_NOT_INSTAGRAM_CONNECTION: "This connection is not an Instagram connection.",
				ERR_NO_CATALOG_PRODUCT_FOUND: "Catalog product not found.",
				ERR_NO_DOCUMENTTEMPLATE_FOUND: "Document template not found.",
				ERR_NO_FILENAME: "File name not provided.",
				ERR_NO_FILE_UPLOADED: "No file uploaded.",
				ERR_NO_FORBIDDENWORD_FOUND: "Forbidden term not found.",
				ERR_NO_QUICKMESSAGE_MEDIA_FOUND: "Quick reply attachment not found.",
				ERR_NO_SOLICITACAO_DESENVOLVIMENTO_FOUND: "Development request not found.",
				ERR_NO_TAGPHRASE_FOUND: "Tag phrase not found.",
				ERR_NO_WHATSAPP_FOUND: "Connection not found.",
				ERR_PUBLIC_API_INVALID_TOKEN: "Invalid public API token.",
				ERR_PUBLIC_API_NOT_CONFIGURED: "Public API not configured.",
				ERR_PUBLIC_API_NO_TOKEN: "Public API token not provided.",
				ERR_QUICKMESSAGE_MAX_MEDIAS: "Quick reply attachment limit reached.",
				ERR_QUOTED_MSG_NOT_IN_CHAT: "The quoted message does not belong to this chat.",
				ERR_SENDING_CATALOG_PRODUCT: "Error sending the catalog product.",
				ERR_SENDING_CLOUDAPI_MSG_INVALID_CONNECTION: "Invalid Official API connection for sending.",
				ERR_SENDING_INSTAGRAM_MSG_INVALID_CONNECTION: "Invalid Instagram connection for sending.",
				ERR_SENDING_WAPP_MSG_CONTACT_NOT_FOUND: "Contact not found to send the message.",
				ERR_SMSBARATO_REQUEST_FAILED: "Request to SMS Barato failed.",
				ERR_SMSDEV_REQUEST_FAILED: "Request to SMSDev failed.",
				ERR_TAGPHRASE_DUPLICATED: "This phrase is already registered.",
				ERR_TAGPHRASE_INVALID_PHRASE: "Invalid phrase.",
				ERR_TEMPLATE_CREDIT_INVALID_CATEGORY: "Invalid template category.",
				ERR_TEMPLATE_HEADER_MEDIA_REQUIRED: "The template requires a media header.",
				ERR_TEMPLATE_MISSING_FIELDS: "Required template fields are missing.",
				ERR_TEMPLATE_NOT_APPROVED: "The template has not been approved by Meta yet.",
				ERR_TEMPLATE_NOT_FOUND: "Template not found.",
				ERR_TEMPLATE_SYNC_META_LIST: "Could not load the template list from Meta.",
				ERR_TEMPLATE_VARIABLES_MISMATCH: "The variables provided do not match the template's.",
				ERR_TEMPLATE_WABA_MISMATCH: "The template belongs to another WhatsApp Business account.",
				ERR_TEST_EMAIL_REQUIRED: "Enter an e-mail for the test.",
				ERR_TICKET_NOT_FOUND: "Ticket not found.",
				ERR_TICKET_OR_CONTACT_REQUIRED: "Provide the ticket or the contact.",
				ERR_TICKET_REQUIRED: "Provide the ticket.",
				ERR_TRANSFER_USER_REQUIRED: "Select the user to transfer to.",
				ERR_WABA_CONNECTION_NOT_FOUND: "WhatsApp Business (WABA) connection not found.",
				ERR_WABA_NOT_CONFIGURED: "WhatsApp Business account (WABA) not configured.",
				ERR_WABA_OR_WHATSAPP_REQUIRED: "Provide the WABA account or the connection.",
				ERR_WAPP_NOT_CLOUDAPI: "This connection is not an Official API connection.",
				ERR_WAPP_NOT_FOUND: "WhatsApp connection not found.",
				ERR_WAPP_VALIDATION_ABORTED: "Number validation cancelled.",
				ERR_WHATSAPP_CONNECTION_EXISTS: "A connection with this number already exists.",
				ERR_WHATSAPP_NAME_REQUIRED: "Enter the connection name.",
				ERR_WITIME_REQUEST_FAILED: "Request to Witime failed.",
				ERR_MEDIA_URL_REQUIRED:
					"Could not identify the selected sticker.",
				ERR_STICKER_REMOVED_FROM_LIBRARY:
					"This sticker has already been removed from the library.",
				ERR_MESSAGES_REPORT_INVALID_PERIOD:
					"Provide a valid report period (start and end date).",
				ERR_MESSAGES_REPORT_TERM_TOO_SHORT:
					"Type at least 3 characters in the search term.",
				ERR_AI_CREDIT_NOT_ENABLED:
					"AI credit billing is not enabled for your company.",
				ERR_AI_CREDIT_COMPANY_NOT_LINKED:
					"This company is not linked to iaHub yet, so there is nowhere to send the credit. Link it in Settings → AI Credits.",
				ERR_AI_CREDIT_INVALID_VALUE:
					"Invalid AI credit top-up amount.",
				ERR_AI_CREDIT_INVALID_SETTING:
					"Invalid AI credit setting.",
				ERR_AI_CREDIT_INVALID_RANGE:
					"The minimum credit cannot be greater than the maximum credit.",
				ERR_AI_CREDIT_TOPUP_NOT_FOUND:
					"AI credit top-up not found.",
				ERR_AI_CREDIT_TOPUP_NOT_PAID:
					"This top-up has not been paid yet: there is no credit to send to iaHub.",
				ERR_AI_HUB_NOT_CONFIGURED:
					"iaHub is not configured in this environment (AI_HUB_BASE_URL and AI_HUB_RESELLER_KEY in the backend .env).",
				ERR_AI_HUB_UNAUTHORIZED:
					"iaHub rejected the reseller key. Check AI_HUB_RESELLER_KEY.",
				ERR_AI_HUB_UNAVAILABLE:
					"Could not reach iaHub right now. Please try again in a moment.",
				ERR_AI_HUB_COMPANY_NOT_FOUND:
					"Company not found in this iaHub reseller.",
				ERR_AI_HUB_RESELLER_CONFLICT:
					"That iaHub company already belongs to another reseller.",
				ERR_AI_HUB_AGENT_NOT_FOUND:
					"Agent not found in iaHub. Check the agent ID — a single extra or missing character keeps the AI from replying.",
				ERR_PROMPT_AGENT_OTHER_HUB_COMPANY:
					"This company is billed with AI credits and the selected agent belongs to another iaHub company: its usage would not come out of this company's balance. Use an agent from the linked company.",
				ERR_AI_CREDIT_AGENT_MISMATCH:
					"This company cannot be billed while linked to that iaHub company: AI usage is charged to the company that owns the agent, and some prompts use another company's agent.",
				ERR_AI_CREDIT_HUB_COMPANY_IN_USE:
					"That iaHub company is already linked to another CRM company.",
				ERR_AI_CREDIT_LINK_HAS_BALANCE:
					"The previous iaHub company has purchased balance; the link was not changed.",
				ERR_TEMPLATE_CREDIT_INSUFFICIENT:
					"Insufficient template credit balance. Top up in Billing to keep sending templates.",
				ERR_TEMPLATE_CREDIT_NOT_ENABLED:
					"Template billing is not enabled for your company.",
				ERR_TEMPLATE_CREDIT_INVALID_VALUE:
					"Invalid top-up amount.",
				ERR_TEMPLATE_CREDIT_ADJUST_BELOW_ZERO:
					"The adjustment would leave the balance negative.",
				ERR_TEMPLATE_CREDIT_REASON_REQUIRED:
					"Provide a reason for the balance adjustment.",
				ERR_TICKET_CLOSE_WITHOUT_INTERACTION:
					"You have not interacted with the contact on this ticket.",
				ERR_TICKET_CLOSE_WITHOUT_INTERACTION_BLOCKED:
					"This ticket cannot be closed: you have not interacted with the contact yet.",
				ERR_TICKET_CLOSE_ASK_COMPLETION_MESSAGE:
					"Confirm whether the completion message should be sent before closing the ticket.",
				ERR_NO_OTHER_WHATSAPP:
					"There must be at lest one default WhatsApp connection.",
				ERR_NO_DEF_WAPP_FOUND:
					"No WhatsApp CONNECTED. Please connect at least one WhatsApp number on the connections page.",
				ERR_NO_BAILEYS_WAPP_FOUND:
					"No WhatsApp (QR Code) connection available to validate numbers. Please connect a WhatsApp session on the connections page.",
				ERR_WAPP_NOT_INITIALIZED:
					"This WhatsApp session is not initialized. Check connections page.",
				ERR_WAPP_CHECK_CONTACT:
					"Could not check WhatsApp contact. Check connections page.",
				ERR_WAPP_INVALID_CONTACT: "This is not a valid whatsapp number.",
				ERR_CHECK_NUMBER:
					"The number provided is not registered on WhatsApp or does not exist.",
				ERR_MEDIA_MIMETYPE_NOT_FOUND:
					"Could not identify the media file type.",
				ERR_INVALID_MIMETYPE:
					"Invalid file type.",
				ERR_IMPORT_CONTACTS_FAILED:
					"Failed to load WhatsApp contacts. Please try again later.",
				ERR_WHATSAPP_NOT_CONNECTED:
					"This WhatsApp connection is not connected. Please check the connections page.",
				ERR_NO_CONTACTS_SYNCED_YET:
					"The phone address book could not be read for this connection right now. Try again in a few minutes; if it persists, import the contacts from a spreadsheet or add them with \"Add Contact\".",
				ERR_IMPORT_NO_FILE:
					"No file was uploaded. Select a CSV, XLS or XLSX spreadsheet.",
				ERR_IMPORT_INVALID_FILE_TYPE:
					"Unsupported file type. Upload a CSV, XLS or XLSX spreadsheet.",
				ERR_IMPORT_TOO_MANY_ROWS:
					"The spreadsheet has too many rows. Split it into files with at most 5000 rows.",
				ERR_WAPP_DOWNLOAD_MEDIA:
					"Could not download media from WhatsApp. Check connections page.",
				ERR_INVALID_CREDENTIALS: 
          "Authentication error. Please try again.",
				ERR_SENDING_WAPP_MSG:
					"Error sending WhatsApp message. Check connections page.",
				ERR_CONTACT_NOT_IN_CONNECTION:
					"This contact does not belong to the current connection. Check if the WhatsApp connection is the same one used to start the conversation.",
				ERR_GROUP_NOT_IN_CONNECTION:
					"This group does not belong to the current connection. Use a WhatsApp connection that is part of this group.",
				ERR_WAPP_NOT_CONNECTED:
					"WhatsApp connection is DISCONNECTED. Check the connections page and reconnect.",
				ERR_CLOUDAPI_GROUP_UNSUPPORTED:
					"Cloud API does not support sending messages to groups.",
				ERR_DELETE_WAPP_MSG: 
          "Couldn't delete message from WhatsApp.",
				ERR_EDITING_WAPP_MSG:
					"Could not edit WhatsApp message.",
				ERR_MESSAGE_NOT_FOUND:
					"Message not found.",
				ERR_CANNOT_EDIT_MESSAGE_NOT_FROM_ME:
					"You can only edit messages sent by you.",
				ERR_CANNOT_EDIT_DELETED_MESSAGE:
					"Deleted messages cannot be edited.",
				ERR_MESSAGE_TOO_OLD_TO_EDIT:
					"This message can no longer be edited (15-minute limit).",
				ERR_CANNOT_EDIT_MEDIA_MESSAGE:
					"Media messages cannot be edited.",
				ERR_MESSAGE_BODY_REQUIRED:
					"Message body is required.",
				ERR_INVALID_REACTION:
					"Invalid reaction.",
				ERR_OTHER_OPEN_TICKET:
					"There's already an open ticket for this contact.",
				ERR_SESSION_EXPIRED:
          "Session expired. Please login.",
				ERR_COMPANY_BLOCKED:
					"Your subscription has expired. Go to the Billing page and settle the payment to keep using the system.",
				ERR_COMPANY_INACTIVE:
					"This company is inactive. Please contact support for more information.",
				ERR_LICENSE_INVALID:
					"This company's license is not valid. Please contact Empsis to renew it.",
				ERR_LICENSE_CHECK_DISABLED:
					"License validation is not enabled on this installation.",
				ERR_COMPANY_EMPSIS_TOKEN_REQUIRED:
					"Enter the company's Empsis token. Use the Generate token button if you don't have one.",
				ERR_EMPSIS_TOKEN_MISSING_FIELDS:
					"Enter the Empsis CNPJ, user and password to generate the token.",
				ERR_EMPSIS_TOKEN_REFUSED:
					"Empsis refused to generate the token. Check the CNPJ, user and password.",
				ERR_EMPSIS_UNAVAILABLE:
					"Empsis did not respond. Please try again in a moment.",
				ERR_EMPSIS_TOKEN_READONLY:
					"The Empsis token cannot be typed in. Generate a new one with the Generate and save button.",
				ERR_SAME_PLAN:
					"The company is already on this plan.",
				ERR_PLAN_QR_CONNECTION_NOT_ALLOWED:
					"The company's plan does not include WhatsApp connections via QR Code.",
				ERR_PLAN_CHANGE_NOT_ALLOWED:
					"Changing plans is not available for this company. Please contact support.",
				ERR_MP_LEGACY_SUBSCRIPTION_REQUIRES_CARD:
					"Your current subscription uses Mercado Pago's legacy model and its amount cannot be changed. Re-register your card on the Billing page (My plan section) to complete the change.",
				ERR_ADDON_CHANGE_ALREADY_PENDING:
					"There is already a pending add-on change. Complete the payment or cancel it before requesting another.",
				ERR_ADDON_MIXED_CHANGE:
					"Add and remove add-ons in separate operations.",
				ERR_ADDON_INVALID_QUANTITY:
					"Invalid add-on quantity.",
				ERR_ADDON_NOT_AN_UPGRADE:
					"The requested change does not add any add-on.",
				ERR_ADDON_NOT_A_DOWNGRADE:
					"The requested change does not remove any add-on.",
				ERR_CHANGE_REQUEST_NOT_FOUND:
					"Plan change request not found.",
				ERR_CHANGE_REQUEST_ALREADY_PAID:
					"This change's prorated amount was already paid — it will be applied automatically.",
				ERR_CHANGE_REQUEST_NOT_CANCELLABLE:
					"This change can no longer be cancelled.",
				ERR_CARD_TOKEN_REQUIRED:
					"A card is required for this operation.",
				ERR_INVOICE_WITHOUT_VALUE:
					"This invoice has no billing amount.",
				ERR_CUSTOM_VALUE_INVALID:
					"Invalid customization values.",
				ERR_PLAN_WITHOUT_VALUE:
					"This plan has no billing amount set. Please contact support.",
				ERR_COMPANY_WITHOUT_PLAN:
					"The company has no plan assigned. Please contact support.",
				ERR_SUBSCRIPTION_ALREADY_ACTIVE:
					"There is already an active automatic subscription for this company.",
				ERR_NO_ACTIVE_SUBSCRIPTION:
					"There is no active automatic subscription to cancel.",
				ERR_INVOICE_NOT_FOUND:
					"Invoice not found.",
				ERR_INVOICE_ALREADY_PAID:
					"This invoice has already been paid.",
				ERR_MP_PLAN_NOT_SYNCED:
					"Could not sync the plan with Mercado Pago. Please try again shortly.",
				ERR_MP_PIX_UNAVAILABLE:
					"Pix payments are unavailable right now. Please use a credit card or contact support.",
				ERR_USER_CREATION_DISABLED:
					"User creation was disabled by administrator.",
				ERR_NO_PERMISSION: 
          "You don't have permission to access this resource.",
				ERR_WAPP_TOKEN_IN_USE:
          "This token is already used by another connection.",
				ERR_WAPP_NAME_IN_USE:
          "A connection with this name already exists in this company.",
				ERR_DUPLICATED_CONTACT: 
          "A contact with this number already exists.",
				ERR_CONTACT_SAVE_FAILED:
					"Could not save the contact. Please try again.",
				ERR_CONTACT_UPDATE_FAILED:
					"Could not update the contact. Please try again.",
				ERR_NO_SETTING_FOUND: 
          "No setting found with this ID.",
				ERR_NO_CONTACT_FOUND: 
          "No contact found with this ID.",
				ERR_NO_TICKET_FOUND: 
          "No ticket found with this ID.",
				ERR_NO_USER_FOUND: 
          "No user found with this ID.",
				ERR_TICKET_INACTIVE: 
          "This ticket belongs to a deleted connection and can't be reopened, transferred or answered.",
				ERR_NO_WAPP_FOUND: 
          "No WhatsApp found with this ID.",
				ERR_CREATING_MESSAGE:
          "Error while creating message on database.",
				ERR_CREATING_TICKET: 
          "Error while creating ticket on database.",
				ERR_FETCH_WAPP_MSG:
					"Error fetching the message in WhtasApp, maybe it is too old.",
				ERR_QUEUE_COLOR_ALREADY_EXISTS:
					"This color is already in use, pick another one.",
			ERR_WAPP_GREETING_REQUIRED:
				"Greeting message is required if there is more than one queue.",
			ERR_CHANNEL_SINGLE_QUEUE_ONLY:
				"This channel type allows only one queue.",
			ERR_QUEUE_HAS_PROMPTS:
				"Cannot delete queue. There are prompts associated with this queue. Please reassign or delete the prompts before deleting this queue.",
			ERR_NO_TICKETNOTE_FOUND:
				"No ticket note found with this ID.",
			ERR_NO_HELP_FOUND:
				"No help found with this ID.",
			ERR_NO_SCHEDULE_FOUND:
				"No schedule found with this ID.",
			ERR_QUEUE_NOT_FOUND:
				"No queue found with this ID.",
			ERR_NO_DIALOG_FOUND:
				"No integration found with this ID.",
			ERR_NO_PROMPT_FOUND:
				"No prompt found with this ID.",
			ERR_NO_PLAN_FOUND:
				"No plan found with this ID.",
			ERR_NO_KANBAN_BOARD_FOUND:
				"No Kanban board found with this ID.",
			ERR_NO_KANBAN_CARD_FOUND:
				"No Kanban card found with this ID.",
			ERR_NO_KANBAN_COLUMN_FOUND:
				"No Kanban column found with this ID.",
			ERR_KANBAN_CARD_DUPLICATE_CONTACT:
				"This contact already has a card. Confirm to create it anyway.",
			ERR_KANBAN_CARD_DUPLICATE_CONTACT_BLOCKED:
				"This contact already has a card — creating duplicate cards is blocked for this company.",
			ERR_NO_MESSAGE_FOUND:
				"No message found with this ID.",
			ERR_NO_COMPANY_FOUND:
				"No company found with this ID.",
			ERR_COMPANY_INVALID_CNPJ:
				"Invalid CNPJ. Please enter a valid CNPJ.",
			ERR_COMPANY_CNPJ_ALREADY_EXISTS:
				"A company with this CNPJ already exists.",
			ERR_COMPANY_NAME_ALREADY_EXISTS:
				"A company with this name already exists.",
			ERR_COMPANY_INVALID_NAME:
				"Invalid company name. Enter at least 2 characters.",
			ERR_COMPANY_INVALID_EMAIL:
				"Enter a valid email address.",
			ERR_USER_EMAIL_ALREADY_EXISTS:
				"This email is already in use. Sign in or use another email.",
			ERR_COMPANY_INVALID_PASSWORD:
				"Enter a password with at least 5 characters.",
			ERR_NO_CONTACTLISTITEM_FOUND:
				"No contact list item found with this ID.",
			ERR_NO_CONTACTLIST_FOUND:
				"No contact list found with this ID.",
			ERR_NO_QUICKMESSAGE_FOUND:
				"No quick message found with this ID.",
			ERR_NO_TAG_FOUND:
				"No tag found with this ID.",
			ERR_NO_FILE_FOUND:
				"No file found with this ID.",
			ERR_NO_RATING_FOUND:
				"No rating found with this ID.",
			ERR_NO_CHAT_FOUND:
				"No chat found with this ID.",
			ERR_NO_CLIENTE_FOUND:
				"No client found with this ID.",
			ERR_COMMENT_REQUIRES_CONTENT_OR_MEDIA:
				"Comment requires content or media.",
			ERR_NO_COMMENT_FOUND:
				"No comment found with this ID.",
			ERR_NO_BAILEYS_DATA_FOUND:
				"No Baileys data found with this ID.",
			ERR_NO_CAMPAIGN_FOUND:
				"No campaign found with this ID.",
			ERR_NO_ANNOUNCEMENT_FOUND:
				"No announcement found with this ID.",
			ERR_USER_NOT_FOUND:
				"User not found.",
			ERR_NO_SUPER:
				"You don't have super administrator permission.",
			ERR_QUEUE_INVALID_COLOR: "Enter a valid color for the queue.",
			ERR_QUEUE_INVALID_NAME: "The queue name must have at least 2 characters.",
			ERR_QUEUE_NAME_ALREADY_EXISTS: "A queue with this name already exists.",
			ERR_QUEUE_LIMIT_REACHED: "Your plan's queue limit has been reached.",
			ERR_QUICKMESSAGE_INVALID_NAME: "The shortcut and the message must have at least 3 characters.",
			ERR_QUICKMESSAGE_REQUIRED: "Fill in the shortcut and the message.",
			ERR_PROMPT_NAME_INVALID: "Enter the prompt name.",
			ERR_PROMPT_AIHUB_AGENTID_REQUIRED: "Enter the iaHub agent ID.",
			ERR_PROMPT_COOLDOWN_INVALID: "Enter a number of minutes equal to or greater than zero.",
			ERR_PROMPT_COOLDOWN_MAX: "The maximum pause time is 10080 minutes (7 days).",
			ERR_TICKETNOTE_INVALID_NAME: "The note must have at least 3 characters.",
			ERR_MEDIA_REDOWNLOAD_FAILED: "Unable to download the media again. Try again later.",
			ERR_TRANSCRIPTION_DISABLED: "Audio transcription is disabled. An administrator can set the OpenAI key in Settings → Options.",
			ERR_TRANSCRIPTION_NOT_RETRYABLE: "This transcription can't be retried right now: it was already retried or is in progress.",
			ERR_INSTAGRAM_STORY_EXPIRED: "The story has expired on Instagram (stories are available for 24h).",
			ERR_INSTAGRAM_MEDIA_UNAVAILABLE: "Instagram no longer provides this file.",
			ERR_INSTAGRAM_REEL_NO_FILE: "Instagram does not provide the reel file; use \"Open on Instagram\".",
			ERR_WHATSAPP_ID_REQUIRED: "Select a connection.",
			ERR_WHATSAPP_LIMIT_REACHED: "Your plan's connection limit has been reached.",
			ERR_USER_LIMIT_REACHED: "Your plan's user limit has been reached.",
			ERR_CONTACT_NOT_GROUP: "This contact is not a group.",
			ERR_GROUP_CONNECTION_NOT_FOUND: "Unable to find the connection for this group.",
			ERR_SYSTEM_ALERTS_CONNECTION_REQUIRED: "Select the connection that will send the alerts.",
			ERR_SYSTEM_ALERTS_NUMBERS_REQUIRED: "Enter at least one valid destination number.",
			ERR_PAIRING_INVALID_NUMBER: "Invalid number. Enter country code + area code + number, digits only (e.g. 5511999998888).",
			ERR_PAIRING_BAILEYS_ONLY: "Phone number login is only available for Baileys connections.",
			ERR_ADMIN_ONLY: "Access denied. Only administrators can access this resource.",
			ERR_FORWARD_MESSAGE_FAILED: "Unable to forward the message.",
			ERR_PROFILE_NOT_FOUND: "Profile not found.",
			ERR_PROFILE_NAME_REQUIRED: "Enter the profile name.",
			ERR_PROFILE_NAME_ALREADY_EXISTS: "A profile with this name already exists in this company. Choose another name.",
			ERR_SCHEDULE_CONNECTION_INVALID: "The selected connection does not belong to the company.",
			ERR_SCHEDULE_INVALID_DATE: "Invalid schedule date/time.",
			ERR_SCHEDULE_IN_PAST: "Messages cannot be scheduled in the past (2-minute tolerance).",
			ERR_FORBIDDEN_OTHER_COMPANY: "This record belongs to another company.",
			ERR_CAMPAIGN_DELETE_IN_PROGRESS: "A campaign in progress cannot be deleted.",
			ERR_CAMPAIGN_UPDATE_NOT_ALLOWED: "Only inactive, scheduled or canceled campaigns can be edited.",
			ERR_CAMPAIGN_INVALID_NAME: "The campaign name must have at least 3 characters.",
			ERR_CAMPAIGN_REQUIRED: "Enter the campaign name.",
			ERR_PEDIDO_NOT_FOUND: "Order not found.",
			ERR_PEDIDO_ITEMS_REQUIRED: "The order must contain at least one item.",
			ERR_PEDIDO_DELETE_NOT_ALLOWED: "Orders that were already delivered or shipped cannot be deleted.",
			ERR_INVALID_RESET_TOKEN: "Check the token you entered.",
			ERR_CONTACTLIST_INVALID_NAME: "The list name must have at least 3 characters.",
			ERR_CONTACTLIST_REQUIRED: "Enter the list name.",
			ERR_CONTACTLISTITEM_INVALID_NAME: "The contact name must have at least 3 characters.",
			ERR_CONTACTLISTITEM_REQUIRED: "Enter the contact name.",
			ERR_FORBIDDENWORD_INVALID_TERM: "The term must have at least 2 characters.",
			ERR_FORBIDDENWORD_REQUIRED: "Enter the term.",
			ERR_TAGPHRASE_REQUIRED: "Enter the phrase.",
			ERR_TAGPHRASE_TAG_REQUIRED: "Select the tag.",
			ERR_ANNOUNCEMENT_REQUIRED: "Enter the announcement title and text.",
			ERR_DOCUMENTTEMPLATE_INVALID_NAME: "The template name must have at least 2 characters.",
			ERR_DOCUMENTTEMPLATE_REQUIRED: "Enter the template name and content.",
			ERR_HELP_INVALID_NAME: "The title must have at least 3 characters.",
			ERR_HELP_REQUIRED: "Enter the title.",
			ERR_RATING_NAME_ALREADY_EXISTS: "A record with this name already exists.",
			ERR_PLAN_INVALID_NAME: "The plan name must have at least 2 characters.",
			ERR_PLAN_NAME_ALREADY_EXISTS: "A plan with this name already exists.",
			ERR_MP_CANCEL_FAILED: "Unable to cancel the subscription at Mercado Pago. Try again in a moment.",
			ERR_MP_PAYMENT_FAILED: "Unable to process the payment at Mercado Pago. Check the details and try again.",
			ERR_MP_PREFERENCE_FAILED: "Unable to start the payment at Mercado Pago. Try again in a moment.",
			ERR_MP_SUBSCRIPTION_FAILED: "Unable to create the subscription at Mercado Pago. Check the card details and try again.",
			ERR_MP_SUBSCRIPTION_UPDATE_FAILED: "Unable to update the subscription at Mercado Pago. Try again in a moment.",
			ERR_SUBSCRIPTION_INVALID_DATA: "Payment details are incomplete or invalid.",
			},
			toasts: {
				genericFallback: "We couldn't complete your request right now. Please try again in a moment.",
				genericUnavailable: "We're restoring the connection. Please try again in a moment.",
			},
			connectionSelectDialog: {
				title: "Select connection",
				noConnections: "No active connections available. Connect a channel to start the ticket.",
				automatic: "Automatic",
				systemDefault: "System default",
				whatsappOfficial: "Official WhatsApp",
				officialBadge: "OFFICIAL",
				email: "Email",
			},
			pagination: {
				currentPage: "Current page",
				currentPageHint: "Current page — type a number between 1 and {{total}} and press Enter",
			},
			errorBoundary: {
				title: "Oops! Something went wrong",
				message: "An unexpected error occurred. Please try again or go back to the home page.",
				goHome: "Go to Home Page",
				reload: "Reload Page",
			},
			locationPreview: {
				openInMaps: "Click to open in Google Maps",
			},
			phoneFormat: {
				notFound: "Number not found",
			},
			ticketsConference: {
				title: "Ticket Review",
				subtitle: "Closed/completed tickets",
				filters: {
					search: "Search by contact",
					queue: "Queue",
					user: "Assignee",
					campaign: "Campaign",
					allQueues: "All",
					allCampaigns: "All",
					allTags: "All",
				},
				table: {
					contact: "Contact",
					queue: "Queue",
					user: "Assignee",
					finishedAt: "Closed at",
					checked: "Reviewed",
					noQueue: "No queue",
					empty: "No closed tickets found.",
					allLoaded: "All tickets have been loaded.",
				},
				actions: {
					openChat: "Open chat",
					check: "Mark as reviewed",
					uncheck: "Unmark as reviewed",
				},
				toasts: {
					updated: "Review updated successfully.",
					openChatError: "Could not open this ticket's chat.",
				},
			},
			connectionsDiag: {
				title: "Connection Diagnostics",
				subtitle: "Overview of all WhatsApp connections in the system",
				numberValue: "Number: {{number}}",
				errors: {
					invalidPassword: "Invalid password",
					loadConnections: "Error loading connections",
					connection: "Connection error",
					sendMessage: "Error sending message",
					autoTest: "Error running the auto-test",
				},
				status: {
					connected: "CONNECTED",
				},
				login: {
					subtitle: "Enter the password to access the panel",
					password: "Password",
					submit: "Sign in",
				},
				buttons: {
					testing: "Testing...",
					autoTest: "General Auto-Test",
				},
				stats: {
					connected: "Connected",
					disconnected: "Disconnected",
				},
				table: {
					session: "Session",
					number: "Number",
					battery: "Battery",
					updatedAt: "Updated",
					action: "Action",
					default: "Default",
				},
				session: {
					active: "Active",
					inactive: "Inactive",
				},
				tooltips: {
					sendTest: "Send test message",
					notConnected: "Connection is not connected",
				},
				autoTest: {
					title: "Auto-Test of All Connections",
					description: "Sends a test message through each connected connection and generates a report",
					numberLabel: "Destination number for all tests",
					numberHelper: "All connections will send a message to this number",
					running: "Running auto-test...",
					runningHint: "Sending a test message through each connection. This may take a few minutes.",
					report: "Auto-Test Report",
					totalDuration: "Total duration: {{duration}}",
					summary: {
						total: "Total: {{value}}",
						success: "Success: {{value}}",
						errors: "Errors: {{value}}",
						skipped: "Skipped: {{value}}",
						tested: "Tested: {{value}}",
					},
					details: "Details by connection:",
					start: "Start Auto-Test",
					again: "Test Again",
				},
				testDialog: {
					title: "Send Test Message",
					connection: "Connection",
					number: "Destination number",
					numberHelper: "Number with country code (e.g. 5542998232794)",
					message: "Message (optional)",
					messageHelper: "Leave blank to use the default test message",
					messagePlaceholder: "Custom message...",
					sending: "Sending...",
					send: "Send Test",
				},
			},
			profiles: {
				deleteAlert: "Delete profile: {{name}}",
				buttons: {
					add: "Add Profile",
				},
				toasts: {
					deleted: "Profile deleted successfully!",
					deleteError: "Error deleting profile",
				},
				confirmDelete: {
					title: "Confirm deletion",
					message: "Are you sure you want to delete the profile \"{{name}}\"?",
				},
				validation: {
					required: "Required field",
				},
				modal: {
					addTitle: "New Profile",
					editTitle: "Edit Profile",
					searchPlaceholder: "Search menu or filter",
					name: "Profile Name",
					nothingFound: "No menu or filter found for \"{{term}}\".",
					allowedMenus: "Allowed Menus",
					selectAll: "Select all",
					kanbanBoards: "Allowed Kanban Flows",
					ownCardsOnly: "Kanban: show only cards created by the user",
					boardFallback: "Board #{{id}}",
					permissions: {
						view: "View",
						create: "Create",
						edit: "Edit",
						delete: "Delete",
					},
					ticketFilters: "Ticket Filters",
					create: "Create",
				},
				menus: {
					dashboard: "Dashboard",
					ticketRatings: "Service Ratings",
					tickets: "Tickets",
					ticketsFullHistory: "Tickets - View the contact's full history",
					ticketsCall: "Tickets - Make and answer calls",
					pendingMessages: "Pending Messages",
					ticketsConference: "Ticket Conference",
					messagesReport: "Messages Report",
					monitoring: "Monitoring",
					internalChat: "Internal Chat",
					flows: "Flows",
					kanbanEditComments: "Kanban - Edit Comments",
					kanbanCardInactivityTime: "Kanban - Configure Card Inactivity Time",
					quickMessages: "Quick Replies",
					documentTemplates: "Document Templates",
					contacts: "Contacts",
					usageReport: "Usage Report",
					customers: "Customers",
					agenda: "Agenda",
					schedules: "Schedules",
					tags: "Tags",
					tagPhrases: "Tag Phrases",
					forbiddenWordsRegister: "Forbidden Terms - Register",
					forbiddenWordsReport: "Forbidden Terms - Report",
					development: "Development",
					campaigns: "Campaigns",
					campaignsList: "Campaigns List",
					campaignsContactLists: "Campaigns - Contact Lists",
					campaignsSettings: "Campaigns - Settings",
					announcements: "Announcements",
					openai: "Open.ai",
					integrations: "Integrations",
					connectionsView: "Connections - View only",
					connectionsManage: "Connections - Manage (add, QR Code, edit and delete)",
					messageTemplates: "Message Templates",
					catalog: "Product Catalog",
					files: "File List",
					queues: "Queues & Chatbot",
					users: "Users",
					api: "API",
					billing: "Billing",
					profiles: "User Profiles",
					settings: "Settings",
					tasks: "Tasks",
					orders: "Orders",
					help: "Help",
				},
				filters: {
					showAll: "Filter: All (see all tickets)",
					queues: "Filter: Queues",
					whatsapps: "Filter: WhatsApps",
					followupUser: "Filter: User (Follow-up)",
				},
			},
			queueOptions: {
				title: "Options",
				optionTitlePlaceholder: "Option title",
				optionMessagePlaceholder: "Enter the option text",
				untitled: "Untitled",
			},
			facebookSdk: {
				errors: {
					loadFailed: "Failed to load the Facebook SDK",
					noAuthCode: "Facebook did not return an authorization code. Check that the app is configured for 'response_type=code'.",
					loginCancelled: "Login canceled or not authorized by the user.",
					startFailed: "Error starting Facebook Login",
				},
			},
			clienteQuickCreateModal: {
				title: "New Client",
				subtitle: "Quick registration — fill in the main details.",
				personTypes: {
					company: "Legal entity",
					individual: "Individual",
				},
				fields: {
					legalName: "Legal name",
					nickname: "Nickname",
					areaCode: "Area code",
				},
				sections: {
					contact: "Contact",
					address: "Address",
					commercial: "Sales",
					customFields: "Custom Fields",
				},
				buttons: {
					create: "Create Client",
				},
				toasts: {
					nameRequired: "Enter the client's name.",
					personTypeRequired: "Select the person type.",
					missingFields: "Fill in the required fields: {{fields}}",
					missingCustomFields: "Fill in the required custom fields: {{fields}}",
					created: "Client created successfully!",
					networkUnstable: "Couldn't save the client right now (unstable connection). Please try again in a moment.",
				},
			},
			clienteCustomFieldsForm: {
				selectPlaceholder: "Select...",
			},
			forbiddenWords: {
				title: "Forbidden terms",
				searchPlaceholder: "Search",
				table: {
					term: "Term",
					replacement: "Replacement",
				},
				confirmationModal: {
					deleteTitle: "Remove term",
					deleteMessage: "Are you sure you want to remove this term?",
				},
				toasts: {
					deleted: "Term removed successfully.",
				},
				modal: {
					title: {
						add: "Add term",
						edit: "Edit term",
					},
					form: {
						term: "Term / word",
						replacement: "Suggested replacement (optional)",
					},
					pluralHint: "Registered words are also recognized in the plural.",
					toasts: {
						saved: "Term saved successfully.",
					},
				},
			},
			forbiddenWordsReport: {
				title: "Forbidden terms usage report",
				fields: {
					term: "Term",
					user: "Agent",
					occurrences: "Occurrences",
					ticket: "Ticket",
				},
				total: "Total occurrences in the period: {{total}}",
				byTerm: "By term",
				byUser: "By agent",
				details: "Details (latest occurrences)",
				noOccurrences: "No occurrences in the period.",
			},
			tagPhrases: {
				title: "Tag-triggering phrases",
				searchPlaceholder: "Search",
				fields: {
					phrase: "Phrase",
					tag: "Applied tag",
					match: "Match",
				},
				match: {
					exact: "Exact phrase",
					contains: "Contains the phrase",
				},
				status: {
					active: "Active",
					inactive: "Inactive",
				},
				confirmationModal: {
					deleteTitle: "Remove phrase",
					deleteMessage: "Are you sure you want to remove this phrase? Contacts already tagged keep the tag.",
				},
				toasts: {
					deleted: "Phrase removed successfully.",
				},
				modal: {
					title: {
						add: "Add phrase",
						edit: "Edit phrase",
					},
					hints: {
						exact: "The tag is applied when the customer's message is exactly this phrase, with nothing else.",
						contains: "The tag is applied when the customer's message contains this phrase, even alongside other text.",
						general: "In either mode, uppercase, lowercase and accents are ignored. The tag is added to the contact and to the conversation where the message arrived, without removing any existing tags.",
					},
					toasts: {
						saved: "Phrase saved successfully.",
					},
				},
			},
			pedidos: {
				title: "Orders",
				searchPlaceholder: "Search orders...",
				buttons: {
					new: "New Order",
				},
				empty: "No orders found",
				itemsCount: "{{count}} item",
				itemsCount_plural: "{{count}} items",
				tooltips: {
					view: "View",
					delete: "Delete",
				},
				confirmationModal: {
					deleteTitle: "Delete Order",
					deleteMessage: "Are you sure you want to delete this order? This action cannot be undone.",
				},
				toasts: {
					deleted: "Order deleted successfully",
				},
				status: {
					pendente: "Pending",
					confirmado: "Confirmed",
					em_producao: "In Production",
					enviado: "Shipped",
					entregue: "Delivered",
					cancelado: "Canceled",
				},
				modal: {
					title: {
						add: "New Order",
						edit: "Edit Order",
					},
					sections: {
						orderData: "Order Details",
						items: "Order Items",
						totals: "Totals",
					},
					fields: {
						client: "Customer",
						orderDate: "Order Date",
						deliveryDate: "Delivery Date",
						orderType: "Order Type",
						orderTypePlaceholder: "E.g.: Sale, Quote, Service",
						paymentMethod: "Payment Method",
						paymentMethodPlaceholder: "E.g.: Cash, Card, Bank slip",
						subtotal: "Subtotal",
						discount: "Discount",
						surcharge: "Surcharge (Shipping, Fees)",
						total: "Total Amount",
					},
					items: {
						code: "Code",
						quantity: "Qty",
						unit: "Unit",
						unitPrice: "Unit Price",
					},
					buttons: {
						addItem: "Add Item",
						update: "Update",
					},
					toasts: {
						minOneItem: "The order must have at least one item",
						selectClient: "Select a customer",
						addItem: "Add at least one item to the order",
						fillDescriptions: "Fill in the description of all items",
						updated: "Order updated successfully",
						created: "Order created successfully",
					},
				},
			},
			solicitacoesDesenvolvimento: {
				title: "Development",
				count: "{{count}} request",
				count_plural: "{{count}} requests",
				filters: {
					search: "Search",
					searchPlaceholder: "Contact, phone or note",
				},
				empty: "No requests found.",
				cardTitle: "#{{id}} - Ticket #{{ticketId}}",
				cardMeta: "User: {{user}} | Created on: {{date}}",
				noContact: "No contact",
				noPhone: "No phone",
				noNotes: "No note",
				toasts: {
					statusUpdated: "Status updated successfully.",
					contactNotResolved: "Could not identify or create the contact to open the chat.",
				},
				fields: {
					ticket: "Ticket",
					contact: "Contact",
					notes: "Note",
				},
				details: {
					title: "Development request details",
					loadError: "Could not load the details.",
					fullNotes: "Full note",
					createdAt: "Created on",
					finalizedAt: "Finished on",
					lastMessages: "Latest captured messages",
					noTicket: "Ticket not available to load the messages.",
					noMarkedMessages: "No messages marked in this request.",
				},
				preview: {
					title: "Review development request",
					notesPlaceholder: "Describe the request. If left blank, we'll use the automatic note.",
					lastMessages: "Last 10 messages exchanged",
					noMessages: "No messages found for this ticket.",
					sender: {
						system: "System",
						agent: "Agent",
						customer: "Customer",
					},
					media: "[media]",
					confirm: "Confirm and save",
				},
			},
			printPage: {
				noData: "No data found.",
				sheetName: "Report",
				fileName: "report",
			},
			messageReceiptsModal: {
				noParticipants: "No participants",
				statusLabel: "Message status",
				status: {
					pending: "Pending",
					read: "Read",
					delivered: "Delivered",
					sent: "Sent",
				},
				summary: {
					read: "Read",
					delivered: "Delivered",
					played: "Played",
					pending: "Pending",
				},
				tabs: {
					read: "Read ({{count}})",
					delivered: "Delivered ({{count}})",
					played: "Played ({{count}})",
				},
			},
			cloudApiWindowBanner: {
				expired: "Expired",
				windowOpen: "Window open: {{time}}",
				officialApi: "Official API",
				windowClosed: "24h window closed. Send a template to start a conversation.",
				noApprovedTemplates: "No approved templates",
			},
			contactNotes: {
				toasts: {
					added: "Note added successfully!",
					deleted: "Note deleted successfully!",
				},
				deleteModal: {
					title: "Delete Record",
					message: "Do you really want to delete this record?",
				},
			},
			contactSearchModal: {
				title: "Select Contact",
				searchLabel: "Search contact",
			},
			queueSelectDialog: {
				title: "Which queue should the ticket be opened in?",
			},
			forbiddenWordWarning: {
				title: "Watch the term you used",
				usingWord: "You are using the word",
				replaceWith: ", replace it with",
				avoid: ". Avoid using it in messages to customers.",
				replace: "Replace",
				sendAnyway: "Send anyway",
			},
			commentThread: {
				reply: "Reply",
				mediaAttached: "[media attached]",
				title: "Comment thread — @{{username}}",
				post: "Post:",
				viewOnInstagram: "view on Instagram",
				postId: "Post {{id}}",
				empty: "No comments in this thread yet.",
			},
			announcementsPopover: {
				referralText: "{{name}} made a referral for this customer",
				dateUnavailable: "Date not available",
				announcementsDivider: "ANNOUNCEMENTS",
			},
			createKanbanCardModal: {
				toasts: {
					loadBoardsError: "Error loading Kanban boards",
					selectBoardAndColumn: "Select a board and a column",
					ticketNotFound: "Ticket not found",
					requiredFieldsMissing: "Required fields not filled in: {{fields}}",
					cardCreated: "Card created successfully in the Kanban!",
				},
				followUpSource: "creating the card",
				duplicate: {
					withDetails: "A card already exists for this contact: \"{{title}}\" (#{{id}}) in {{board}} / {{column}}{{createdBy}}.",
					untitled: "untitled",
					createdBy: ", created by {{name}}",
					simple: "A card already exists for this contact.",
					blockedHint: "Choose another board or column.",
					warnHint: "Click Create Card to create it anyway.",
				},
				info: {
					ticket: "Ticket:",
					contact: "Contact:",
					number: "Number:",
					noName: "No name",
				},
				form: {
					title: "Card Title",
					description: "Card Description",
					descriptionRequired: "Required on this board",
					addDefaultDescription: "Add default description: \"{{description}}\"",
					client: "Client",
					clientPlaceholder: "Type to search for a client...",
					clientNotFound: "No clients found",
					newClient: "Create new client",
					board: "Kanban Board",
					selectBoard: "Select a board",
					column: "Column",
					selectColumn: "Select a column",
					boardFields: "Board fields",
				},
				customField: {
					required: "This field is required",
					noOptions: "No options available",
					selectAtLeastOne: "(select at least one option)",
				},
			},
			imobilizadoAutocomplete: {
				availability: "{{available}} of {{total}} available",
				noOptions: "No assets found",
				minChars: "Type at least {{min}} letters to search",
				loading: "Searching Empsis...",
			},
			followUpPrompt: {
				title: "Create a new follow-up?",
				question: "After {{source}}, do you want to create a new follow-up now?",
				confirm: "Yes, create",
				sources: {
					default: "this action",
					registerCliente: "registering the client",
				},
				popupBlocked: {
					title: "Popup blocked",
					message: "The browser blocked the follow-up dashboard. Click \"Try again\" to open the popup.",
					tryAgain: "Try again",
				},
			},
			campaignReport: {
				title: "Report for {{name}}",
				campaignFallback: "Campaign",
				statusLine: "Status: {{status}} {{delivered}} of {{total}}",
				unnamedContact: "Unnamed contact",
				currentStatus: "Current status: {{status}}.",
				cards: {
					targetContacts: "Target contacts",
					confirmationRequested: "Confirmations requested",
					confirmed: "Confirmations",
					delivered: "Delivered",
					completedAt: "Completion",
				},
				sendStatuses: {
					success: "Success",
					error: "Error",
					waiting: "Waiting",
				},
				table: {
					title: "Sending details per contact",
					ariaLabel: "campaign sending details",
					contact: "Contact",
					number: "Number",
					sendStatus: "Sending status",
					statusDescription: "Status description",
					empty: "No sending records found for this campaign.",
				},
			},
			messagesReport: {
				title: "Messages Report",
				noUser: "No assignee",
				noQueue: "No queue",
				hint: "Filters are cumulative; under \"Contact tags\", a conversation is included if its contact has any of the selected tags. The agent is the ticket assignee at the time of the query; messages sent by another operator appear under the current assignee — when available, the signature of whoever typed the message is shown in the Agent column.",
				buttons: {
					clearFilters: "Clear filters",
					exporting: "Exporting...",
				},
				filters: {
					term: "Term (message or transcription)",
					all: "All",
					sent: "Sent",
					received: "Received",
					user: "Agent (ticket assignee)",
					typeMinChars: "Type at least {{min}} characters",
					noContacts: "No contacts found",
					contactTags: "Contact tags",
					queue: "Queue",
					whatsapp: "Connection",
					includeDeleted: "Include deleted",
				},
				totals: {
					total: "Total: {{value}}",
					received: "Received: {{value}}",
					sent: "Sent: {{value}}",
				},
				directionLabels: {
					sent: "Sent",
					received: "Received",
				},
				table: {
					dateTime: "Date/Time",
					direction: "Direction",
					contact: "Contact",
					user: "Agent",
					message: "Message",
					queueConnection: "Queue / Connection",
					inGroup: "in group:",
					typedBy: "typed by:",
					openAtMessage: "Open conversation at this message",
					empty: "No messages found for the selected filters.",
				},
				export: {
					number: "Number",
					group: "Group",
					groupAuthor: "Author (group)",
					signature: "Signature",
					queue: "Queue",
					whatsapp: "Connection",
					transcription: "Transcription",
					deleted: "Deleted",
					ticket: "Ticket",
					fileName: "messages-report-{{start}}-to-{{end}}",
					sheetName: "Messages",
				},
				pagination: {
					rowsPerPage: "Rows per page",
					displayedRows: "{{from}}-{{to}} of {{total}}",
				},
				toasts: {
					openFailed: "Could not open the conversation for this message.",
					nothingToExport: "No messages to export with the current filters.",
					exportLimited: "Export limited to 5,000 messages. Narrow the period or the filters to export the rest.",
				},
			},
			tabAlert: {
				newMessage: "New message",
				newMessages: "New messages",
			},
			templateCreditManager: {
				categories: {
					MARKETING: "Marketing",
					UTILITY: "Utility",
					AUTHENTICATION: "Authentication",
				},
				txTypes: {
					purchase: "Top-up",
					manual_adjust: "Manual adjustment",
					debit: "Debit",
					refund: "Refund",
				},
				rates: {
					title: "Prices by template category",
					fieldLabel: "{{category}} (R$ per send)",
					save: "Save prices",
					hint: "Price 0 = free sending (even for enabled companies). Set the prices before enabling billing for companies.",
				},
				companies: {
					title: "Template billing by company",
					billingEnabled: "Billing enabled",
					balance: "Balance",
					companyDisabled: "(company deactivated)",
					adjustBalance: "Adjust balance",
					statement: "Statement",
					empty: "No companies found.",
				},
				adjustDialog: {
					title: "Adjust balance — {{name}}",
					hint: "Current balance: {{balance}}. Use a negative value to remove credits.",
					amount: "Adjustment amount (R$)",
					reason: "Reason (required)",
					adjusting: "Adjusting...",
				},
				historyDialog: {
					title: "Statement — {{name}}",
					category: "Category",
					template: "Template",
					source: "Source",
					amount: "Amount",
					balanceAfter: "Balance after",
					empty: "No transactions recorded.",
				},
				toasts: {
					ratesSaved: "Prices updated.",
					balanceAdjusted: "Balance adjusted.",
				},
			},
			aiCreditManager: {
				topupStatus: {
					awaiting_payment: "Awaiting payment",
					pending: "Processing",
					credited: "Credited",
					failed: "Failed",
					cancelled: "Canceled",
					reversed: "Refunded",
					reversalPending: "Refund pending",
					reversedAmount: "refunded {{amount}}",
				},
				toasts: {
					hubSyncError: "Saved in the CRM, but iaHub was not updated (markup and balance alert remain unchanged): {{error}}",
					settingsSaved: "AI credit settings saved.",
					billingEnabled: "AI billing enabled (prepaid).",
					billingDisabled: "AI billing disabled (complimentary).",
					linkUpdated: "iaHub link updated.",
					topupCredited: "Top-up credited in iaHub.",
					topupNotAccepted: "iaHub has not accepted the top-up yet.",
				},
				confirmLinkChange: {
					defaultDetails: "The previous company in iaHub has purchased balance.",
					message: "That balance stays with the previous company (which goes back to complimentary) and future top-ups will go to the new one. Switch anyway?",
				},
				alerts: {
					notConfigured: "<strong>iaHub is not configured in this environment.</strong> Set <code>AI_HUB_BASE_URL</code> and <code>AI_HUB_RESELLER_KEY</code> in the backend .env — without them you cannot link companies or credit top-ups.",
					zeroMarkup: "<strong>Markup at 0%.</strong> Reseller {{name}} has no markup in iaHub: customers' AI usage is being charged at cost. Set the per-call markup below.",
					outOfSync: "The balance alert threshold or the reseller's notification URL in iaHub differ from this CRM. Click <strong>Save</strong> to sync.",
					hubError: "Could not reach iaHub right now: {{error}}",
				},
				settings: {
					title: "AI billing for this environment",
					titleWithReseller: "AI billing for this environment — reseller {{name}}",
					markup: "Per-call markup (%)",
					minCredit: "Minimum credit",
					maxCredit: "Maximum credit",
					lowBalanceAlert: "Alert below (R$)",
					hint: "Top-ups are 1:1: {{amount}} paid becomes {{amount}} in credit. The markup is added to the API cost on each AI call and is stored in the iaHub reseller — the customer does not see it.",
					hintWithReseller: "Top-ups are 1:1: {{amount}} paid becomes {{amount}} in credit. The markup is added to the API cost on each AI call and is stored in the iaHub reseller {{name}} — the customer does not see it.",
					noReseller: "Without a connection to iaHub, the markup cannot be read or changed.",
				},
				pending: {
					title: "Top-ups and refunds that did not reach iaHub",
					hint: "The money came in but the credit was not issued — or the payment was refunded and the credit is still there. The system retries automatically every hour; use the button to force it now.",
					status: "Status",
					credit: "Credit",
					attempts: "Attempts",
					action: "Action",
					resend: "Resend",
					resending: "Sending...",
				},
				companies: {
					title: "Companies",
					hint: "On = prepaid (the customer tops up and the AI stops when the balance hits zero). Off = complimentary (we pay; usage is measured but never blocked).",
					billing: "Billing",
					balance: "Balance",
					updatedAt: "Updated",
					prepaid: "Prepaid",
					courtesy: "Complimentary",
					agentOtherCompany: "\"{{prompts}}\" uses an agent from \"{{company}}\" — usage is deducted there",
					agentMissing: "\"{{prompts}}\" uses an agent that does not exist in this reseller",
					notLinked: "not linked",
					blocked: "blocked",
					link: "Link",
					empty: "No companies found.",
				},
				hubCompany: "Company in iaHub",
				linkDialog: {
					title: "Link {{name}} to iaHub",
					noLink: "No link",
					notConfirmed: "(not confirmed)",
					agentOwner: "owner of this company's agent",
					hint: "This company's top-ups credit the balance of the company chosen here, and the hub deducts usage from the company that owns the agent — to charge, both must be the same.",
					noAgents: "This company has no prompt with an agent from this iaHub.",
					agentOf: "\"{{prompts}}\": agent from \"{{company}}\"",
					agentOfUnknown: "\"{{prompts}}\": agent from a company not found in this reseller",
					saveLink: "Save link",
					saveAndCharge: "Save and charge",
				},
			},
			clienteCustomFieldsManager: {
				types: {
					text: "Text",
					number: "Number",
					date: "Date",
					select: "Single select",
					multiselect: "Multiple select",
					checkbox: "Checkbox",
					textarea: "Text area",
					email: "Email",
					phone: "Phone",
					cpf: "CPF",
					cnpj: "CNPJ",
					cep: "ZIP Code",
				},
				addButton: "Add Custom Field",
				table: {
					order: "Order",
					label: "Label",
					fieldName: "Field Name",
					inReport: "In Report",
				},
				dialog: {
					editTitle: "Edit Custom Field",
					newTitle: "New Custom Field",
					fieldLabel: "Field label (as it will appear on the form)",
					fieldName: "Field name (internal identifier)",
					fieldNameHelper: "It will be converted to a valid format automatically",
					fieldType: "Field Type",
					orderIndex: "Display Order",
					options: "Options (comma-separated)",
					optionsHelper: "E.g.: Option 1, Option 2, Option 3",
					defaultValue: "Default Value",
					required: "Required Field",
					includeInReport: "Include this field in the client report",
				},
				confirmDelete: "Are you sure you want to delete this field?",
				toasts: {
					loadError: "Error loading custom fields",
					nameAndLabelRequired: "Name and label are required",
					updated: "Field updated successfully",
					created: "Field created successfully",
					saveError: "Error saving custom field",
					deleted: "Field deleted successfully",
					deleteError: "Error deleting field",
				},
			},
			management: {
				restricted: "This screen is restricted to the platform administrator.",
				tabs: {
					billing: "Billing",
					usage: "System Usage",
				},
			},
			billingManager: {
				tabs: {
					companies: "By company",
					statement: "Financial statement",
				},
				all: "All",
				companyDisabled: "(company disabled)",
				notDueYet: "Not yet due",
				days: "{{count}} day",
				days_plural: "{{count}} days",
				daysOverdue: "{{count}} day overdue",
				daysOverdue_plural: "{{count}} days overdue",
				subscriptionStatus: {
					active: "Active",
					paymentFailed: "Charge failed",
					cancelled: "Canceled",
					paused: "Paused",
					pending: "Pending",
				},
				paymentStatus: {
					approved: "Received",
					pending: "Awaiting",
					rejected: "Declined",
					cancelled: "Canceled",
					refunded: "Refunded",
				},
				methods: {
					creditCard: "Card",
					other: "Other",
				},
				types: {
					oneTime: "One-time",
					recurring: "Subscription",
				},
				columns: {
					plan: "Plan",
					dueDate: "Due date",
					status: "Status",
					subscription: "Subscription",
					lastCharge: "Last charge",
					lastPayment: "Last payment",
					method: "Method",
					value: "Amount",
					balance: "Balance",
					periodBalance: "Period balance",
					mpPaymentId: "Mercado Pago ID",
					origin: "Source",
					daysOverdue: "Days overdue",
					entries: "Entries",
					cardShare: "% of total",
				},
				origin: {
					invoice: "Invoice",
					invoiceNumber: "Invoice #{{id}}",
					companyDueDate: "Company due date",
				},
				companies: {
					title: "Company billing",
					filter: "Filter",
					filters: {
						overdue: "Overdue",
						blocked: "Blocked",
						subscriptionActive: "Active subscription",
						subscriptionFailed: "Failed subscription",
					},
					showInactive: "Show inactive ({{total}})",
					perMonth: "{{value}}/mo",
					situation: {
						blocked: "Blocked",
						gracePeriod: "Grace period",
						upToDate: "Up to date",
					},
					amountDiverges: "Subscription at {{subscriptionAmount}} but the plan costs {{planAmount}} — the subscriber keeps the old amount until they resubscribe",
					lastCharge: {
						approved: "approved",
						rejected: "declined",
					},
					paymentStatus: {
						approved: "Approved",
						rejected: "Declined",
						pending: "Pending",
						cancelled: "Canceled",
						refunded: "Refunded",
					},
					empty: "No companies found for the selected filter.",
				},
				detail: {
					fileFallback: "detail",
					entries: "{{count}} entry",
					entries_plural: "{{count}} entries",
					clients: "{{count}} client",
					clients_plural: "{{count}} clients",
					empty: "No entries make up this amount.",
					byClient: "By client",
					details: "Details",
				},
				statement: {
					periods: {
						thisMonth: "This month",
						lastMonth: "Last month",
						last7: "Last 7 days",
						last30: "Last 30 days",
						thisYear: "This year",
						custom: "Custom",
					},
					cardHint: "click to see the breakdown",
					periodRange: "{{start}} to {{end}}",
					periodSubtitle: "Period: {{period}}",
					currentPositionSubtitle: "Current position — regardless of the filtered period",
					export: {
						period: "{{start}}_to_{{end}}",
						statementFile: "statement",
						receivablesFile: "receivables",
					},
					period: "Period",
					cards: {
						received: {
							title: "Received in period",
							caption: "{{total}} payment(s) — {{period}}",
						},
						awaiting: {
							title: "Awaiting payment",
							caption: "{{total}} charge(s) issued and not paid",
						},
						pending: {
							title: "Not yet due (receivable)",
							caption: "{{total}} open invoice(s) — current position",
						},
						overdue: {
							title: "Overdue",
							caption: "{{total}} overdue charge(s) — current position",
						},
					},
					failedSummary: "{{total}} declined attempt(s) in the period, totaling {{amount}}.",
					failedTitle: "Declined attempts",
					viewWhich: "See which",
					tabs: {
						statement: "Period statement",
						pending: "Not yet due ({{total}})",
						overdue: "Overdue ({{total}})",
					},
					statusFilter: {
						approved: "Received only",
						all: "All transactions",
						pending: "Awaiting",
						rejected: "Declined",
						refunded: "Refunded",
					},
					order: "Order",
					orderOptions: {
						asc: "Oldest first",
						desc: "Newest first",
					},
					totalShown: "Total shown ({{count}} entry)",
					totalShown_plural: "Total shown ({{count}} entries)",
					noTransactions: "No transactions in the selected period.",
					dueFilter: {
						all: "All (current position)",
						period: "Only those due in the period",
					},
					estimatedValue: "amount estimated from the plan composition",
					totalCharges: "Total ({{count}} charge)",
					totalCharges_plural: "Total ({{count}} charges)",
					nothingOverdue: "Nothing overdue for the selected filter.",
					nothingPending: "Nothing coming due for the selected filter.",
				},
			},
			clientUsageManager: {
				health: {
					ativo: "Active",
					atencao: "Warning",
					inativo: "Inactive",
				},
				periods: {
					last7: "Last 7 days",
					last30: "Last 30 days",
					last90: "Last 90 days",
					custom: "Custom",
				},
				situations: {
					todos: "All statuses",
					ativo: "Active",
					atencao: "Warning",
					inativo: "Inactive",
				},
				idle: {
					never: "never used",
					today: "today",
				},
				dueDate: {
					none: "no due date",
					due: "due {{date}}",
				},
				search: "Search client",
				volumePeriod: "Volume period",
				situation: "Status",
				showDisabled: "Show deactivated ({{total}})",
				clearFilters: "Clear filters",
				legend: "Status: green up to 2 days idle, yellow from 3 to 7, red above 7 — based on the most recent activity between messages and login. In \"tickets\", the pair is opened/closed in the period.",
				columns: {
					client: "Client",
					lastMessage: "Last message",
					lastLogin: "Last login",
					connections: "Connections",
					users: "Users",
					volume: "Volume in period",
					plan: "Plan",
				},
				companyDisabled: "company deactivated",
				since: "since {{date}}",
				contacts: "{{total}} contacts",
				sentAt: "{{date}} sent",
				receivedAt: "{{date}} rcvd",
				loginEstimated: "Estimated: this user hasn't logged in since login tracking was introduced.",
				noUser: "no user",
				connectionsCaption: "limit {{limit}} · {{drops}} drops",
				noConnection: "no connection",
				usersCaption: "{{active}} active 30d · {{online}} on",
				volumeLine: "{{sent}} sent · {{received}} rcvd",
				ticketsCaption: "tickets {{created}}/{{finished}} · {{active}} open",
				noPlan: "no plan",
				empty: "No clients found for the selected filter.",
			},
			financeiro: {
				paymentStatus: {
					approved: "Approved",
					pending: "Pending",
					rejected: "Declined",
					cancelled: "Canceled",
					refunded: "Refunded",
				},
				invoiceStatus: {
					paid: "Paid",
					overdue: "Overdue",
					open: "Open",
				},
				toasts: {
					chargeFailed: "Your subscription charge failed: {{reason}}",
					subscriptionCancelled: "Subscription canceled. Your license remains valid until the current due date.",
				},
				license: {
					unavailable: "License status unavailable",
					noExpiration: "License active, no expiration",
					overdue: "License expired {{count}} day ago",
					overdue_plural: "License expired {{count}} days ago",
					overdueDetail: "Expired on {{date}}. Pay the monthly fee to keep using the system.",
					dueToday: "License expires today",
					dueDate: "Due date: {{date}}",
					dueIn: "License expires in {{count}} day",
					dueIn_plural: "License expires in {{count}} days",
					upToDate: "License up to date",
					validUntil: "Valid until {{date}}",
				},
				cancelModal: {
					title: "Cancel automatic subscription?",
					message: "The automatic monthly charge to your card will be canceled. Your license remains valid until the current due date, and you can make one-time payments (Pix or card) whenever you want.",
				},
				plan: "Plan",
				planNamed: "Plan {{name}}",
				perMonth: "{{value}}/month",
				autoRenewActive: "Automatic renewal active",
				monthlyCardDebit: "Monthly charge to your card.",
				monthlyCardDebitEmail: "Monthly charge to your card ({{email}}).",
				cancelRenewal: "Cancel renewal",
				lastChargeDeclined: "The last card charge was declined and the license was not renewed. Pay the monthly fee below (Pix or card).",
				regularizeNow: "Settle now",
				payMonthlyFee: "Pay monthly fee",
				pixOrCard: "Pix or credit card",
				preferAutoRenew: "I'd rather turn on automatic renewal on my card →",
				nothingToDo: "Nothing to do — your license renews automatically every month.",
				managePlan: "Manage plan — additional users and connections, plan change",
				changePlan: "Change plan",
				invoicesAndHistory: "Invoices and payment history",
				invoicesAndHistoryOpen: "Invoices and payment history ({{count}} open)",
				invoices: "Invoices",
				table: {
					details: "Details",
					value: "Amount",
					dueDate: "Due date",
					action: "Action",
					method: "Method",
				},
				pay: "PAY",
				paid: "PAID",
				loadMoreInvoices: "Load more invoices",
				paymentHistory: "Payment history",
				noPayments: "No payments recorded yet.",
				paymentType: {
					recurring: "Subscription",
					oneTime: "One-time",
				},
				paymentMethod: {
					creditCard: "Credit card",
				},
			},
			subscription: {
				title: "Subscription",
				licenseValidity: "License validity",
				validUntil: "Your license is valid until {{date}}",
				noExpiration: "No expiration date set",
				billingEmail: "Billing email",
				subscribeNow: "Subscribe now!",
			},
			checkout: {
				statusDetail: {
					insufficientAmount: "Card has no available credit.",
					badCardNumber: "Invalid card number.",
					badDate: "Invalid expiration date.",
					badSecurityCode: "Invalid security code.",
					badOther: "Invalid card details.",
					callForAuthorize: "The bank requested authorization — call your card issuer.",
					cardDisabled: "Card disabled — contact your card issuer.",
					duplicatedPayment: "Duplicate payment detected.",
					highRisk: "Payment declined by fraud screening.",
					maxAttempts: "Attempt limit reached — try again later.",
					otherReason: "Payment declined by the card issuer.",
					default: "Payment declined. Check your details or try another card.",
				},
				brickErrors: {
					cardNumberEmpty: "Enter the card number.",
					cardNumberIncomplete: "Incomplete card number.",
					cardNumberInvalid: "Invalid card — check the number you entered.",
					expirationDateEmpty: "Enter the card's expiration date.",
					expirationDateIncomplete: "Incomplete expiration date.",
					expirationDateInvalid: "Invalid expiration date.",
					securityCodeEmpty: "Enter the security code.",
					securityCodeIncomplete: "Incomplete security code.",
					securityCodeInvalid: "Invalid security code.",
					cardholderNameEmpty: "Enter the cardholder's name as it appears on the card.",
					emailEmpty: "Enter the email.",
					emailInvalid: "Invalid email.",
					identificationNumberEmpty: "Enter the cardholder's CPF/CNPJ.",
					identificationNumberInvalid: "Invalid CPF/CNPJ.",
					identificationTypeEmpty: "Select the document type.",
					paymentMethodNotFound: "We don't recognize this card's brand.",
					installmentsEmpty: "Select the number of installments.",
					critical: "We couldn't process the payment form. Reload the page and try again.",
					generic: "Invalid card details. Check the information and try again.",
				},
				title: {
					templateCredit: "Buy template credits",
					aiCredit: "Buy AI credits",
					addon: "Pay plan add-ons",
					renewal: "Renew license",
				},
				hint: {
					templateCredit: "Pix or credit card — the credits are added to your balance as soon as the payment is approved",
					aiCredit: "Pix or credit card — the AI credits are added to your balance as soon as the payment is approved",
					addon: "Pix or credit card — unlocks the purchased add-ons until the end of the cycle",
					renewal: "Pix or credit card — renews your license for 1 month",
				},
				toasts: {
					approvedTemplateCredit: "Payment approved! Your template credits have been added.",
					approvedAiCredit: "Payment approved! Your AI credits have been added.",
					approvedAddon: "Payment approved! Your add-ons have been unlocked.",
					approvedRenewal: "Payment approved! Your license has been renewed.",
					processing: "Payment is being processed. You'll be notified once it's confirmed.",
					subscriptionActivated: "Subscription activated! Your card will be charged automatically every month to renew.",
				},
				pixUnavailableSupport: "Pix payments are unavailable right now. Contact support to settle your monthly fee.",
				pixUnavailableCard: "Pix payments are unavailable right now. Complete the payment with a credit card using the form below.",
				brickBlocked: "Your browser blocked the Mercado Pago card form (ad blocker or tracking protection). Disable the extension for this page and reload to pay by card.",
				unavailableTitle: "Payment unavailable",
				missingPublicKey: "The Mercado Pago public key (REACT_APP_MP_PUBLIC_KEY) is not configured. Contact support.",
				tabs: {
					payInvoice: "Pay invoice",
					autoSubscription: "Automatic subscription",
				},
				invoiceError: "We couldn't generate the renewal invoice for this company. Check the subscribed plan or contact support.",
				noOpenInvoice: "No open invoices to pay.",
				invoiceDue: "{{detail}} — due {{date}}",
				payWithPix: "Pay with Pix (QR code)",
				subscriptionActiveChip: "Subscription active",
				subscriptionAlreadyActive: "Your subscription is already active on your card. It renews automatically every month. To change cards, cancel the subscription on the Billing page and subscribe again.",
				subscriptionAlreadyActiveEmail: "Your subscription is already active on your card ({{email}}). It renews automatically every month. To change cards, cancel the subscription on the Billing page and subscribe again.",
				autoDebit: "Automatic monthly charge to your credit card",
				autoDebitPlan: "Automatic monthly charge to your credit card — {{plan}} plan",
				perMonth: "{{value}}/month",
				autoRenewInfo: "Once Mercado Pago confirms the charge, your license renews automatically. Cancel anytime.",
				payPixMeanwhile: "Meanwhile, you can pay this month's invoice with Pix in the \"{{tab}}\" tab.",
				noPlanValue: "Company has no plan with a set price — contact support.",
				success: {
					licenseRenewed: "Your license has been renewed until {{date}}!",
					qrAlt: "Pix QR code",
					copied: "Copied",
					copyPixCode: "Copy Pix code",
					instructions: "To finish, just make the payment by scanning or pasting the Pix code above :)",
				},
			},
			changePlanDialog: {
				changed: "Plan changed to {{plan}}. The new price applies starting with the next renewal.",
				title: "Change plan",
				currentPlan: "Current plan:",
				perMonth: "{{value}}/month",
				newPlan: "New plan",
				planOption: "{{name}} — {{value}}/month ({{users}} users, {{connections}} connections)",
				newValueNote: "The period already paid continues until the current due date. Starting with the next renewal, the price will be",
				autoDebitUpdate: "The automatic charge to your card will be updated to the new price — no need to re-register your card.",
				confirm: "Confirm change",
			},
			planAddons: {
				changeStatus: {
					pendingPayment: "Awaiting prorated payment",
					applying: "Applying...",
					scheduled: "Reduction scheduled for the next cycle",
					requiresNewCard: "Awaiting card re-registration",
				},
				toasts: {
					addonsApplied: "Add-ons purchased and unlocked!",
					payProrata: "Pay the prorated amount to unlock the add-ons. Opening payment...",
					downgradeScheduled: "Reduction scheduled: the current price and limits apply until the end of the cycle.",
					requestCancelled: "Pending change canceled.",
					subscriptionMigrated: "Subscription migrated successfully! Pending changes have been applied.",
				},
				unitPrice: "({{value}}/month each)",
				title: "My plan",
				planChip: "{{description}} — {{value}}/month",
				limits: "Limits: {{users}} user(s) ({{usersInUse}} in use) · {{connections}} connection(s) ({{connectionsInUse}} in use)",
				extraUsers: "Additional user(s)",
				extraConnections: "Additional connection(s)",
				pending: {
					users: "{{count}} user",
					users_plural: "{{count}} users",
					connections: "{{count}} connection",
					connections_plural: "{{count}} connections",
					usersAndConnections: "{{users}} and {{connections}}",
					upgrade: "Addition of {{items}}",
					downgrade: "Reduction of {{items}}",
					newMonthlyFee: "new monthly fee {{value}}",
					effectiveFrom: "starting {{date}}",
					prorata: "(prorated: {{value}})",
				},
				payProrata: "Pay prorated amount",
				replaceCard: "Re-register card",
				simulation: {
					newMonthlyFee: "New monthly fee:",
					prorataNow: "To unlock now, pay the prorated amount for the {{count}} remaining day of the cycle:",
					prorataNow_plural: "To unlock now, pay the prorated amount for the {{count}} remaining days of the cycle:",
					noChargeNow: "No charge now — the add-ons are unlocked immediately and the new price applies at the next renewal.",
					hireAndPay: "Purchase and pay {{value}}",
					hireAddons: "Purchase add-ons",
					newMonthlyNextCycle: "New monthly fee starting next cycle:",
					noRefund: "(no refund for the current period)",
					usageWarning: "Warning: the new limit is below current usage — nothing will be deleted, but creating new items will be blocked.",
					scheduleReduction: "Schedule reduction",
				},
				undo: "Undo",
				replaceDialog: {
					title: "Re-register subscription card",
					description: "Your current subscription was created under Mercado Pago's legacy model and its amount cannot be changed. Register your card so we can create the new {{value}}/month subscription — the old one is canceled automatically, with no duplicate charge.",
				},
			},
			templateCredit: {
				categories: {
					marketing: "Marketing",
					utility: "Utility",
					authentication: "Authentication",
				},
				txTypes: {
					purchase: "Top-up",
					manualAdjust: "Adjustment",
					debit: "Debit",
					refund: "Refund",
				},
				title: "Template credits (Official API)",
				ratesIntro: "Each template sent deducts its category's price:",
				ratesUndefined: "prices not set yet",
				otherValue: "Other amount",
				generating: "Generating...",
				buy: "Buy credits",
				showStatement: "View statement",
				hideStatement: "Hide statement",
				table: {
					template: "Template",
					value: "Amount",
					balanceAfter: "Balance after",
				},
				noMovements: "No transactions recorded.",
			},
			aiCredit: {
				topupStatus: {
					awaitingPayment: "Awaiting payment",
					pending: "Processing",
					credited: "Credited",
					failed: "Under review",
					cancelled: "Canceled",
					reversed: "Refunded",
					withReversal: "{{label}} ({{value}} refunded)",
				},
				title: "AI credits",
				monthUsage: "{{calls}} AI interactions this month · {{value}} used",
				consumptionInfo: "The balance is used up as the AI agent is used.",
				stale: "(balance from the last sync)",
				blockedTitle: "AI paused due to insufficient balance.",
				blockedHint: "Top up so the agent starts replying again.",
				lowBalance: "Low balance. When it runs out, the AI agent stops replying.",
				otherCreditValue: "Other credit amount",
				generating: "Generating...",
				buy: "Buy credits",
				showUsage: "View usage",
				hideUsage: "Hide usage",
				usageByDay: "Usage per day",
				table: {
					day: "Day",
					interactions: "Interactions",
					consumption: "Usage",
					status: "Status",
					credit: "Credit",
					paid: "Paid",
				},
				noUsage: "No usage in this period.",
				topups: "Top-ups",
				noTopups: "No top-ups recorded.",
			},
			attendanceMonitor: {
				title: "Service Monitoring",
				subtitle: "Median wait and service times: current month to date",
				alarmsOn: "Alarms: ON ({{minutes}} min)",
				alarmsOff: "Alarms: OFF",
				autoRefreshOn: "Auto-refresh: ON",
				autoRefreshOff: "Auto-refresh: OFF",
				toasts: {
					loadError: "Error loading monitoring data",
					alarmsEnabled: "Alarms enabled",
					alarmsDisabled: "Alarms disabled",
					alarmsUpdateError: "Error updating alarm status",
					openTicketError: "Error opening conversation",
				},
				summary: {
					queues: "Queues",
					waiting: "Waiting",
					attendants: "Agents",
					online: "Online",
					offline: "Offline",
					inService: "In Progress",
					medianWait: "Median Wait Time",
					medianService: "Median Service Time",
				},
				tabs: {
					inService: "In progress",
					waiting: "Waiting",
					all: "All",
					online: "Online",
					offline: "Offline",
				},
				search: {
					attendantOrQueue: "Search agent or queue",
					queue: "Search queue",
					attendant: "Search agent",
				},
				alarmTickets: "Tickets in alarm ({{total}})",
				sections: {
					queues: "Queues",
					attendants: "Agents",
				},
				queueBadge: "Queue",
				emptyQueue: "No open tickets in this queue.",
				emptyAttendant: "No open tickets for this agent.",
				waitingTooltip: "Time waiting for a reply",
				queueTotal: "Total tickets in queue:",
				attendantTotal: "Total open tickets:",
				noQueues: "No queues found",
				noAttendants: "No agents found",
				status: {
					online: "Online",
					offline: "Offline",
				},
			},
			usageReport: {
				title: "System Usage Report",
				tabs: {
					general: "General",
					forwarding: "Forwarding",
				},
				filters: {
					profile: "Profile",
					user: "User",
					senderUser: "Source User",
					receiverUser: "Destination User",
					historyType: "History Type",
				},
				profiles: {
					admin: "Administrator",
				},
				buttons: {
					printGeneral: "Print General",
					printDetailed: "Print Detailed",
					printForwarding: "Print Forwarding",
				},
				periodLabel: "Period: {{period}}",
				periodRange: "{{from}} to {{to}}",
				invalidPeriod: "Invalid period",
				generatedAt: "Generated on: {{date}}",
				toasts: {
					invalidDates: "Enter valid dates in the correct format",
					dateRange: "The start date cannot be later than the end date",
					detailsError: "Error loading relationship details",
					usersError: "Error loading user list",
					reportError: "Error loading system usage report",
					forwardingError: "Error loading forwarding report",
					detailedPrintError: "Error generating detailed printout",
				},
				columns: {
					user: "User",
					registrations: "Registrations",
					totalContacts: "Total Contacts",
					orders: "Orders",
				},
				clickForDetails: "Click to see {{type}} details",
				chart: {
					contactsByUserType: "Contacts by User — {{type}}",
					totalContactsByUser: "Total Contacts by User",
				},
				emptyGeneral: "Select a period and click Filter to generate the report",
				emptyForwarding: "Select a period and click Filter to generate the forwarding report",
				files: {
					generalExcel: "usage-report-general-{{from}}-{{to}}",
					generalSheet: "General Report",
					forwardingExcel: "forwarding-report-{{from}}-{{to}}",
					generalPrint: "Usage_Report_General_{{from}}_{{to}}",
					detailedPrint: "Usage_Report_Detailed_{{from}}_{{to}}",
					forwardingPrint: "Forwarding_Report_{{from}}_{{to}}",
				},
				forwarding: {
					reportTitle: "Forwarding Report",
					types: {
						move: "Move",
						copy: "Copy",
						create: "Creation",
					},
					createdTitle: "Card Creation",
					createdEmpty: "No cards created in this period.",
					cardsCreated: "Cards Created",
					forwardedTitle: "Cards Forwarded to Other Users",
					forwardedEmpty: "No cards forwarded to another user in this period.",
					origin: "Source",
					destination: "Destination",
					quantity: "Quantity",
					totalAllDestinations: "Total (all destinations)",
					rowsPerPage: "Destinations per page",
					displayedRows: "{{from}}-{{to}} of {{total}} destinations",
				},
				print: {
					noData: "No data available to print.",
					generalTitle: "Usage Report - General",
					detailedTitle: "Usage Report - Detailed by User",
					totalRecords: "Total records: {{total}}",
					noRecordsForFilters: "No records found for the selected filters.",
					noTypeSummary: "No interactions by type",
					unknownUser: "Unidentified user",
				},
				details: {
					contactDate: "Contact Date",
					client: "Customer",
					contactMethod: "Contact Method",
					contactMethodFull: "Contact Method",
					result: "Result",
					nextAction: "Next Action",
					nextActionDate: "Next Action Date",
					reasons: "Reasons",
				},
				reasons: {
					followUp: "Follow Up",
					meetings: "Meetings",
					calls: "Calls",
					visits: "Visits",
					emails: "Emails",
					quotes: "Quotes",
					negotiations: "Negotiations",
					closings: "Closings",
					afterSales: "After Sales",
					complaints: "Complaints",
					referrals: "Referrals",
					others: "Other",
				},
				modal: {
					title: "Details - {{user}} - {{type}}",
					totalRecords: "Total records:",
					emptyText: "There is no data available for the selected period.",
					printSubtitle: "Period: {{period}} | Total: {{total}} | Printed on: {{date}}",
				},
			},
		},
	},
};

export { messages };
